/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date custom scalar type */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string; }
  /** A field whose value is a valid Decimal which safely allows mathematical operations on numbers */
  Decimal: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** Plain date custom scalar type */
  PlainDate: { input: string; output: string; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AiAssistantResponse = {
  __typename?: 'AIAssistantResponse';
  /** Result payload based on response type */
  result?: Maybe<AssistantResultUnion>;
  /** Type of the assistant response */
  type: AssistantResponseEnum;
};

export enum AumFeeStatus {
  Collected = 'Collected',
  Pending = 'Pending'
}

/** Unified payment action item that can represent both legacy BenefitPayment and new Payment entities */
export type ActionItemPayment = {
  __typename?: 'ActionItemPayment';
  /** Total payment amount */
  amount: Scalars['Decimal']['output'];
  /** Associated benefit/product name */
  benefitName?: Maybe<Scalars['String']['output']>;
  /** Payment creation date */
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
};

export type ActionItems = {
  __typename?: 'ActionItems';
  /** Active employees count for current month */
  activeEmployeesCount: Scalars['Float']['output'];
  /** Total salary for current month */
  adjustedSalary: Scalars['Decimal']['output'];
  /** Company tranding bank account */
  companyTrandingBankAccount?: Maybe<CrmTradingBankAccount>;
  /** Pending payments */
  pendingPayments: Array<ActionItemPayment>;
  /** Pending product assignment subscription change requests */
  productAssignmentSubscriptionRequests: Array<CrmProductAssignmentSubscriptionRequestEntity>;
  /** Rejected/cancelled payments */
  rejectedPayments: Array<ActionItemPayment>;
  /** Total uninvited employees since inception */
  uninvitedEmployees: Scalars['Float']['output'];
};

export type Adjustment = {
  __typename?: 'Adjustment';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  createdByUser: User;
  id: Scalars['ID']['output'];
  reasonText?: Maybe<Scalars['String']['output']>;
  reasonType: AdjustmentReasonType;
  updatedAt: Scalars['DateTime']['output'];
};

export type AdjustmentReasonInput = {
  reasonText?: InputMaybe<Scalars['String']['input']>;
  reasonType: AdjustmentReasonType;
};

export enum AdjustmentReasonType {
  CreditFee = 'CreditFee',
  DebitFee = 'DebitFee',
  Other = 'Other',
  Overpayment = 'Overpayment',
  Underpayment = 'Underpayment'
}

/** Event log for admin dashboard */
export type AdminEventLog = {
  __typename?: 'AdminEventLog';
  /** ID of the related company object, if applicable */
  companyObjectId?: Maybe<Scalars['String']['output']>;
  /** Type of the related company object, if applicable */
  companyObjectType?: Maybe<Scalars['String']['output']>;
  /** Main content or message of the event log */
  content: Scalars['String']['output'];
  /** Timestamp when the event was created */
  createdAt: Scalars['DateTime']['output'];
  /** Type of the event (e.g. creation, update, deletion) */
  eventType: EventType;
  /** Unique identifier for the event log entry */
  id: Scalars['ID']['output'];
  /** List of metadata items associated with the event */
  metadataItems: Array<EventMetadataItem>;
};

export type AdminEventLogFiltersInput = {
  /** Filter events created at or after this date */
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter events created at or before this date */
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by event types */
  eventTypes?: InputMaybe<Array<EventType>>;
  /** Search term to filter events by eventData JSON content */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AdminEventLogList = {
  __typename?: 'AdminEventLogList';
  count: Scalars['Int']['output'];
  list: Array<AdminEventLog>;
};

/** Columns by which AdminEventLogList can be ordered */
export enum AdminEventLogOrderByColumn {
  CreatedAt = 'CreatedAt',
  EventType = 'EventType'
}

export type AdminEventLogOrderByInput = {
  /** Column name */
  column?: AdminEventLogOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

export type AggregatedAumFee = {
  __typename?: 'AggregatedAUMFee';
  status: AumFeeStatus;
  units: Scalars['Decimal']['output'];
};

export type AllInvitationsItem = {
  __typename?: 'AllInvitationsItem';
  company?: Maybe<CrmCompany>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inviterUser: User;
  isEmployee: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  roles: Array<Role>;
};

export type AllInvitationsList = {
  __typename?: 'AllInvitationsList';
  count: Scalars['Int']['output'];
  list: Array<AllInvitationsItem>;
};

/** Language configuration per web application with translation item relationships */
export type AppLanguage = {
  __typename?: 'AppLanguage';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  items: Array<Translation>;
  language: SupportedLanguages;
  updatedAt: Scalars['DateTime']['output'];
  webApp: WebApps;
};

export type AssignEmployeesToProductInput = {
  /** Whether to add or remove assignments */
  action: ProductAssignmentAction;
  /** If true, assigns all unassigned employees to this product instance */
  assignAllEmployees?: Scalars['Boolean']['input'];
  /** List of employee IDs to assign. Ignored if assignAllEmployees is true. */
  employeeIds?: Array<Scalars['String']['input']>;
  /** ID of the product instance */
  productInstanceId: Scalars['String']['input'];
};

export type AssignEmployeesToProductResult = {
  __typename?: 'AssignEmployeesToProductResult';
  assignedCount: Scalars['Float']['output'];
  invalidEmployees: Array<InvalidEmployeeError>;
  /** Status when async: 'completed' or 'processing' */
  status?: Maybe<Scalars['String']['output']>;
  /** Workflow ID when processing asynchronously (for polling status) */
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type AssignEmployeesToProductStatusResult = {
  __typename?: 'AssignEmployeesToProductStatusResult';
  assignedCount?: Maybe<Scalars['Float']['output']>;
  invalidEmployees?: Maybe<Array<InvalidEmployeeError>>;
  /** Workflow status: RUNNING, COMPLETED, FAILED, etc. */
  status: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

export type AssistantMessageMetadata = {
  __typename?: 'AssistantMessageMetadata';
  /** ID of the original user message being responded to */
  originalMessageId: Scalars['String']['output'];
  /** AI assistant response result and metadata */
  result: AiAssistantResponse;
};

/** Assistant mode selection - GENERAL for chat only, AUREM_AGENT for database operations */
export enum AssistantModeEnum {
  AuremAgent = 'AUREM_AGENT',
  General = 'GENERAL'
}

/** Types of responses from the AI assistant */
export enum AssistantResponseEnum {
  Chat = 'CHAT',
  Export = 'EXPORT',
  Query = 'QUERY'
}

export type AssistantResultUnion = ChatResult | DatabaseExportResult | DatabaseQueryResult;

export type Attachment = {
  __typename?: 'Attachment';
  createdAt: Scalars['DateTime']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** Attributes corrections */
export type AttributesCorrections = {
  __typename?: 'AttributesCorrections';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  attribute: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  newValue: Scalars['String']['output'];
  oldValue?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  requestId: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resourceId: Scalars['String']['output'];
  resourceType: AttributesCorrectionsResourceType;
  updatedAt: Scalars['DateTime']['output'];
};

export type AttributesCorrectionsList = {
  __typename?: 'AttributesCorrectionsList';
  count: Scalars['Int']['output'];
  list: Array<AttributesCorrections>;
};

/** Columns by which AttributesCorrectionsList can be ordered */
export enum AttributesCorrectionsListOrderByColumn {
  Attribute = 'Attribute',
  CreatedAt = 'CreatedAt',
  Id = 'Id',
  UpdatedAt = 'UpdatedAt'
}

export type AttributesCorrectionsListOrderByInput = {
  /** Column name */
  column?: AttributesCorrectionsListOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

/** Parent entity grouping a batch of attributes correction submissions */
export type AttributesCorrectionsRequest = {
  __typename?: 'AttributesCorrectionsRequest';
  corrections: Array<AttributesCorrections>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  requestedBy: User;
  requestedById: Scalars['String']['output'];
  status: AttributesCorrectionsRequestStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** Status of an attributes corrections request */
export enum AttributesCorrectionsRequestStatus {
  Finished = 'Finished',
  Pending = 'Pending'
}

/** Type of resource a fields correction is associated with */
export enum AttributesCorrectionsResourceType {
  Employee = 'Employee'
}

/** Audit trail tracking resource changes (inserts, updates, removes) */
export type AuditTrail = {
  __typename?: 'AuditTrail';
  /** Timestamp when the event was created */
  createdAt: Scalars['DateTime']['output'];
  diff?: Maybe<Scalars['JSON']['output']>;
  /** Type of event that occurred */
  event: AuditTrailEvent;
  /** Unique identifier of the audit trail */
  id: Scalars['ID']['output'];
  /** Object snapshot at the time of the event */
  object: Scalars['JSON']['output'];
  /** ID of the resource that was changed */
  resourceId: Scalars['String']['output'];
  /** Type of resource that was changed */
  resourceType: Scalars['String']['output'];
  /** User who performed the action */
  user?: Maybe<User>;
  /** ID of the user who performed the action */
  userId?: Maybe<Scalars['String']['output']>;
};

/** Type of audit trail event */
export enum AuditTrailEvent {
  Insert = 'INSERT',
  Remove = 'REMOVE',
  Update = 'UPDATE'
}

export type BalanceStats = {
  __typename?: 'BalanceStats';
  /** Total settled employer (basic) contributions */
  employerContributions: Scalars['Decimal']['output'];
  /** Total amount invested through settled contributions */
  totalInvested: Scalars['Decimal']['output'];
  /** Overall return percentage adjusted for withdrawals, null when nothing is invested */
  totalReturnPercent?: Maybe<Scalars['Decimal']['output']>;
  /** Total settled voluntary contributions */
  voluntaryContributions: Scalars['Decimal']['output'];
};

export type BankTransferDetails = {
  __typename?: 'BankTransferDetails';
  accountName?: Maybe<Scalars['String']['output']>;
  branchAddress?: Maybe<Scalars['String']['output']>;
  branchName?: Maybe<Scalars['String']['output']>;
  iban: Scalars['String']['output'];
  paymentReference: Scalars['String']['output'];
  swiftCode?: Maybe<Scalars['String']['output']>;
};

export type BatchPayload = {
  batchNumber: Scalars['Int']['input'];
  rows: Array<PaymentAdjustmentRow>;
  totalBatches: Scalars['Int']['input'];
  totalRows: Scalars['Int']['input'];
};

export type BulkUpsertEmployees = {
  __typename?: 'BulkUpsertEmployees';
  /** List of employees that were upserted during the bulk import */
  employees?: Maybe<Array<CrmEmployee>>;
  /** Whether the bulk employee import was processed successfully */
  processed: Scalars['Boolean']['output'];
};

/** Structured error information for chat messages */
export type ChatErrorMetadata = {
  __typename?: 'ChatErrorMetadata';
  /** Original error message */
  error: Scalars['String']['output'];
  /** Classification of the error type */
  type: ChatErrorType;
};

/** Classification of chat error types */
export enum ChatErrorType {
  DataProcessing = 'DATA_PROCESSING',
  ExecutionLimit = 'EXECUTION_LIMIT',
  LlmValidation = 'LLM_VALIDATION',
  RateLimit = 'RATE_LIMIT',
  Timeout = 'TIMEOUT',
  Unknown = 'UNKNOWN',
  WorkflowState = 'WORKFLOW_STATE'
}

/** Chat message within a thread tracking sender, content, status, and metadata (intents, assistant responses, and results). */
export type ChatMessage = {
  __typename?: 'ChatMessage';
  /** Timestamp when the message processing was completed */
  completedAt?: Maybe<Scalars['Date']['output']>;
  /** Text content of the message */
  content: Scalars['String']['output'];
  /** Timestamp when the message was created */
  createdAt: Scalars['Date']['output'];
  /** Error details if message processing failed */
  errorMetadata?: Maybe<ChatErrorMetadata>;
  exportFilename?: Maybe<Scalars['String']['output']>;
  exportSize?: Maybe<Scalars['String']['output']>;
  exportUrl?: Maybe<Scalars['String']['output']>;
  /** Sender of the message */
  from: MessageFromEnum;
  /** Unique identifier of the message */
  id: Scalars['ID']['output'];
  /** Message metadata including intents and AI results */
  metadata?: Maybe<MessageMetadata>;
  /** Number of times this message has been retried (0 for original, 1+ for retries) */
  retryCount?: Maybe<Scalars['Int']['output']>;
  /** Processing status of the message */
  status: MessageStatusEnum;
  /** Chat thread this message belongs to */
  thread: ChatThread;
  /** ID of the chat thread this message belongs to */
  threadId: Scalars['String']['output'];
};

/** Columns by which ChatMessageList can be ordered */
export enum ChatMessageOrderByColumn {
  CreatedAt = 'CreatedAt',
  Id = 'Id',
  UpdatedAt = 'UpdatedAt'
}

export type ChatMessageOrderByInput = {
  /** Column name */
  column?: ChatMessageOrderByColumn;
  /** Sort direction */
  direction?: SortDirection;
};

export type ChatResult = {
  __typename?: 'ChatResult';
  /** AI reasoning for the chat response */
  reasoning: Scalars['String']['output'];
  /** AI assistant's text response to the user */
  response: Scalars['String']['output'];
  /** Type of the assistant response */
  type: AssistantResponseEnum;
};

/** Chat conversation thread tracking messages, stars, and export history */
export type ChatThread = {
  __typename?: 'ChatThread';
  /** Timestamp when the thread was created */
  createdAt: Scalars['Date']['output'];
  /** The description of the chat thread */
  description?: Maybe<Scalars['String']['output']>;
  /** Number of exports generated from this thread */
  exportsCount: Scalars['Int']['output'];
  /** Unique identifier of the chat thread */
  id: Scalars['ID']['output'];
  /** Whether the thread is active */
  isActive: Scalars['Boolean']['output'];
  /** Whether the thread is starred by the user */
  isStarred: Scalars['Boolean']['output'];
  /** Timestamp of the last message in the thread */
  lastMessageAt?: Maybe<Scalars['Date']['output']>;
  /** Messages in this chat thread */
  messages: Array<ChatMessage>;
  /** List of chat messages within this thread, ordered by creation time */
  messagesList: Array<ChatMessage>;
  /** The title of the chat thread */
  title: Scalars['String']['output'];
  /** Timestamp when the thread was last updated */
  updatedAt: Scalars['Date']['output'];
  /** User who owns the chat thread */
  user: User;
  /** ID of the user who owns the chat thread */
  userId: Scalars['String']['output'];
};


/** Chat conversation thread tracking messages, stars, and export history */
export type ChatThreadMessagesListArgs = {
  orderBy?: InputMaybe<ChatMessageOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};

export type ChatThreadsList = {
  __typename?: 'ChatThreadsList';
  count: Scalars['Int']['output'];
  list: Array<ChatThread>;
};

/** Columns by which CompaniesList can be ordered */
export enum CompaniesListOrderByColumn {
  CreatedAt = 'CreatedAt',
  Id = 'Id',
  Name = 'Name',
  UpdatedAt = 'UpdatedAt'
}

export type CompaniesListOrderByInput = {
  /** Column name */
  column?: CompaniesListOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

/** Detailed MOHRE company information. */
export type Company = {
  __typename?: 'Company';
  /** Registered address of the company. */
  address: Scalars['String']['output'];
  /** City where the company is located. */
  city: Scalars['String']['output'];
  /** Country of company registration. */
  country: Scalars['String']['output'];
  /** MOHRE employer ID for the company. */
  employerId: Scalars['String']['output'];
  /** Full details string for the company record. */
  fullDetails: Scalars['String']['output'];
  /** ICP company code assigned to the company. */
  icpCompanyCode: Scalars['String']['output'];
  /** Company name as registered in MOHRE. */
  name: Scalars['String']['output'];
  /** Company's tax registration number. */
  taxRegistrationNumber: Scalars['String']['output'];
};

/** Type of custom document for company verification */
export enum CompanyDocumentFrom {
  Company = 'Company',
  Signatory = 'Signatory'
}

/** Document templates for company verification with multilingual support */
export type CompanyDocumentTypes = {
  __typename?: 'CompanyDocumentTypes';
  createdAt: Scalars['Date']['output'];
  data: Scalars['JSONObject']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  isAdditional: Scalars['Boolean']['output'];
  optional: Scalars['Boolean']['output'];
  type: CompanyDocumentFrom;
  updatedAt: Scalars['Date']['output'];
};

export type CompanyFatcaFormSubmissionInput = {
  /** The form data as a JSON object containing the FATCA form field values */
  data: Scalars['JSON']['input'];
  /** The unique identifier of the FATCA form template to be submitted */
  formTemplateId: Scalars['String']['input'];
};

export type CompanyFeeSummary = {
  __typename?: 'CompanyFeeSummary';
  /** Date of the most recent settled payment */
  lastPaidDate?: Maybe<Scalars['DateTime']['output']>;
  /** Total amount paid across all settled payments */
  totalPaid: Scalars['Decimal']['output'];
  /** Amount of the next upcoming pending payment */
  upcomingAmount?: Maybe<Scalars['Decimal']['output']>;
};

/** MOHRE company summary from list response. */
export type CompanyFromList = {
  __typename?: 'CompanyFromList';
  /** MOHRE owner code for the company. */
  OwnerCode: Scalars['String']['output'];
  /** Company trade license number. */
  TradeLicenseNumber: Scalars['String']['output'];
  /** MOHRE company code. */
  companyCode: Scalars['String']['output'];
  /** Company name in Arabic. */
  companyNameAr: Scalars['String']['output'];
  /** Company name in English. */
  companyNameEn: Scalars['String']['output'];
};

export type CompanyOnboardingSteps = {
  __typename?: 'CompanyOnboardingSteps';
  admins: OnboardingStepStatus;
  banking: OnboardingStepStatus;
  benefits: OnboardingStepStatus;
  employees: OnboardingStepStatus;
  tax: OnboardingStepStatus;
};

/** MOHRE API response status and message. */
export type CompanyResponse = {
  __typename?: 'CompanyResponse';
  /** Response message from MOHRE API. */
  Message: Scalars['String']['output'];
  /** Status code indicating success or failure. */
  StatusCode: Scalars['Boolean']['output'];
};

export enum CompanyVerificationStatus {
  Approved = 'Approved',
  DocumentsInReview = 'DocumentsInReview',
  DocumentsRequired = 'DocumentsRequired',
  DocumentsRetry = 'DocumentsRetry',
  Rejected = 'Rejected',
  SignatoryRequired = 'SignatoryRequired',
  WaitingForSignature = 'WaitingForSignature'
}

export enum ComparisonOperator {
  Equals = 'equals',
  Includes = 'includes',
  NotEquals = 'not_equals',
  NotIncludes = 'not_includes'
}

/** Document submission record for KYC and KYB compliance flows */
export type ComplianceDocument = {
  __typename?: 'ComplianceDocument';
  attachments: Array<Attachment>;
  complianceReferenceId: Scalars['String']['output'];
  complianceType: ComplianceType;
  createdAt: Scalars['Date']['output'];
  documentType: ComplianceDocumentType;
  documentTypeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isResubmissionRequired: Scalars['Boolean']['output'];
  isResubmitted: Scalars['Boolean']['output'];
  isVerificationSubmitted: Scalars['Boolean']['output'];
  signatoryId?: Maybe<Scalars['Float']['output']>;
  signatoryName?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['Date']['output'];
};

/** Party type for compliance document verification flow */
export enum ComplianceDocumentFrom {
  Company = 'Company',
  Employee = 'Employee',
  Signatory = 'Signatory'
}

/** Document type definition for KYC and KYB compliance flows */
export type ComplianceDocumentType = {
  __typename?: 'ComplianceDocumentType';
  complianceType: ComplianceType;
  createdAt: Scalars['Date']['output'];
  data: Scalars['JSONObject']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  isAdditional: Scalars['Boolean']['output'];
  optional: Scalars['Boolean']['output'];
  type?: Maybe<ComplianceDocumentFrom>;
  updatedAt: Scalars['Date']['output'];
};

export type ComplianceDocumentTypeDataInput = {
  ar?: InputMaybe<ComplianceDocumentTypeLocaleInput>;
  en: ComplianceDocumentTypeLocaleInput;
};

export type ComplianceDocumentTypeList = {
  __typename?: 'ComplianceDocumentTypeList';
  count: Scalars['Int']['output'];
  list: Array<ComplianceDocumentType>;
};

export type ComplianceDocumentTypeLocaleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Type of compliance document flow */
export enum ComplianceType {
  Kyb = 'KYB',
  Kyc = 'KYC'
}

export type ConditionalRule = {
  __typename?: 'ConditionalRule';
  conditions: Array<FieldCondition>;
};

export type ConditionalRuleInput = {
  /** List of conditions that must be met for the rule to apply */
  conditions: Array<FieldConditionInput>;
};

export type ConfirmMarketOrders = {
  __typename?: 'ConfirmMarketOrders';
  /** Whether the confirm upload was processed successfully */
  processing: Scalars['Boolean']['output'];
};

export type ContributionOverview = {
  __typename?: 'ContributionOverview';
  /** One entry per month in the range, including months with no contributions */
  series: Array<ContributionOverviewPoint>;
  /** Sum of every contribution across the whole range */
  totalAmount: Scalars['Decimal']['output'];
};

export type ContributionOverviewPoint = {
  __typename?: 'ContributionOverviewPoint';
  /** Settled additional employer contributions in the month */
  additional: Scalars['Decimal']['output'];
  /** Settled basic contributions in the month, including accrued liability transfers */
  basic: Scalars['Decimal']['output'];
  /** Settled voluntary lump sum contributions in the month */
  lumpSum: Scalars['Decimal']['output'];
  /** ISO date of the first day of the month, in YYYY-MM-DD form */
  month: Scalars['String']['output'];
  /** Settled contributions in the month whose category maps to no named series */
  other: Scalars['Decimal']['output'];
  /** Sum of every contribution category in the month, always equal to the sum of the named series and other */
  total: Scalars['Decimal']['output'];
  /** Settled voluntary subscription contributions in the month */
  voluntary: Scalars['Decimal']['output'];
};

/** Time window a contribution overview is aggregated over */
export enum ContributionOverviewRange {
  OneYear = 'OneYear',
  SixMonths = 'SixMonths',
  ThreeMonths = 'ThreeMonths',
  YearToDate = 'YearToDate'
}

export type CreateCompanyInput = {
  /** Custom attributes for company (key-value pairs) */
  customAttributes?: InputMaybe<Array<CustomAttributeInput>>;
  /** The name of the company */
  name: Scalars['String']['input'];
  /** The official registered office address */
  registeredAddress: Scalars['String']['input'];
  /** The official registration number */
  registeredNumber: Scalars['String']['input'];
  /** UAE-specific company details (MOHRE, license, etc) */
  uaeDetails?: InputMaybe<UaeCompanyDetails>;
};

export type CreateFeeInput = {
  /** Optional description providing more context about the fee */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of the fee */
  name: Scalars['String']['input'];
};

export type CreateFeeWorkflowInput = {
  /** Optional description of the workflow */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Fee ID to assign the workflow to */
  feeId: Scalars['String']['input'];
  /** Name of the workflow */
  name: Scalars['String']['input'];
};

export type CreateHoldingAdjustmentInput = {
  amount: Scalars['Decimal']['input'];
  executedAt?: InputMaybe<Scalars['DateTime']['input']>;
  isin: Scalars['String']['input'];
  productAssignmentId: Scalars['String']['input'];
  reason: AdjustmentReasonInput;
  vestedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateProductWorkflowInput = {
  /** Optional description of the workflow */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of the workflow */
  name: Scalars['String']['input'];
  /** Product ID to associate with the workflow */
  productId: Scalars['String']['input'];
};

export type CreateRoleInput = {
  /** Optional description explaining the purpose and responsibilities of this role */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether this is a platform-wide role or a company-specific role */
  isPlatform: Scalars['Boolean']['input'];
  /** The name of the role */
  name: Scalars['String']['input'];
  /** List of permissions granted to users assigned this role */
  permissions: Array<PermissionEnum>;
  /** Optional list of company IDs to which this role is restricted */
  restrictedCompanyIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateTaskCommentInput = {
  /** The attachments to add to the comment */
  attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** The content of the comment */
  content: Scalars['String']['input'];
  /** The task ID to add the comment to */
  taskId: Scalars['ID']['input'];
};

export type CreateTaskInput = {
  assigneeId: Scalars['String']['input'];
  /** Optional company scope for the task */
  companyId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** Company entity managing organizational details, onboarding status, verification, and banking information */
export type CrmCompany = {
  __typename?: 'CrmCompany';
  /** Aggregated actionable items for the company dashboard (pending invitations, payments, requests, etc) */
  actionItems: ActionItems;
  bankingDetails?: Maybe<CrmCompanyBankingDetails>;
  billingDetails?: Maybe<CrmCompanyBillingDetails>;
  createdAt: Scalars['DateTime']['output'];
  customCompanyValues: Array<CustomCompanyValue>;
  /** Total number of employees in the company. */
  employeesCount: Scalars['Float']['output'];
  fatcaDetails?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  industry: Scalars['String']['output'];
  /** Aggregated company insights for dashboard analytics (benefits, employees, contributions, etc) */
  insights: Insights;
  kycRequests: Array<KycRequest>;
  logoFilename?: Maybe<Scalars['String']['output']>;
  logoSize?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  mohreDetails?: Maybe<CrmCompanyMohreDetails>;
  name: Scalars['String']['output'];
  notifications: Array<EventLog>;
  numberOfEmployees: Scalars['String']['output'];
  onboardingSteps: CompanyOnboardingSteps;
  registeredAddress: Scalars['String']['output'];
  registeredNumber?: Maybe<Scalars['String']['output']>;
  samlConfiguration?: Maybe<CrmSamlConfiguration>;
  /** Whether the company admin has dismissed verification status card on the dashboard */
  statusDismissed: Scalars['Boolean']['output'];
  testClock?: Maybe<Scalars['PlainDate']['output']>;
  tradingBankAccount?: Maybe<CrmTradingBankAccount>;
  updatedAt: Scalars['DateTime']['output'];
  verificationDetails?: Maybe<CrmCompanyVerification>;
  verificationStatus: CompanyVerificationStatus;
  virtualAccount?: Maybe<ScbVirtualAccount>;
};

/** Company banking details storing IBAN, SWIFT, and payee information */
export type CrmCompanyBankingDetails = {
  __typename?: 'CrmCompanyBankingDetails';
  bankCountry: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  payeeAccountName: Scalars['String']['output'];
  payeeSWIFT?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Company billing details storing TRN, billing address, and banking information for invoice generation */
export type CrmCompanyBillingDetails = {
  __typename?: 'CrmCompanyBillingDetails';
  billingAddress?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  trn?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Company verification document tracking upload status and resubmission requirements */
export type CrmCompanyDocument = {
  __typename?: 'CrmCompanyDocument';
  documentType: CompanyDocumentTypes;
  fileFilename?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isResubmissionRequired: Scalars['Boolean']['output'];
  isResubmitted: Scalars['Boolean']['output'];
  isVerificationSubmitted: Scalars['Boolean']['output'];
  signatoryId?: Maybe<Scalars['Float']['output']>;
  signatoryName?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CrmCompanyDocumentTypeList = {
  __typename?: 'CrmCompanyDocumentTypeList';
  count: Scalars['Int']['output'];
  list: Array<CompanyDocumentTypes>;
};

export type CrmCompanyList = {
  __typename?: 'CrmCompanyList';
  count: Scalars['Int']['output'];
  list: Array<CrmCompany>;
};

/** UAE MOHRE integration details storing company codes and government identifiers */
export type CrmCompanyMohreDetails = {
  __typename?: 'CrmCompanyMohreDetails';
  companyCode: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  eida?: Maybe<Scalars['String']['output']>;
  employerId: Scalars['String']['output'];
  icpCompanyCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ownerCode: Scalars['String']['output'];
  referenceId?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Company KYB verification tracking documents, reviewer, and submission status */
export type CrmCompanyVerification = {
  __typename?: 'CrmCompanyVerification';
  company: CrmCompany;
  companyId: Scalars['ID']['output'];
  complianceDocuments: Array<ComplianceDocument>;
  createdAt: Scalars['DateTime']['output'];
  documents: Array<CrmCompanyDocument>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  resubmissionRemark?: Maybe<Scalars['String']['output']>;
  reviewer?: Maybe<User>;
  reviewerId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CrmCurrency = {
  __typename?: 'CrmCurrency';
  /** Currency code or identifier (e.g., USD, AED). */
  id: Scalars['String']['output'];
  /** Indicates if this currency is the base currency for conversion. */
  isBase: Scalars['Boolean']['output'];
  /** Exchange rate of the currency relative to the base currency. */
  rate: Scalars['Decimal']['output'];
};

export type CrmCurrencyList = {
  __typename?: 'CrmCurrencyList';
  count: Scalars['Int']['output'];
  list: Array<CrmCurrency>;
};

/** Employee record tracking employment details, personal information, benefits enrollment, and product assignments */
export type CrmEmployee = {
  __typename?: 'CrmEmployee';
  address?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Scalars['String']['output']>;
  company: CrmCompany;
  companyId: Scalars['String']['output'];
  contribution: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  customEmployeeValues: Array<CustomEmployeeValue>;
  dateOfBirth?: Maybe<Scalars['PlainDate']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  employeeSubscriptionRequest?: Maybe<CrmEmployeeSubscriptionRequestEntity>;
  employmentStatus?: Maybe<EmploymentStatus>;
  endDate?: Maybe<Scalars['PlainDate']['output']>;
  eventLogs: Array<EventLog>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<EmployeeGender>;
  id: Scalars['String']['output'];
  /** Timestamp of when a user accepted the employee invitation - when the employee entity was linked to a user entity */
  invitationAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  invitations: Array<EmployeeInvitation>;
  isInterestedInIncentive: Scalars['Boolean']['output'];
  isInterestedInMatching: Scalars['Boolean']['output'];
  /** Returns true if the employee is classified as skilled. */
  isSkilled: Scalars['Boolean']['output'];
  /** Returns true if the employee is terminated. */
  isTerminated: Scalars['Boolean']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  level?: Maybe<Scalars['String']['output']>;
  nationalId: Scalars['String']['output'];
  nationality?: Maybe<Scalars['String']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  productAssignments: Array<ProductAssignment>;
  startDate: Scalars['PlainDate']['output'];
  /** Timestamp of when a mohre employee is imported or updated */
  syncWithMohreAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  /** Returns the event logs for the employee app notification section, with optional language and limit. */
  userEventLogs: Array<UserEventLog>;
  userId?: Maybe<Scalars['String']['output']>;
  workEmail?: Maybe<Scalars['String']['output']>;
};


/** Employee record tracking employment details, personal information, benefits enrollment, and product assignments */
export type CrmEmployeeUserEventLogsArgs = {
  language?: InputMaybe<SupportedLanguages>;
  pagination?: InputMaybe<Pagination>;
};

export type CrmEmployeeList = {
  __typename?: 'CrmEmployeeList';
  count: Scalars['Int']['output'];
  list: Array<CrmEmployee>;
};

/** Employee benefit subscription change request tracking approval status and amounts */
export type CrmEmployeeSubscriptionRequestEntity = {
  __typename?: 'CrmEmployeeSubscriptionRequestEntity';
  amount?: Maybe<Scalars['Decimal']['output']>;
  contribution?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  employee: CrmEmployee;
  employeeId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: EmployeeSubscriptionRequestStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type CrmKybRequestList = {
  __typename?: 'CrmKybRequestList';
  count: Scalars['Int']['output'];
  list: Array<CrmCompanyVerification>;
};

/** Product assignment subscription request for recurrent or one-time payment changes */
export type CrmProductAssignmentSubscriptionRequestEntity = {
  __typename?: 'CrmProductAssignmentSubscriptionRequestEntity';
  amount?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  productAssignment: ProductAssignment;
  productAssignmentId: Scalars['String']['output'];
  status: ProductAssignmentSubscriptionRequestStatus;
  type: ProductAssignmentSubscriptionRequestType;
  updatedAt: Scalars['DateTime']['output'];
};

export type CrmProductAssignmentSubscriptionRequestList = {
  __typename?: 'CrmProductAssignmentSubscriptionRequestList';
  count: Scalars['Int']['output'];
  list: Array<CrmProductAssignmentSubscriptionRequestEntity>;
};

/** Company SAML SSO configuration with domain verification and metadata management */
export type CrmSamlConfiguration = {
  __typename?: 'CrmSamlConfiguration';
  company: CrmCompany;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  identityProviderUrl?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  metadataFilename?: Maybe<Scalars['String']['output']>;
  metadataSize?: Maybe<Scalars['String']['output']>;
  metadataSourceType?: Maybe<MetadataSourceType>;
  metadataUrl?: Maybe<Scalars['String']['output']>;
  verificationDomain?: Maybe<Scalars['String']['output']>;
  verificationStatus: SamlConfigurationVerificationStatus;
  verificationTxtToken?: Maybe<Scalars['String']['output']>;
};

/** Company trading bank account details for fund transactions and settlements */
export type CrmTradingBankAccount = {
  __typename?: 'CrmTradingBankAccount';
  accountName?: Maybe<Scalars['String']['output']>;
  bankLocation?: Maybe<Scalars['String']['output']>;
  bankName: Scalars['String']['output'];
  branchAddress?: Maybe<Scalars['String']['output']>;
  branchName?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  iban: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  swift?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CrmUserList = {
  __typename?: 'CrmUserList';
  count: Scalars['Int']['output'];
  list: Array<User>;
};

/** Dynamic form field definition for custom data collection across entities (company, employee, product) */
export type CustomAttribute = {
  __typename?: 'CustomAttribute';
  category: FormCategory;
  data?: Maybe<Scalars['JSONObject']['output']>;
  displayedOnAdmin: Scalars['Boolean']['output'];
  editable: Scalars['Boolean']['output'];
  entity: Scalars['String']['output'];
  fundDocuments: Array<Attachment>;
  hidden: Scalars['Boolean']['output'];
  hint?: Maybe<Scalars['JSONObject']['output']>;
  /** Unique identifier of the custom attribute */
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Scalars['JSONObject']['output']>;
  order: Scalars['Float']['output'];
  placeholder?: Maybe<Scalars['JSONObject']['output']>;
  productCustomAttribute?: Maybe<ProductCustomAttribute>;
  required: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['JSONObject']['output']>;
  type: CustomAttributeType;
  updatedAt: Scalars['DateTime']['output'];
  validator?: Maybe<CustomAttributeValidator>;
};

export type CustomAttributeInput = {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CustomAttributeList = {
  __typename?: 'CustomAttributeList';
  count: Scalars['Int']['output'];
  list: Array<CustomAttribute>;
};

export enum CustomAttributeType {
  Boolean = 'boolean',
  Cron = 'cron',
  Date = 'date',
  Decimal = 'decimal',
  Fund = 'fund',
  SalaryContribution = 'salaryContribution',
  Select = 'select',
  Text = 'text',
  Textarea = 'textarea'
}

export enum CustomAttributeValidator {
  Date = 'Date',
  DateOfBirth = 'DateOfBirth',
  Email = 'Email',
  EmiratesId = 'EmiratesId',
  FutureDate = 'FutureDate',
  Number = 'Number',
  OptionValue = 'OptionValue',
  PhoneNumber = 'PhoneNumber',
  PositiveInteger = 'PositiveInteger',
  Url = 'Url'
}

/** Custom field value storage for company using EAV (Entity–Attribute–Value) pattern */
export type CustomCompanyValue = {
  __typename?: 'CustomCompanyValue';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** Custom field value storage for employee using EAV (Entity–Attribute–Value) pattern */
export type CustomEmployeeValue = {
  __typename?: 'CustomEmployeeValue';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** Custom field value storage for nominee using EAV (Entity–Attribute–Value) pattern */
export type CustomNomineeValue = {
  __typename?: 'CustomNomineeValue';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** Custom field value storage for product assignments using EAV (Entity–Attribute–Value) pattern */
export type CustomProductAssignmentValue = {
  __typename?: 'CustomProductAssignmentValue';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productAssignment: ProductAssignment;
  productAssignmentId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** Custom field value storage for product instances using EAV (Entity–Attribute–Value) pattern */
export type CustomProductInstanceValue = {
  __typename?: 'CustomProductInstanceValue';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productInstance: ProductInstance;
  productInstanceId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** Handler key for a data import job */
export enum DataImportHandlerKey {
  PaymentAdjustments = 'PaymentAdjustments'
}

export type DataImportJob = {
  __typename?: 'DataImportJob';
  createdAt: Scalars['DateTime']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  handlerKey: DataImportHandlerKey;
  id: Scalars['ID']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  processedRows: Scalars['Int']['output'];
  status: DataImportJobStatus;
  totalRows: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploadId: Scalars['String']['output'];
};

/** Status of a data import job */
export enum DataImportJobStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  Processing = 'Processing'
}

export type DatabaseExportResult = {
  __typename?: 'DatabaseExportResult';
  /** Debug information (only in localhost) */
  debug?: Maybe<DebugInfo>;
  /** Format of the exported file */
  fileFormat?: Maybe<ExportFileFormatEnum>;
  /** Name of the exported file */
  fileName: Scalars['String']['output'];
  /** AI reasoning for the export operation */
  reasoning: Scalars['String']['output'];
  /** Summary description of the exported data */
  summary: Scalars['String']['output'];
  /** Type of the assistant response */
  type: AssistantResponseEnum;
};

export type DatabaseQueryResult = {
  __typename?: 'DatabaseQueryResult';
  /** Array of query result records */
  data: Array<Scalars['JSONObject']['output']>;
  /** Debug information (only in localhost) */
  debug?: Maybe<DebugInfo>;
  /** AI reasoning for the query execution */
  reasoning: Scalars['String']['output'];
  /** Summary description of the query results */
  summary: Scalars['String']['output'];
  /** Total count of records returned by the query */
  totalCount?: Maybe<Scalars['Float']['output']>;
  /** Type of the assistant response */
  type: AssistantResponseEnum;
};

export type DebugInfo = {
  __typename?: 'DebugInfo';
  /** Execution trace showing what was tried and results */
  executionTrace: Scalars['String']['output'];
  /** Suggestions for improving the system prompt */
  promptEnhancements?: Maybe<Scalars['String']['output']>;
};

export type DecimalRangeDto = {
  __typename?: 'DecimalRangeDto';
  /** Maximum value in the range */
  max: Scalars['Decimal']['output'];
  /** Minimum value in the range */
  min: Scalars['Decimal']['output'];
};

export type DeletePaymentAdjustmentInput = {
  id: Scalars['String']['input'];
};

/** Log of all emails sent through the system */
export type EmailLog = {
  __typename?: 'EmailLog';
  /** BCC recipients (comma-separated) */
  bcc?: Maybe<Scalars['String']['output']>;
  /** Rendered HTML body of the email */
  body?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the email was sent */
  createdAt: Scalars['DateTime']['output'];
  /** Sender email address */
  from?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the email log */
  id: Scalars['ID']['output'];
  /** Email subject line */
  subject: Scalars['String']['output'];
  /** Email template identifier */
  template: Scalars['String']['output'];
  /** Recipient email address */
  to: Scalars['String']['output'];
};

export enum EmailTemplate {
  BenefitPaymentApproved = 'BenefitPaymentApproved',
  BenefitPaymentFailedReminder = 'BenefitPaymentFailedReminder',
  BenefitPaymentMade = 'BenefitPaymentMade',
  BenefitPaymentPastDueReminder = 'BenefitPaymentPastDueReminder',
  BenefitPaymentRejected = 'BenefitPaymentRejected',
  BenefitUpdate = 'BenefitUpdate',
  CompanyUserInvitation = 'CompanyUserInvitation',
  EmailVerification = 'EmailVerification',
  EmployeeCorrectionsRejected = 'EmployeeCorrectionsRejected',
  EmployeeCorrectionsResolved = 'EmployeeCorrectionsResolved',
  EmployeeDataCorrectionsAcknowledged = 'EmployeeDataCorrectionsAcknowledged',
  EmployeeDataUpdated = 'EmployeeDataUpdated',
  EmployeeEndDateUpdated = 'EmployeeEndDateUpdated',
  EmployeeInvitation = 'EmployeeInvitation',
  EmployeeNameUpdatedToEmployer = 'EmployeeNameUpdatedToEmployer',
  EmployerLedFundComplete = 'EmployerLedFundComplete',
  EmployerLedFundRequest = 'EmployerLedFundRequest',
  FundSelectionConfirmation = 'FundSelectionConfirmation',
  IbanUpdated = 'IbanUpdated',
  KybApproved = 'KybApproved',
  KybDocumentsSubmitted = 'KybDocumentsSubmitted',
  KybRejected = 'KybRejected',
  KycApproved = 'KycApproved',
  KycCancelled = 'KycCancelled',
  KycRejected = 'KycRejected',
  KycResubmissionRequired = 'KycResubmissionRequired',
  KycSubmittedForReview = 'KycSubmittedForReview',
  MohreEmployeeDataUpdated = 'MohreEmployeeDataUpdated',
  MonthlyPensionReport = 'MonthlyPensionReport',
  NewCompanyUserInvitation = 'NewCompanyUserInvitation',
  PaymentReminderOnDue = 'PaymentReminderOnDue',
  PlatformUserInvitation = 'PlatformUserInvitation',
  ProfileDataUpdated = 'ProfileDataUpdated',
  ReportEmployeeInaccurateDataWithCorrections = 'ReportEmployeeInaccurateDataWithCorrections',
  RequestMoreKybDocuments = 'RequestMoreKybDocuments',
  RequestMoreKycDocuments = 'RequestMoreKycDocuments',
  ResetPassword = 'ResetPassword',
  ResubmitKybDocuments = 'ResubmitKybDocuments',
  ScbMarketOrders = 'ScbMarketOrders',
  StartKybRegistration = 'StartKybRegistration',
  TaskAssigned = 'TaskAssigned',
  TaskCommentAdded = 'TaskCommentAdded',
  TaskEscalated = 'TaskEscalated',
  TaskEscalatedAutomatic = 'TaskEscalatedAutomatic',
  UserBlocked = 'UserBlocked',
  UserBlockedEmployerNotification = 'UserBlockedEmployerNotification',
  UserUnblocked = 'UserUnblocked',
  UserUnblockedEmployerNotification = 'UserUnblockedEmployerNotification',
  VerificationRequestBankAccountAdd = 'VerificationRequestBankAccountAdd',
  VerificationRequestBankAccountUpdate = 'VerificationRequestBankAccountUpdate',
  VerificationRequestEmailOtpVerification = 'VerificationRequestEmailOtpVerification',
  VerificationRequestPensionContributionEdit = 'VerificationRequestPensionContributionEdit',
  VerificationRequestWithdraw = 'VerificationRequestWithdraw',
  VoluntaryContributionApproved = 'VoluntaryContributionApproved',
  VoluntaryContributionRequested = 'VoluntaryContributionRequested',
  VoluntaryInvestmentsFundComplete = 'VoluntaryInvestmentsFundComplete',
  VoluntaryInvestmentsFundRequest = 'VoluntaryInvestmentsFundRequest'
}

/** Template of email */
export type EmailTemplateDto = {
  __typename?: 'EmailTemplateDto';
  description: Scalars['String']['output'];
  emailType: EmailTemplate;
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  parts: Array<EmailTemplatePart>;
  roles: Array<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
};

/** Template of email */
export type EmailTemplateInListDto = {
  __typename?: 'EmailTemplateInListDto';
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  emailType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  subject: Scalars['String']['output'];
};

/** Template of email part */
export type EmailTemplatePart = {
  __typename?: 'EmailTemplatePart';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Pending email verification request */
export type EmailVerificationEntity = {
  __typename?: 'EmailVerificationEntity';
  /** Email waiting to be verified */
  email: Scalars['String']['output'];
  /** ID sent in a verification email used to confirm address ownership */
  id: Scalars['String']['output'];
  /** Date by which the request will expire */
  validTill: Scalars['DateTime']['output'];
};

export type EmployeeAttributeCorrectionInput = {
  attribute: Scalars['String']['input'];
  newValue: Scalars['String']['input'];
};

export type EmployeeExportInput = {
  companyId: Scalars['String']['input'];
  filters?: InputMaybe<FiltersExpression>;
  format: ExportFormat;
  language?: Scalars['String']['input'];
};

export type EmployeeFilterOptionsDto = {
  __typename?: 'EmployeeFilterOptionsDto';
  /** List of available departments for filtering */
  departments: Array<Scalars['String']['output']>;
  /** List of available levels for filtering */
  levels: Array<Scalars['String']['output']>;
  /** Salary range for filtering employees */
  salary: SalaryRangeDto;
};

export enum EmployeeGender {
  Female = 'Female',
  Male = 'Male',
  Other = 'Other'
}

export type EmployeeInput = {
  /** Employee's address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Employee's branch */
  branch?: InputMaybe<Scalars['String']['input']>;
  /** Custom attributes for employee (key-value pairs) */
  customAttributes?: InputMaybe<Array<CustomAttributeInput>>;
  /** Employee's date of birth */
  dateOfBirth?: InputMaybe<Scalars['PlainDate']['input']>;
  /** Employee's department */
  department?: InputMaybe<Scalars['String']['input']>;
  /** Employee's employment status */
  employmentStatus?: InputMaybe<EmploymentStatus>;
  /** Employee's employment end date */
  endDate?: InputMaybe<Scalars['PlainDate']['input']>;
  /** Employee's first name */
  firstName: Scalars['String']['input'];
  /** Employee's gender */
  gender?: InputMaybe<EmployeeGender>;
  /** The stable primary key of an existing employee. When provided, this ID is used to match the employee for update instead of nationalId, allowing nationalId itself to be changed. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Employee's job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Employee's last name */
  lastName: Scalars['String']['input'];
  /** Employee's level */
  level?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier for the national ID document */
  nationalId: Scalars['String']['input'];
  /** Employee's nationality */
  nationality?: InputMaybe<Scalars['String']['input']>;
  /** Employee's passport number */
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  /** Employee's phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Employee's employment start date */
  startDate?: InputMaybe<Scalars['PlainDate']['input']>;
  /** UAE-specific employee details */
  uaeDetails?: InputMaybe<UaeEmployee>;
  /** Employee's work email address */
  workEmail?: InputMaybe<Scalars['String']['input']>;
};

/** Employee invitation record tracking inviter and invitation email */
export type EmployeeInvitation = {
  __typename?: 'EmployeeInvitation';
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  employee: CrmEmployee;
  employeeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inviterUser: User;
  inviterUserId: Scalars['String']['output'];
};

export type EmployeeInvitationList = {
  __typename?: 'EmployeeInvitationList';
  count: Scalars['Int']['output'];
  list: Array<EmployeeInvitation>;
};

/** Columns by which EmployeeList can be ordered */
export enum EmployeeListOrderByColumn {
  CreatedAt = 'CreatedAt',
  Department = 'Department',
  EndDate = 'EndDate',
  FirstName = 'FirstName',
  Id = 'Id',
  JobTitle = 'JobTitle',
  LastName = 'LastName',
  StartDate = 'StartDate',
  UpdatedAt = 'UpdatedAt',
  WorkEmail = 'WorkEmail'
}

export type EmployeeListOrderByInput = {
  /** Column name */
  column?: EmployeeListOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

export type EmployeePartialInput = {
  /** Employee's email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier for the national ID document */
  nationalId: Scalars['String']['input'];
  /** Employee's phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Products an employee can register their interest for */
export enum EmployeeProductInterest {
  Incentive = 'Incentive',
  Matching = 'Matching'
}

export type EmployeeStatementObject = {
  __typename?: 'EmployeeStatementObject';
  /** Timestamp when the employee statement was created */
  createdAt: Scalars['DateTime']['output'];
  /** Original filename of the employee statement PDF */
  filename: Scalars['String']['output'];
  /** Unique identifier for the employee statement attachment */
  id: Scalars['ID']['output'];
  /** Signed S3 URL to download the employee statement PDF */
  url?: Maybe<Scalars['String']['output']>;
};

export enum EmployeeSubscriptionRequestStatus {
  Approved = 'Approved',
  Pending = 'Pending'
}

export type EmployeeTerminationInput = {
  employeeId: Scalars['String']['input'];
  productAssignmentId: Scalars['String']['input'];
};

export enum EmployeesPurpose {
  NotBlocked = 'NotBlocked'
}

export type EmployerHoldingExportInput = {
  /** Target currency code for amount conversion (e.g. USD, EUR) */
  currency?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FiltersExpression>;
  format: ExportFormat;
  language?: Scalars['String']['input'];
  orderBy?: InputMaybe<EmployerHoldingPositionsListOrderByInput>;
  /** IANA timezone for date formatting (e.g. Asia/Dubai) */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type EmployerHoldingHistoryList = {
  __typename?: 'EmployerHoldingHistoryList';
  count: Scalars['Int']['output'];
  list: Array<EmployerHoldingHistoryRow>;
};

/** Columns by which EmployerHoldingPositionHistory can be ordered */
export enum EmployerHoldingHistoryOrderByColumn {
  Amount = 'Amount',
  EmployeeFullName = 'EmployeeFullName',
  Units = 'Units'
}

export type EmployerHoldingHistoryOrderByInput = {
  /** Column name */
  column?: EmployerHoldingHistoryOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

export type EmployerHoldingHistoryRow = {
  __typename?: 'EmployerHoldingHistoryRow';
  amount?: Maybe<Scalars['Decimal']['output']>;
  employeeFullName: Scalars['String']['output'];
  executedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  units: Scalars['Decimal']['output'];
};

export type EmployerHoldingList = {
  __typename?: 'EmployerHoldingList';
  count: Scalars['Int']['output'];
  list: Array<EmployerHoldingRow>;
  totalMarketValue?: Maybe<Scalars['Decimal']['output']>;
};

export type EmployerHoldingPositionSummary = {
  __typename?: 'EmployerHoldingPositionSummary';
  companyName: Scalars['String']['output'];
  fundName?: Maybe<Scalars['JSON']['output']>;
  isin: Scalars['String']['output'];
  marketValue?: Maybe<Scalars['Decimal']['output']>;
  shareClass?: Maybe<Scalars['String']['output']>;
  totalUnits: Scalars['Decimal']['output'];
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type EmployerHoldingPositionsListOrderByInput = {
  /** Column name */
  column?: EmployerHoldingPositionsOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

/** Columns by which EmployerHoldingPositionsList can be ordered */
export enum EmployerHoldingPositionsOrderByColumn {
  CompanyName = 'CompanyName',
  Isin = 'Isin',
  MarketValue = 'MarketValue',
  NavPrice = 'NavPrice',
  TotalUnits = 'TotalUnits'
}

export type EmployerHoldingRow = {
  __typename?: 'EmployerHoldingRow';
  companyId: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  fundName?: Maybe<Scalars['JSON']['output']>;
  isin: Scalars['String']['output'];
  marketValue?: Maybe<Scalars['Decimal']['output']>;
  navPrice?: Maybe<Scalars['Decimal']['output']>;
  shareClass?: Maybe<Scalars['String']['output']>;
  totalUnits: Scalars['Decimal']['output'];
};

export enum EmploymentStatus {
  Contract = 'Contract',
  Permanent = 'Permanent',
  Temporary = 'Temporary'
}

export type EntityColumns = {
  __typename?: 'EntityColumns';
  /** Base entity columns available for querying */
  baseColumns: Array<Scalars['String']['output']>;
  /** Custom attribute columns available for querying */
  customColumns: Array<Scalars['String']['output']>;
  /** Resolved fields for querying */
  resolvedFields: Array<Scalars['String']['output']>;
};

export type EnvironmentConfg = {
  __typename?: 'EnvironmentConfg';
  /** List of blocked citizenship country codes (e.g., ['US', 'CA']) */
  blockedCitizenships: Array<Scalars['String']['output']>;
  /** Feeling lost URL in Arabic */
  feelingLostUrlAr?: Maybe<Scalars['String']['output']>;
  /** Feeling lost URL in English */
  feelingLostUrlEn?: Maybe<Scalars['String']['output']>;
  /** This flag determines whether the user is logging in for the first time and should be redirected to the configuration tool to complete initial setup */
  firstLogin: Scalars['Boolean']['output'];
  /** ID of the environment config */
  id?: Maybe<Scalars['String']['output']>;
  /** KYC provider handles KYC/AML checks and can be an external system. Aurem is the default provider, which is our manual in-house KYC. */
  kycProvider: KycProvider;
  /** Logo for use in emails - for both light and dark backgrounds */
  logoUrlEmail?: Maybe<Scalars['String']['output']>;
  /** Inverted variant of the logo used by the client - for dark backgrounds */
  logoUrlInverse?: Maybe<Scalars['String']['output']>;
  /** Regular variant of the logo used by the client - for light backgrounds */
  logoUrlRegular?: Maybe<Scalars['String']['output']>;
  /** Square logo for use in the platform sidebar on light and dark backgrounds */
  logoUrlSymbol?: Maybe<Scalars['String']['output']>;
  /** The name of the environment config */
  name: Scalars['String']['output'];
  nameAr?: Maybe<Scalars['String']['output']>;
  /** Decimal places used for NAV/fund price formatting */
  navDecimalPlaces: Scalars['Int']['output'];
  /** Privacy notice text in Arabic */
  privacyNoticeAr?: Maybe<Scalars['String']['output']>;
  /** Privacy notice text in English */
  privacyNoticeEn?: Maybe<Scalars['String']['output']>;
  /** Colour theme name */
  themeName?: Maybe<EnvironmentTheme>;
  /** Decimal places used for units formatting and calculations */
  unitsDecimalPlaces: Scalars['Int']['output'];
};

/** White-label environment configuration storing theme, features, and documents */
export type EnvironmentConfig = {
  __typename?: 'EnvironmentConfig';
  /** Collection of documents associated with this environment */
  documents?: Maybe<Array<EnvironmentDocument>>;
  /** Unique identifier of the environment configuration */
  id: Scalars['String']['output'];
  logoEmailFilename?: Maybe<Scalars['String']['output']>;
  logoEmailSize?: Maybe<Scalars['String']['output']>;
  logoEmailUrl?: Maybe<Scalars['String']['output']>;
  logoInverseFilename?: Maybe<Scalars['String']['output']>;
  logoInverseSize?: Maybe<Scalars['String']['output']>;
  logoInverseUrl?: Maybe<Scalars['String']['output']>;
  logoRegularFilename?: Maybe<Scalars['String']['output']>;
  logoRegularSize?: Maybe<Scalars['String']['output']>;
  logoRegularUrl?: Maybe<Scalars['String']['output']>;
  logoSymbolFilename?: Maybe<Scalars['String']['output']>;
  logoSymbolSize?: Maybe<Scalars['String']['output']>;
  logoSymbolUrl?: Maybe<Scalars['String']['output']>;
};

export type EnvironmentConfigInput = {
  /** List of blocked citizenship country codes (e.g., ['US', 'CA']) */
  blockedCitizenships?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Feeling lost URL in Arabic */
  feelingLostUrlAr?: InputMaybe<Scalars['String']['input']>;
  /** Feeling lost URL in English */
  feelingLostUrlEn?: InputMaybe<Scalars['String']['input']>;
  /** KYC provider handles KYC/AML checks and can be an external system. Aurem is the default provider, which is our manual in-house KYC. */
  kycProvider?: InputMaybe<KycProvider>;
  /** The name of the environment config */
  name?: InputMaybe<Scalars['String']['input']>;
  nameAr?: InputMaybe<Scalars['String']['input']>;
  /** Privacy notice text in Arabic */
  privacyNoticeAr?: InputMaybe<Scalars['String']['input']>;
  /** Privacy notice text in English */
  privacyNoticeEn?: InputMaybe<Scalars['String']['input']>;
  /** Colour theme name */
  themeName?: InputMaybe<EnvironmentTheme>;
};

/** Environment-specific document storage with multilingual titles and file references */
export type EnvironmentDocument = {
  __typename?: 'EnvironmentDocument';
  attachments: Array<Attachment>;
  /** Timestamp when the document was created */
  createdAt: Scalars['Date']['output'];
  /** Environment configuration this document belongs to */
  environment: EnvironmentConfig;
  /** Document file references keyed by language code */
  files: Scalars['JSONObject']['output'];
  /** Unique identifier of the environment document */
  id: Scalars['String']['output'];
  /** Multilingual document titles keyed by language code */
  titles: Scalars['JSONObject']['output'];
  /** Document usage type for environment-specific documents */
  type: EnvironmentDocumentType;
  /** Timestamp when the document was last updated */
  updatedAt: Scalars['Date']['output'];
};

export enum EnvironmentDocumentType {
  Generic = 'Generic',
  Terms = 'Terms'
}

export enum EnvironmentTheme {
  Black = 'Black',
  Blue = 'Blue',
  Gold = 'Gold',
  Green = 'Green',
  NavyAzure = 'NavyAzure',
  NavyBlue = 'NavyBlue',
  Orange = 'Orange',
  Pink = 'Pink',
  Purple = 'Purple',
  RedSlate = 'RedSlate',
  Yellow = 'Yellow'
}

export type EscalationInput = {
  afterDays: Scalars['Int']['input'];
  roles: Array<Scalars['String']['input']>;
};

/** Audit log event tracking user actions, entity changes, and system activities with multilingual content */
export type EventLog = {
  __typename?: 'EventLog';
  /** Admin user who performed the action */
  adminUser?: Maybe<User>;
  adminUserId?: Maybe<Scalars['String']['output']>;
  company: CrmCompany;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  eventType: EventType;
  id: Scalars['ID']['output'];
  ownerId: Scalars['String']['output'];
  ownerType: Scalars['String']['output'];
  readAt?: Maybe<Scalars['Date']['output']>;
  showInAdminDashboard: Scalars['Boolean']['output'];
  showInEmployeeApp: Scalars['Boolean']['output'];
  /** Target user of the action */
  targetUser?: Maybe<User>;
  targetUserId?: Maybe<Scalars['String']['output']>;
};

export enum EventLogType {
  Error = 'Error',
  Info = 'Info',
  Success = 'Success',
  Warning = 'Warning'
}

/** Event log metadata item */
export type EventMetadataItem = {
  __typename?: 'EventMetadataItem';
  /** Name of the metadata property for the event log */
  name: Scalars['String']['output'];
  /** Value of the metadata property for the event log */
  value: Scalars['String']['output'];
};

export enum EventType {
  BankAccountAdded = 'BankAccountAdded',
  CompanyInfoEdited = 'CompanyInfoEdited',
  EmployeeBulkUploaded = 'EmployeeBulkUploaded',
  EmployeeCreated = 'EmployeeCreated',
  EmployeeEdited = 'EmployeeEdited',
  EmployeeInvited = 'EmployeeInvited',
  MohreAddedEmployeeSync = 'MohreAddedEmployeeSync',
  MohreCompanyDataSynced = 'MohreCompanyDataSynced',
  MohreEditedEmployeeSync = 'MohreEditedEmployeeSync',
  MohreFinishedEmployeeSync = 'MohreFinishedEmployeeSync',
  MohreImportEmployees = 'MohreImportEmployees',
  UserBlocked = 'UserBlocked',
  UserIdentityRejected = 'UserIdentityRejected',
  UserIdentityRetry = 'UserIdentityRetry',
  UserIdentityVerified = 'UserIdentityVerified',
  UserInvited = 'UserInvited',
  UserRoleDeleted = 'UserRoleDeleted',
  UserRoleUpdated = 'UserRoleUpdated',
  UserUnblocked = 'UserUnblocked',
  VerificationDocumentUploaded = 'VerificationDocumentUploaded'
}

/** Export file formats supported by the AI assistant */
export enum ExportFileFormatEnum {
  Csv = 'CSV',
  Xlsx = 'XLSX'
}

/** Export file format */
export enum ExportFormat {
  Csv = 'CSV',
  Xlsx = 'XLSX'
}

export type ExportProductAssignmentContributionsInput = {
  companyId: Scalars['String']['input'];
  format: ExportFormat;
  language?: Scalars['String']['input'];
  productAssignmentId: Scalars['String']['input'];
};

export type ExportResultDto = {
  __typename?: 'ExportResultDTO';
  downloadUrl: Scalars['String']['output'];
  expiresAt: Scalars['Date']['output'];
  rowCount: Scalars['Int']['output'];
};

export type ExportStatusResult = {
  __typename?: 'ExportStatusResult';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  /** Workflow status: RUNNING, COMPLETED, FAILED, etc. */
  status: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

export type ExportWorkflowStartResult = {
  __typename?: 'ExportWorkflowStartResult';
  workflowId: Scalars['String']['output'];
};

export type FeaturesConfig = {
  __typename?: 'FeaturesConfig';
  avs_feature?: Maybe<Scalars['Boolean']['output']>;
  beneficiaries_feature?: Maybe<Scalars['Boolean']['output']>;
  employees_auto_invite_feature?: Maybe<Scalars['Boolean']['output']>;
  google_sign_in_feature?: Maybe<Scalars['Boolean']['output']>;
  ipp_feature?: Maybe<Scalars['Boolean']['output']>;
  market_orders_confirm_feature?: Maybe<Scalars['Boolean']['output']>;
  saml_feature?: Maybe<Scalars['Boolean']['output']>;
  show_fees_in_transactions?: Maybe<Scalars['Boolean']['output']>;
  workflowConfigFeature?: Maybe<Scalars['Boolean']['output']>;
};

export type FeaturesConfigInput = {
  avs_feature?: InputMaybe<Scalars['Boolean']['input']>;
  beneficiaries_feature?: InputMaybe<Scalars['Boolean']['input']>;
  employees_auto_invite_feature?: InputMaybe<Scalars['Boolean']['input']>;
  google_sign_in_feature?: InputMaybe<Scalars['Boolean']['input']>;
  ipp_feature?: InputMaybe<Scalars['Boolean']['input']>;
  market_orders_confirm_feature?: InputMaybe<Scalars['Boolean']['input']>;
  saml_feature?: InputMaybe<Scalars['Boolean']['input']>;
  show_fees_in_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  workflowConfigFeature?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Container entity grouping related fee workflows (assignments via FeeAssignment table) */
export type Fee = {
  __typename?: 'Fee';
  category?: Maybe<PaymentCategory>;
  categoryId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Assignments of this fee to entities */
  feeAssignments: Array<FeeAssignment>;
  /** Workflows owned by this fee */
  feeWorkflows: Array<WorkflowDefinition>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** The type of entity a fee can be assigned to (Company, Product, ProductInstance, Environment) */
export enum FeeAssignableType {
  CompanyEntity = 'CompanyEntity',
  EnvironmentConfigEntity = 'EnvironmentConfigEntity',
  ProductEntity = 'ProductEntity',
  ProductInstanceEntity = 'ProductInstanceEntity'
}

/** Assigns a fee to companies, products, or platform-wide */
export type FeeAssignment = {
  __typename?: 'FeeAssignment';
  /** The ID of the entity this fee is assigned to */
  assignableId: Scalars['ID']['output'];
  /** The type of entity this fee is assigned to */
  assignableType: FeeAssignableType;
  createdAt: Scalars['DateTime']['output'];
  fee: Fee;
  feeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Action to perform on fee assignments */
export enum FeeAssignmentAction {
  Add = 'Add',
  Remove = 'Remove'
}

/** Fee-scoped workflow config keys */
export enum FeeWorkflowKey {
  AumFeeCollection = 'AumFeeCollection',
  AumFeeComputation = 'AumFeeComputation',
  ParticipationFee = 'ParticipationFee'
}

export type FieldCondition = {
  __typename?: 'FieldCondition';
  operator: ComparisonOperator;
  sourceFieldId: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
};

export type FieldConditionInput = {
  /** Comparison operator for the condition (e.g. equals, not_equals, includes, not_includes) */
  operator: ComparisonOperator;
  /** ID of the source field to compare against */
  sourceFieldId: Scalars['String']['input'];
  /** Value(s) to compare with the source field */
  value: Scalars['JSON']['input'];
};

export type FileLanguageInput = {
  /** Uploaded document file for the specified language */
  file: Scalars['Upload']['input'];
  /** Language code for the document (e.g., 'en', 'ar') */
  lang: Scalars['String']['input'];
};

export type Filter = {
  field: Scalars['String']['input'];
  op: Operation;
  relationField?: InputMaybe<Scalars['String']['input']>;
  values: Array<Scalars['String']['input']>;
};

export type FiltersExpression = {
  childExpressions?: InputMaybe<Array<FiltersExpression>>;
  filters: Array<Filter>;
  operator: Operator;
};

export enum FormCategory {
  CompanyCreate = 'CompanyCreate',
  CompanyInformation = 'CompanyInformation',
  CompanyProduct = 'CompanyProduct',
  CompanyTax = 'CompanyTax',
  EmployeeBankDetails = 'EmployeeBankDetails',
  EmployeeContact = 'EmployeeContact',
  EmployeeEmploymentDetails = 'EmployeeEmploymentDetails',
  EmployeePersonalInfo = 'EmployeePersonalInfo',
  EmployeeProduct = 'EmployeeProduct',
  NomineeDetails = 'NomineeDetails',
  Other = 'Other',
  TaxInformation = 'TaxInformation'
}

export type FormField = {
  __typename?: 'FormField';
  conditionalRule?: Maybe<ConditionalRule>;
  content?: Maybe<Scalars['JSONObject']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['JSONObject']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<FormFieldOption>>;
  order?: Maybe<Scalars['Float']['output']>;
  placeholder?: Maybe<Scalars['JSONObject']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  validation?: Maybe<Scalars['JSONObject']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

export type FormFieldInput = {
  /** Conditional rule that determines field visibility or behavior */
  conditionalRule?: InputMaybe<ConditionalRuleInput>;
  /** Additional content for the form field, keyed by language */
  content?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Default value for the form field */
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** Localized description for the form field (keyed by language) */
  description?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Unique identifier for the form field */
  id: Scalars['String']['input'];
  /** Localized label for the form field (keyed by language) */
  label?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Layout type for the form field */
  layout?: InputMaybe<Scalars['String']['input']>;
  /** Whether the field supports multiple values */
  multi?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the form field */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of selectable options for the field (if applicable) */
  options?: InputMaybe<Array<FormFieldOptionInput>>;
  /** Order of the field in the form layout */
  order?: InputMaybe<Scalars['Float']['input']>;
  /** Localized placeholder text for the form field (keyed by language) */
  placeholder?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Whether the field is required */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of the form field (e.g. text, select, checkbox) */
  type: Scalars['String']['input'];
  /** Validation rules for the field, keyed by language and rule type */
  validation?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Variant of the field (e.g. style or display type) */
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type FormFieldOption = {
  __typename?: 'FormFieldOption';
  id?: Maybe<Scalars['String']['output']>;
  label: Scalars['JSONObject']['output'];
  value: Scalars['String']['output'];
};

export type FormFieldOptionInput = {
  /** Unique identifier for the field option */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Localized label for the field option (keyed by language) */
  label: Scalars['JSONObject']['input'];
  /** Value associated with the field option */
  value: Scalars['String']['input'];
};

/** Dynamic form template with versioned field definitions for employee, company, and product data collection */
export type FormTemplate = {
  __typename?: 'FormTemplate';
  category: FormCategory;
  createdAt: Scalars['DateTime']['output'];
  currentVersion: Scalars['Float']['output'];
  deletable: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['JSONObject']['output']>;
  extendable: Scalars['Boolean']['output'];
  fields: Array<FormField>;
  id: Scalars['ID']['output'];
  name: Scalars['JSONObject']['output'];
  publishedVersion?: Maybe<Scalars['Float']['output']>;
  status: FormTemplateStatus;
  systemKey?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type FormTemplateInput = {
  /** Category of the form template */
  category: FormCategory;
  /** Localized description of the form template (keyed by language) */
  description?: InputMaybe<Scalars['JSONObject']['input']>;
  /** List of fields included in the form template */
  fields: Array<FormFieldInput>;
  /** Localized name of the form template (keyed by language) */
  name: Scalars['JSONObject']['input'];
  /** Status of the form template (e.g. draft, published) */
  status?: InputMaybe<FormTemplateStatus>;
};

export enum FormTemplateStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published'
}

export type FormTemplateUpdateInput = {
  /** Category of the form template */
  category?: InputMaybe<FormCategory>;
  /** Localized description of the form template (keyed by language) */
  description?: InputMaybe<Scalars['JSONObject']['input']>;
  /** List of fields included in the form template */
  fields?: InputMaybe<Array<FormFieldInput>>;
  /** Localized name of the form template (keyed by language) */
  name?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Status of the form template (e.g. draft, published) */
  status?: InputMaybe<FormTemplateStatus>;
};

/** Immutable snapshot of form template fields and configuration at time of publication */
export type FormTemplateVersion = {
  __typename?: 'FormTemplateVersion';
  formTemplateId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  publishedAt: Scalars['DateTime']['output'];
  publishedByUserId?: Maybe<Scalars['String']['output']>;
  snapshot: FormTemplateVersionSnapshot;
  version: Scalars['Float']['output'];
};

export type FormTemplateVersionSnapshot = {
  __typename?: 'FormTemplateVersionSnapshot';
  category: FormCategory;
  description?: Maybe<Scalars['JSONObject']['output']>;
  fields: Array<FormField>;
  name: Scalars['JSONObject']['output'];
};

export type Fund = {
  __typename?: 'Fund';
  /** @deprecated Funds live in custom attributes */
  id: Scalars['String']['output'];
  /** @deprecated Funds live in custom attributes */
  nameAr: Scalars['String']['output'];
  /** @deprecated Funds live in custom attributes */
  nameEn: Scalars['String']['output'];
};

/** Fund document storage with multilingual titles and file paths */
export type FundDocument = {
  __typename?: 'FundDocument';
  attachments: Array<Attachment>;
  /** Timestamp when the fund document was created */
  createdAt: Scalars['Date']['output'];
  /** Document file paths keyed by locale for multilingual support */
  files: Scalars['JSONObject']['output'];
  /** The unique identifier of the associated fund */
  fundId: Scalars['String']['output'];
  /** Unique identifier of the fund document */
  id: Scalars['String']['output'];
  /** Multilingual document titles keyed by locale (e.g., 'en', 'ar') */
  titles: Scalars['JSONObject']['output'];
  /** Timestamp when the fund document was last updated */
  updatedAt: Scalars['Date']['output'];
};

export type GetMohreCompanyInput = {
  /** ID value for the company (UID or EIDA) */
  id: Scalars['String']['input'];
  /** Type of the company ID (UID or EIDA) */
  type: MohreIdType;
};

export type GetMohreCompanyInputWithOtp = {
  /** OTP code for verification */
  code: Scalars['String']['input'];
  /** ID value for the company (UID or EIDA) */
  id: Scalars['String']['input'];
  /** Type of the company ID (UID or EIDA) */
  type: MohreIdType;
};

export type HoldingExportInput = {
  /** Target currency code for amount conversion (e.g. USD, EUR) */
  currency?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FiltersExpression>;
  format: ExportFormat;
  language?: Scalars['String']['input'];
  orderBy?: InputMaybe<HoldingPositionsListOrderByInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** IANA timezone for date formatting (e.g. Asia/Dubai) */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type HoldingPosition = {
  __typename?: 'HoldingPosition';
  companyId: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  employeeFullName: Scalars['String']['output'];
  fundName?: Maybe<Scalars['JSON']['output']>;
  isin: Scalars['String']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  marketValue?: Maybe<Scalars['Decimal']['output']>;
  productName: Scalars['String']['output'];
  shareClass?: Maybe<Scalars['String']['output']>;
  sourceId: Scalars['String']['output'];
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  unvestedUnits: Scalars['Decimal']['output'];
  vestedUnits: Scalars['Decimal']['output'];
};

export type HoldingPositionFilterOptionsDto = {
  __typename?: 'HoldingPositionFilterOptionsDto';
  /** List of distinct company names for filtering */
  companies: Array<Scalars['String']['output']>;
  /** Market value range for filtering */
  marketValue?: Maybe<DecimalRangeDto>;
  /** List of distinct product/benefit names for filtering */
  products: Array<Scalars['String']['output']>;
  /** Total units range (vested + unvested) for filtering */
  totalUnits: DecimalRangeDto;
};

export type HoldingPositionList = {
  __typename?: 'HoldingPositionList';
  count: Scalars['Int']['output'];
  list: Array<HoldingPosition>;
  totalMarketValue?: Maybe<Scalars['Decimal']['output']>;
};

export type HoldingPositionWithHistory = {
  __typename?: 'HoldingPositionWithHistory';
  companyId: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  employeeFullName: Scalars['String']['output'];
  fundName?: Maybe<Scalars['JSON']['output']>;
  history: Array<HoldingV2>;
  isin: Scalars['String']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  marketValue?: Maybe<Scalars['Decimal']['output']>;
  pendingFees: Array<AggregatedAumFee>;
  productName: Scalars['String']['output'];
  shareClass?: Maybe<Scalars['String']['output']>;
  sourceId: Scalars['String']['output'];
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  unvestedUnits: Scalars['Decimal']['output'];
  vestedUnits: Scalars['Decimal']['output'];
};

/** Columns by which HoldingPositionsList can be ordered */
export enum HoldingPositionsListOrderByColumn {
  CompanyName = 'CompanyName',
  EmployeeFullName = 'EmployeeFullName',
  Isin = 'Isin',
  LastUpdatedAt = 'LastUpdatedAt',
  MarketValue = 'MarketValue',
  ProductName = 'ProductName',
  UnitPrice = 'UnitPrice',
  UnvestedUnits = 'UnvestedUnits',
  VestedUnits = 'VestedUnits'
}

export type HoldingPositionsListOrderByInput = {
  /** Column name */
  column?: HoldingPositionsListOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

export type HoldingSnapshot = {
  __typename?: 'HoldingSnapshot';
  /** Total balance of holdings */
  total: Scalars['Decimal']['output'];
  /** Unvested balance of holdings */
  unvested: Scalars['Decimal']['output'];
  /** Vested balance of holdings */
  vested: Scalars['Decimal']['output'];
};

/** Fund holding record tracking ISIN units, vesting date, and execution date for benefits or product assignments */
export type HoldingV2 = {
  __typename?: 'HoldingV2';
  adjustment?: Maybe<Adjustment>;
  executedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isin: Scalars['String']['output'];
  units: Scalars['Decimal']['output'];
  vestedAt: Scalars['DateTime']['output'];
};

export type ImportPaymentAdjustmentsInput = {
  batch: BatchPayload;
  paymentId: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
};

export type Insights = {
  __typename?: 'Insights';
  /** Total basic contribution since inception */
  basicContribution: Scalars['Decimal']['output'];
  /** Total invited employees since inception */
  invitedEmployees: Scalars['Float']['output'];
  /** Total registered employees since inception */
  registeredEmployees: Scalars['Float']['output'];
  /** Total contribution since inception */
  totalContribution: Scalars['Decimal']['output'];
  /** Total number of employees who opt in for Matching */
  totalEmployeesMatching: Scalars['Float']['output'];
  /** Total voluntary contribution since inception */
  voluntaryContribution: Scalars['Decimal']['output'];
};

export type InternalAuditTrailList = {
  __typename?: 'InternalAuditTrailList';
  count: Scalars['Int']['output'];
  list: Array<AuditTrail>;
};

/** Columns by which InternalAuditTrailList can be ordered */
export enum InternalAuditTrailOrderByColumn {
  CreatedAt = 'CreatedAt',
  Event = 'Event',
  Id = 'Id',
  ResourceType = 'ResourceType'
}

export type InternalAuditTrailOrderByInput = {
  /** Column name */
  column?: InternalAuditTrailOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

export type InternalChatThreadList = {
  __typename?: 'InternalChatThreadList';
  count: Scalars['Int']['output'];
  list: Array<ChatThread>;
};

/** Columns by which InternalChatThreadList can be ordered */
export enum InternalChatThreadOrderByColumn {
  CreatedAt = 'CreatedAt',
  LastMessageAt = 'LastMessageAt',
  Title = 'Title',
  UpdatedAt = 'UpdatedAt'
}

export type InternalChatThreadOrderByInput = {
  /** Column name */
  column?: InternalChatThreadOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

export type InternalDataImportJobList = {
  __typename?: 'InternalDataImportJobList';
  count: Scalars['Int']['output'];
  list: Array<DataImportJob>;
};

/** Columns by which InternalDataImportJobList can be ordered */
export enum InternalDataImportJobOrderByColumn {
  CreatedAt = 'CreatedAt',
  HandlerKey = 'HandlerKey',
  Id = 'Id',
  Status = 'Status',
  TotalRows = 'TotalRows'
}

export type InternalDataImportJobOrderByInput = {
  /** Column name */
  column?: InternalDataImportJobOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

export type InternalEmailLogList = {
  __typename?: 'InternalEmailLogList';
  count: Scalars['Int']['output'];
  list: Array<EmailLog>;
};

/** Columns by which InternalEmailLogList can be ordered */
export enum InternalEmailLogOrderByColumn {
  CreatedAt = 'CreatedAt',
  Id = 'Id',
  Template = 'Template',
  To = 'To'
}

export type InternalEmailLogOrderByInput = {
  /** Column name */
  column?: InternalEmailLogOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

export type InternalEmployeeInvitationList = {
  __typename?: 'InternalEmployeeInvitationList';
  count: Scalars['Int']['output'];
  list: Array<EmployeeInvitation>;
};

/** Columns by which InternalEmployeeInvitationList can be ordered */
export enum InternalEmployeeInvitationOrderByColumn {
  CreatedAt = 'CreatedAt',
  Email = 'Email',
  Id = 'Id'
}

export type InternalEmployeeInvitationOrderByInput = {
  /** Column name */
  column?: InternalEmployeeInvitationOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

export type InternalLlmAuditLogList = {
  __typename?: 'InternalLLMAuditLogList';
  count: Scalars['Int']['output'];
  list: Array<LlmAuditLog>;
};

/** Columns by which InternalLLMAuditLogList can be ordered */
export enum InternalLlmAuditLogOrderByColumn {
  CreatedAt = 'CreatedAt',
  Id = 'Id',
  ModelName = 'ModelName',
  Success = 'Success',
  TotalDurationMs = 'TotalDurationMs',
  TurnCount = 'TurnCount'
}

export type InternalLlmAuditLogOrderByInput = {
  /** Column name */
  column?: InternalLlmAuditLogOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

export type InternalOutboundList = {
  __typename?: 'InternalOutboundList';
  count: Scalars['Int']['output'];
  list: Array<Outbound>;
};

export type InternalOutboundLogList = {
  __typename?: 'InternalOutboundLogList';
  count: Scalars['Int']['output'];
  list: Array<OutboundLog>;
};

/** Columns by which InternalOutboundLogList can be ordered */
export enum InternalOutboundLogOrderByColumn {
  Connector = 'Connector',
  CreatedAt = 'CreatedAt',
  Endpoint = 'Endpoint',
  EntityType = 'EntityType',
  Id = 'Id',
  Status = 'Status'
}

export type InternalOutboundLogOrderByInput = {
  /** Column name */
  column?: InternalOutboundLogOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

/** Columns by which InternalOutboundList can be ordered */
export enum InternalOutboundOrderByColumn {
  Connector = 'Connector',
  CreatedAt = 'CreatedAt',
  EntityType = 'EntityType',
  Id = 'Id',
  Status = 'Status',
  Type = 'Type',
  UpdatedAt = 'UpdatedAt'
}

export type InternalOutboundOrderByInput = {
  /** Column name */
  column?: InternalOutboundOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

export type InternalSupportToolLogList = {
  __typename?: 'InternalSupportToolLogList';
  count: Scalars['Int']['output'];
  list: Array<SupportToolLog>;
};

/** Columns by which InternalSupportToolLogList can be ordered */
export enum InternalSupportToolLogOrderByColumn {
  Action = 'Action',
  Category = 'Category',
  CreatedAt = 'CreatedAt',
  EntityType = 'EntityType',
  Id = 'Id',
  Success = 'Success'
}

export type InternalSupportToolLogOrderByInput = {
  /** Column name */
  column?: InternalSupportToolLogOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

/** A barrier node a workflow run is parked on, with the runs still holding it back. */
export type InternalWorkflowBarrierWaiter = {
  __typename?: 'InternalWorkflowBarrierWaiter';
  /** Runs that must finish before this barrier releases. Narrowed as each one finishes. */
  blockingRunIds: Array<Scalars['ID']['output']>;
  /** The barrier node the run is parked on */
  nodeId: Scalars['String']['output'];
};

export type InternalWorkflowRunList = {
  __typename?: 'InternalWorkflowRunList';
  count: Scalars['Int']['output'];
  list: Array<WorkflowRun>;
};

/** Columns by which InternalWorkflowRunList can be ordered */
export enum InternalWorkflowRunOrderByColumn {
  CreatedAt = 'CreatedAt',
  Status = 'Status'
}

export type InternalWorkflowRunOrderByInput = {
  /** Column name */
  column?: InternalWorkflowRunOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

export type InvalidEmployeeError = {
  __typename?: 'InvalidEmployeeError';
  arabicName?: Maybe<Scalars['String']['output']>;
  basicSalary?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullSalary?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<EmployeeGender>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  missingFields: Array<Scalars['String']['output']>;
  nationalId?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
  unifiedNumber?: Maybe<Scalars['String']['output']>;
  workEmail?: Maybe<Scalars['String']['output']>;
};

export type InviteOrResendEmployeesInput = {
  /** If true, processes all uninvited/pending employees in the company. If false, uses employeeIds. */
  all: Scalars['Boolean']['input'];
  /** Company ID */
  companyId: Scalars['String']['input'];
  /** List of employee IDs to process. Ignored if all is true. */
  employeeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InviteUsersInput = {
  /** Optional company ID to associate with the invitations */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  /** List of role IDs to assign to invited users */
  roleIds: Array<Scalars['ID']['input']>;
  /** List of users to invite */
  users: Array<UserInviteDataInput>;
};

export type InvoiceConfig = {
  __typename?: 'InvoiceConfig';
  billedBy?: Maybe<InvoicePartyRef>;
  billedTo?: Maybe<InvoicePartyRef>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
};

export type InvoiceParty = {
  __typename?: 'InvoiceParty';
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  disclaimer?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  trn?: Maybe<Scalars['String']['output']>;
  type?: Maybe<InvoicePartyKind>;
  updatedAt: Scalars['Date']['output'];
};

export enum InvoicePartyKind {
  Company = 'Company',
  Individual = 'Individual'
}

export type InvoicePartyRef = InvoicePartyRefCompany | InvoicePartyRefEmployee | InvoicePartyRefInvoiceParty;

export type InvoicePartyRefCompany = {
  __typename?: 'InvoicePartyRefCompany';
  type: InvoicePartyType;
};

export type InvoicePartyRefEmployee = {
  __typename?: 'InvoicePartyRefEmployee';
  type: InvoicePartyType;
};

export type InvoicePartyRefInvoiceParty = {
  __typename?: 'InvoicePartyRefInvoiceParty';
  partyId: Scalars['String']['output'];
  type: InvoicePartyType;
};

export enum InvoicePartyType {
  Company = 'Company',
  CustomParty = 'CustomParty',
  Employee = 'Employee'
}

/** List of companies returned from MOHRE API. */
export type Items = {
  __typename?: 'Items';
  /** Array of company summaries from MOHRE. */
  companies: Array<CompanyFromList>;
};

/** Columns by which KybRequestListsList can be ordered */
export enum KybRequestListOrderByColumn {
  CompanyName = 'CompanyName',
  CreatedAt = 'CreatedAt',
  Id = 'Id',
  ReviewerName = 'ReviewerName',
  Status = 'Status',
  UpdatedAt = 'UpdatedAt'
}

export type KybRequestListOrderByInput = {
  /** Column name */
  column?: KybRequestListOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

export type KycDocument = {
  __typename?: 'KycDocument';
  extractedFields?: Maybe<KycDocumentExtractedFields>;
  fileFilename?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isResubmissionRequired: Scalars['Boolean']['output'];
  isResubmitted: Scalars['Boolean']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  secondaryFilename?: Maybe<Scalars['String']['output']>;
  secondarySize?: Maybe<Scalars['String']['output']>;
  secondaryUrl?: Maybe<Scalars['String']['output']>;
  type: KycDocumentType;
  uploadedAt: Scalars['String']['output'];
};

export type KycDocumentAddress = {
  __typename?: 'KycDocumentAddress';
  country?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
};

export type KycDocumentExtractedFields = {
  __typename?: 'KycDocumentExtractedFields';
  address?: Maybe<KycDocumentAddress>;
  country?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  idDocType?: Maybe<Scalars['String']['output']>;
  issuedDate?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  validUntil?: Maybe<Scalars['String']['output']>;
};

export enum KycDocumentType {
  Identity = 'Identity',
  ProofOfAddress = 'ProofOfAddress'
}

export type KycExtractedAddressInput = {
  /** Full formatted address extracted from KYC document. */
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
};

export type KycExtractedFieldsInput = {
  /** Extracted address details from KYC document. */
  address?: InputMaybe<KycExtractedAddressInput>;
  /** Extracted country of citizenship from KYC document. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Extracted date of birth (YYYY-MM-DD) from KYC document. */
  dob?: InputMaybe<Scalars['String']['input']>;
  /** Extracted first name from KYC document. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Extracted gender from KYC document. */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** Extracted last name from KYC document. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Extracted middle name from KYC document. */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Extracted place of birth from KYC document. */
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
};

export enum KycProvider {
  Aurem = 'Aurem',
  Sumsub = 'Sumsub'
}

/** KYC verification request with documents, status, risk rating, and provider data */
export type KycRequest = {
  __typename?: 'KycRequest';
  company: CrmCompany;
  companyId: Scalars['String']['output'];
  complianceDocuments: Array<ComplianceDocument>;
  createdAt: Scalars['DateTime']['output'];
  documents: Array<KycDocument>;
  expiredAt?: Maybe<Scalars['PlainDate']['output']>;
  id: Scalars['String']['output'];
  kycProvider: KycProvider;
  note?: Maybe<Scalars['String']['output']>;
  requestedVia?: Maybe<KycRequestSource>;
  reviewer?: Maybe<User>;
  reviewerId?: Maybe<Scalars['String']['output']>;
  riskRating: KycRiskRating;
  status: KycRequestStatus;
  /** AML screening data from Sumsub */
  sumsubAmlScreeningData?: Maybe<SumsubAmlScreeningData>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type KycRequestList = {
  __typename?: 'KycRequestList';
  count: Scalars['Int']['output'];
  list: Array<KycRequest>;
};

/** Columns by which KycRequestListsList can be ordered */
export enum KycRequestListOrderByColumn {
  CompanyName = 'CompanyName',
  CreatedAt = 'CreatedAt',
  EmployeeName = 'EmployeeName',
  Id = 'Id',
  ReviewerName = 'ReviewerName',
  Status = 'Status',
  UpdatedAt = 'UpdatedAt'
}

export type KycRequestListOrderByInput = {
  /** Column name */
  column?: KycRequestListOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

export enum KycRequestSource {
  Contribution = 'Contribution',
  FundSwitch = 'FundSwitch',
  Withdrawal = 'Withdrawal'
}

export enum KycRequestStatus {
  AdditionalDocumentRequired = 'AdditionalDocumentRequired',
  Approved = 'Approved',
  Cancelled = 'Cancelled',
  DocumentsInReview = 'DocumentsInReview',
  DocumentsRequired = 'DocumentsRequired',
  OnHold = 'OnHold',
  Rejected = 'Rejected',
  ResubmissionRequired = 'ResubmissionRequired'
}

export enum KycRiskRating {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

/** Audit log for LLM agent executions */
export type LlmAuditLog = {
  __typename?: 'LLMAuditLog';
  /** Full conversation history with the LLM */
  conversationHistory: Scalars['JSON']['output'];
  /** Timestamp when the LLM execution was logged */
  createdAt: Scalars['DateTime']['output'];
  /** Error message if the execution failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Final output from the agent execution */
  finalOutput?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier of the LLM audit log */
  id: Scalars['ID']['output'];
  /** Maximum turns allowed for the agent */
  maxTurns: Scalars['Int']['output'];
  /** Name of the LLM model used */
  modelName: Scalars['String']['output'];
  /** Node ID within the agent workflow */
  nodeId?: Maybe<Scalars['String']['output']>;
  /** Run ID for grouping related agent executions */
  runId?: Maybe<Scalars['String']['output']>;
  /** Whether the agent execution was successful */
  success: Scalars['Boolean']['output'];
  /** Tool definitions available to the agent */
  toolsDefinition?: Maybe<Scalars['JSON']['output']>;
  /** Total duration of the execution in milliseconds */
  totalDurationMs: Scalars['Int']['output'];
  /** Number of turns taken during execution */
  turnCount: Scalars['Int']['output'];
  /** User who triggered the execution */
  user?: Maybe<User>;
  /** ID of the user who triggered the execution */
  userId?: Maybe<Scalars['String']['output']>;
};

export type LocationType = {
  __typename?: 'LocationType';
  /** City name for the location. */
  city?: Maybe<Scalars['String']['output']>;
  /** Country name for the location. */
  country?: Maybe<Scalars['String']['output']>;
};

export enum LogoVariant {
  Email = 'Email',
  Inverse = 'Inverse',
  Regular = 'Regular',
  Symbol = 'Symbol'
}

/** Manual task entity for user-created tasks with title and description */
export type ManualTask = {
  __typename?: 'ManualTask';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for marking all notifications as read with optional type filter */
export type MarkAllNotificationsReadInput = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Input for marking a single notification as read */
export type MarkNotificationReadInput = {
  notificationId: Scalars['ID']['input'];
};

/** Input for marking multiple notifications as seen */
export type MarkNotificationsSeenInput = {
  notificationIds: Array<Scalars['ID']['input']>;
};

/** Market order for fund transactions (buy, sell, switch) with execution tracking and receipt management */
export type MarketOrder = {
  __typename?: 'MarketOrder';
  company: CrmCompany;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  executedBy?: Maybe<Scalars['ID']['output']>;
  executedByUser?: Maybe<User>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isin?: Maybe<Scalars['String']['output']>;
  isinTarget?: Maybe<Scalars['String']['output']>;
  /** Returns paginated transactions for the selected market order, with optional employee/company search. */
  marketOrderTransactionsList: MarketOrderTransactionList;
  /** Returns aggregate transaction totals for the market order, used by details header and execution modal calculations. */
  marketOrderTransactionsSummary: MarketOrderTransactionSummary;
  purpose?: Maybe<MarketOrderPurpose>;
  receiptFilename?: Maybe<Scalars['String']['output']>;
  receiptFromFilename?: Maybe<Scalars['String']['output']>;
  receiptFromSize?: Maybe<Scalars['String']['output']>;
  receiptFromUrl?: Maybe<Scalars['String']['output']>;
  receiptSize?: Maybe<Scalars['String']['output']>;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  runId?: Maybe<Scalars['String']['output']>;
  state: MarketOrderStatus;
  type: MarketOrderType;
  updatedAt: Scalars['DateTime']['output'];
  withdrawalPaymentId?: Maybe<Scalars['String']['output']>;
  workflowRun?: Maybe<WorkflowRun>;
};


/** Market order for fund transactions (buy, sell, switch) with execution tracking and receipt management */
export type MarketOrderMarketOrderTransactionsListArgs = {
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MarketOrderExportInput = {
  /** Currency code for amount display (e.g. USD, AED) */
  currency?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FiltersExpression>;
  format: ExportFormat;
  language?: Scalars['String']['input'];
  orderBy?: InputMaybe<MarketOrdersListOrderByInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** IANA timezone for date formatting (e.g. Asia/Dubai) */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type MarketOrderFilterOptionsDto = {
  __typename?: 'MarketOrderFilterOptionsDto';
  /** List of distinct fund share classes for filtering */
  fundClasses: Array<Scalars['String']['output']>;
};

export type MarketOrderList = {
  __typename?: 'MarketOrderList';
  count: Scalars['Int']['output'];
  list: Array<MarketOrder>;
};

export enum MarketOrderPurpose {
  AumFeeCollection = 'AUMFeeCollection',
  EmployeeWithdrawal = 'EmployeeWithdrawal'
}

export enum MarketOrderStatus {
  Executed = 'Executed',
  Pending = 'Pending'
}

/** Individual fund transaction within a market order specifying ISIN, units, price, and vesting schedule */
export type MarketOrderTransaction = {
  __typename?: 'MarketOrderTransaction';
  adjustment?: Maybe<Adjustment>;
  benefitEmployeeId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  executedBy?: Maybe<Scalars['ID']['output']>;
  executedByUser?: Maybe<User>;
  /** Holds the amount in AED sold for switch market orders */
  fromCashAmount?: Maybe<Scalars['Decimal']['output']>;
  /** Holds the amount of units to sell for switch market orders */
  fromUnitsAmount?: Maybe<Scalars['Decimal']['output']>;
  /** Holds the target fund id in case the type is Switch. */
  fundIdTarget?: Maybe<Scalars['String']['output']>;
  /** Returns the fund label */
  fundLabel?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  isin?: Maybe<Scalars['String']['output']>;
  /** Holds target ISIN in case of switch market order */
  isinTarget?: Maybe<Scalars['String']['output']>;
  marketOrder: MarketOrder;
  marketOrderId: Scalars['String']['output'];
  productAssignment?: Maybe<ProductAssignment>;
  productAssignmentId?: Maybe<Scalars['ID']['output']>;
  reference: Scalars['String']['output'];
  shareClass?: Maybe<Scalars['String']['output']>;
  state: MarketOrderStatus;
  /** Returns the target fund label (for Switch orders) */
  targetFundLabel?: Maybe<Scalars['JSON']['output']>;
  targetShareClass?: Maybe<Scalars['String']['output']>;
  totalCashAmount?: Maybe<Scalars['Decimal']['output']>;
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitsAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type MarketOrderTransactionList = {
  __typename?: 'MarketOrderTransactionList';
  count: Scalars['Int']['output'];
  list: Array<MarketOrderTransaction>;
};

export type MarketOrderTransactionSummary = {
  __typename?: 'MarketOrderTransactionSummary';
  /** Sum of totalCashAmount across rows */
  totalCashAmount: Scalars['Decimal']['output'];
  /** Sum of fromCashAmount across rows */
  totalFromCashAmount: Scalars['Decimal']['output'];
  /** Sum of fromUnitsAmount across rows */
  totalFromUnitsAmount: Scalars['Decimal']['output'];
  /** Sum of unitsAmount across rows */
  totalUnitsAmount: Scalars['Decimal']['output'];
};

export enum MarketOrderType {
  Buy = 'Buy',
  Sell = 'Sell',
  Switch = 'Switch'
}

/** Columns by which MarketOrdersList can be ordered */
export enum MarketOrdersListOrderByColumn {
  CreatedAt = 'CreatedAt',
  ExecutedAt = 'ExecutedAt',
  Id = 'Id',
  Status = 'Status',
  Type = 'Type',
  UpdatedAt = 'UpdatedAt'
}

export type MarketOrdersListOrderByInput = {
  /** Column name */
  column?: MarketOrdersListOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

/** Who sent the message */
export enum MessageFromEnum {
  Assistant = 'ASSISTANT',
  User = 'USER'
}

export type MessageInput = {
  /** The content of the message */
  content: Scalars['String']['input'];
  /** Assistant mode: GENERAL for chat only, AUREM_AGENT (default) for database operations */
  mode?: InputMaybe<AssistantModeEnum>;
  /** Number of times this message has been retried (0 for original, 1+ for retries) */
  retryCount?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the chat thread to send the message to */
  threadId?: InputMaybe<Scalars['String']['input']>;
};

export type MessageMetadata = AssistantMessageMetadata | UserMessageMetadata;

/** Status of the message processing */
export enum MessageStatusEnum {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

export enum MetadataSourceType {
  File = 'File',
  Url = 'Url'
}

/** MOHRE API response containing companies list and status. */
export type MohreCompaniesResponse = {
  __typename?: 'MohreCompaniesResponse';
  /** List of companies returned from MOHRE. */
  Items: Items;
  /** API response status and message. */
  Response: CompanyResponse;
};

/** MOHRE API response containing a single company and status. */
export type MohreCompany = {
  __typename?: 'MohreCompany';
  /** API response status and message. */
  Response: CompanyResponse;
  /** Detailed company information if found. */
  company?: Maybe<Company>;
};

export enum MohreIdType {
  Eida = 'EIDA',
  Uid = 'UID'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptAttributesCorrections: Scalars['Boolean']['output'];
  acceptEmployeeAttributeCorrection: CrmEmployee;
  acceptEmployeeAttributesCorrections: CrmEmployee;
  acceptEmployeeInvitation: User;
  acceptUserInvitation: Array<UserRole>;
  approveCompanyVerification: CrmCompany;
  approveKycRequest: KycRequest;
  approveProductAssignmentSubscriptionRequests: Array<CrmProductAssignmentSubscriptionRequestEntity>;
  archiveFormTemplate: FormTemplate;
  assignEmployeesToProduct: AssignEmployeesToProductResult;
  assignReviewer: Task;
  assignRole: Array<UserRole>;
  assignTask: Task;
  /** Block a user account, terminating all active sessions */
  blockUser: User;
  /** Cancel a pending user or employee invitation by its ID. Pass isEmployee: true when cancelling an employee invitation. */
  cancelInvitation: UserInvitation;
  cancelKycRequest: KycRequest;
  cancelMessage: ChatMessage;
  changeTaskPriority: Task;
  changeTaskStatus: Task;
  /** Updates workflow status to Draft or Active */
  changeWorkflowStatus: WorkflowDefinition;
  checkWithdrawalEligibility: Scalars['Boolean']['output'];
  /** Allow platform admin to confirm market order transactions */
  confirmMarketOrders: ConfirmMarketOrders;
  /** Manually continues a pending timer node in a workflow run, skipping the remaining timer duration and proceeding immediately to the next node. */
  continueTimerNode: WorkflowRun;
  /** Re-signals Temporal for a workflow run stuck in 'Created', replaying its stored input so the workflow executes from the beginning. */
  continueWorkflowRun: WorkflowRun;
  createAttributesCorrections: Scalars['Boolean']['output'];
  /** Create a new company */
  createCompany: CrmCompany;
  /** Create a new company */
  createCompanyLegacy: CrmCompany;
  /** Creates employee */
  createEmployee: CrmEmployee;
  /** Create a new fee entity (metadata only, no assignments) */
  createFee: Fee;
  /** Create a new fee workflow definition in Draft status and automatically assign it to the specified fee. */
  createFeeWorkflow: WorkflowDefinition;
  createFormTemplate: FormTemplate;
  createHoldingAdjustment: Adjustment;
  createKycRequest: KycRequest;
  createManualTask: Task;
  createMohreOtpForCompany: Scalars['Boolean']['output'];
  createNewTokens: UserAuthResponse;
  createNominee: Nominee;
  /** Creates a new product workflow definition in Draft status and assigns it to the specified product */
  createProductWorkflow: WorkflowDefinition;
  createRole: Role;
  /** Create a new comment on a task */
  createTaskComment: TaskComment;
  createUserBankAccount: UserBankAccount;
  /** Creates a verification request that can be used to underwrite an action (e.g. fund withdrawal, etc.) */
  createVerificationRequest: VerificationRequest;
  /** Delete all notifications for the current user, returns count of deleted notifications */
  deleteAllNotifications: Scalars['Int']['output'];
  deleteCompanyVerificationDocument: CrmCompanyDocument;
  deleteComplianceDocumentType: Scalars['Boolean']['output'];
  deleteCurrentUserSession: Scalars['Boolean']['output'];
  deleteEmployeeDocument: KycRequest;
  deleteEnvironmentDocument: Scalars['Boolean']['output'];
  deleteEnvironmentLogo: EnvironmentConfg;
  /** Delete a fee and its associated workflows and assignments. Workflows are soft-deleted. */
  deleteFee: Scalars['Boolean']['output'];
  /** Soft-delete a fee workflow. The workflow is hidden from queries but data is preserved. */
  deleteFeeWorkflow: Scalars['Boolean']['output'];
  deleteFormTemplate: Scalars['Boolean']['output'];
  deleteFundDocument: Scalars['Boolean']['output'];
  deleteInvoiceParty: Scalars['Boolean']['output'];
  deleteNominee: Scalars['Boolean']['output'];
  deletePaymentAdjustment: Scalars['Boolean']['output'];
  deleteRole: Scalars['Boolean']['output'];
  deleteSamlConfigurationMetadataFile: CrmSamlConfiguration;
  deleteThread: Scalars['Boolean']['output'];
  deleteUserBankAccount: Scalars['Boolean']['output'];
  deleteUserGoal: Scalars['Boolean']['output'];
  destroyEmployeeInvitation: EmployeeInvitation;
  disableMfa: User;
  dismissVerificationStatus: CrmCompany;
  /** Duplicate a fee including its assignments and workflows. The new fee is named "<original> (copy)". */
  duplicateFee: Fee;
  /** Duplicate a fee workflow. Creates a new Draft workflow with the same trigger, nodes, and layout. Barrier node references are cleared. */
  duplicateFeeWorkflow: WorkflowDefinition;
  enableMfa: User;
  escalateTask: Task;
  executeOrder: MarketOrder;
  executeSwitchMarketOrder: MarketOrder;
  /** Abandons a workflow run stuck in 'Created', moving it to 'Exited' without executing any of its nodes. */
  exitWorkflowRun: WorkflowRun;
  /** Start an async employee export workflow. Poll `exportStatus` with the returned workflowId to get the download URL when it's ready. */
  exportEmployees: ExportWorkflowStartResult;
  /** Start an async employer holding positions export workflow */
  exportEmployerHoldings: ExportWorkflowStartResult;
  /** Start an async holding positions export workflow */
  exportHoldings: ExportWorkflowStartResult;
  /** Start an async market order export workflow */
  exportMarketOrders: ExportWorkflowStartResult;
  /** Export payment line items to CSV or XLSX */
  exportPaymentLineItems: ExportResultDto;
  /** Start an async payment export workflow */
  exportPayments: ExportWorkflowStartResult;
  /** Export payment invoices and/or receipts as a zip file. Runs synchronously for <=10 payments, asynchronously via Temporal for >10. */
  exportPaymentsZip: PaymentZipExportResult;
  /** Export the money-in contribution history of a product assignment to CSV or XLSX */
  exportProductAssignmentContributions: ExportResultDto;
  /** Manually triggers the 'Payroll deduction for savings' workflow for a product instance, stamping every generated payment with the selected paymentForMonth. */
  generatePayrollDeductionPayment: WorkflowRun;
  generateSumsubAccessToken: Scalars['String']['output'];
  importMohreEmployees: Scalars['Boolean']['output'];
  importPaymentAdjustments: Scalars['Boolean']['output'];
  inviteAllEmployees: Scalars['Boolean']['output'];
  inviteEmployee: EmployeeInvitation;
  inviteEmployees: Scalars['Boolean']['output'];
  /** Sends invitations to new employees or resends to those with pending invitations */
  inviteOrResendEmployees: Scalars['Boolean']['output'];
  inviteUser: Array<UserInvitation>;
  loginUser: UserAuthResponse;
  loginUserWithGoogleAuthToken: UserAuthResponse;
  loginUserWithGoogleAuthTokenWithAccessToken: UserAuthResponse;
  loginUserWithMfaCode: UserAuthResponse;
  /** Mark all notifications as read, returns count of updated notifications */
  markAllNotificationsAsRead: Scalars['Int']['output'];
  /** Mark a single notification as read */
  markNotificationAsRead: Notification;
  /** Mark a list of notifications as seen in the notification center, returns count of updated notifications */
  markNotificationsAsSeen: Scalars['Int']['output'];
  markPageAsCompleted: Progress;
  /** Mark when the user opened the notification center, used for badge count calculation */
  notificationCenterOpened: Scalars['Boolean']['output'];
  processEmployeeTerminations: Scalars['Boolean']['output'];
  /** Allow sender (e.g. company) to make the payment */
  processPayment: Payment;
  pushAllEmployeesToMohre: Scalars['Boolean']['output'];
  pushEmployerToMohre: Scalars['Boolean']['output'];
  pushIndividualBasicSubscriptionToMohre: Scalars['Boolean']['output'];
  pushIndividualEmployeeToMohre: Scalars['Boolean']['output'];
  pushIndividualPaymentToMohre: Scalars['Boolean']['output'];
  pushOwnerToMohre: Scalars['Boolean']['output'];
  pushSubscriptionToMohre: Scalars['Boolean']['output'];
  redirectUserToIdentityProvider: UserSamlRedirectResponse;
  /** Creates a new verification request if and only if the previous request is either expired or about to expire. */
  refreshVerificationRequest: VerificationRequest;
  /** Regenerate SAML domain DNS record for a company */
  regenerateSamlDomainDnsTxtRecord: CrmSamlConfiguration;
  registerInterest: CrmEmployee;
  registerUser: UserAuthResponse;
  registerUserWithGoogleAuthToken: UserAuthResponse;
  rejectAttributesCorrections: Scalars['Boolean']['output'];
  rejectCompanyVerification: CrmCompany;
  rejectKycRequest: KycRequest;
  /** Remove payment line items from a pending payment. Can either remove specific items or keep only specific items and remove all others. */
  removePaymentLineItems: Payment;
  /** Renames a workflow version */
  renameWorkflowVersion: WorkflowVersion;
  requestCompanyVerificationDocumentsResubmission: CrmCompany;
  requestCompanyVerificationMoreDocuments: CrmCompanyVerification;
  requestEmailUpdate: Scalars['Boolean']['output'];
  requestKycMoreDocuments: KycRequest;
  requestPasswordReset: Scalars['Boolean']['output'];
  /** Re-fires the 'employee_fund_switched' hook for a single product assignment, starting the fund switch workflows exactly as setFund would. Use when the original switch produced no market order (e.g. it ran before the employee had any holdings). Does not modify the employee's selected fund. */
  rerunEmployeeFundSwitch: Array<WorkflowRun>;
  /** Re-runs the daily employee termination job for every employee whose end date is today or earlier. Starts the workflow and returns immediately without waiting for it to finish. */
  rerunEmployeeTerminations: Scalars['Boolean']['output'];
  /** Re-runs a single node within a workflow run by superseding its events (and everything after them) and re-triggering the run from that node. Previous attempts are retained for history. */
  rerunWorkflowNode: WorkflowRun;
  resendEmployeeInvitation: EmployeeInvitation;
  resendVerificationEmail: Scalars['Boolean']['output'];
  resetPassword: UserAuthResponse;
  resolveAttributesCorrections: Scalars['Boolean']['output'];
  resubmitKycRequest: KycRequest;
  /** Update email template */
  revertEmailToDefault: Array<Translation>;
  revokeRole: Scalars['Boolean']['output'];
  /** Manually triggers a workflow run for a specific version with optional context (productInstanceId, etc.) */
  runWorkflow: WorkflowRun;
  /** Manually triggers a git-managed workflow run by its config key with optional context (productInstanceId, etc.). Requires the workflowConfigFeature flag to be enabled for the current tenant. */
  runWorkflowByKey: WorkflowRun;
  saveCompanyVerificationSignatories: CrmCompanyVerification;
  /** Save a fee workflow (creates a new version if trigger/nodes changed, updates layout only if unchanged). */
  saveFeeWorkflow: WorkflowVersion;
  /** Saves product workflow configuration with trigger validation. Creates new version if trigger/nodes changed, updates layout only if unchanged. */
  saveProductWorkflow: WorkflowVersion;
  /** Send a message and get AI response */
  sendMessage: SendMessageResponse;
  /** Sends an email with the OTP in order to authenticate the user for a secured action. */
  sendOtpViaEmail: VerificationRequest;
  sendTestEmail: Scalars['Boolean']['output'];
  /** Sends an email with the OTP to the user that owns this verification request. */
  sendVerificationCode: VerificationRequest;
  /** Updates the current workflow version pointer */
  setCurrentVersion: WorkflowDefinition;
  setFund: ProductAssignment;
  setSalaryContribution: ProductAssignment;
  skipOnboardingStep: CrmCompany;
  submitCompanyDocumentsForVerification: CrmCompany;
  submitIndustryAndVerifyDocumentUploads: CrmCompany;
  submitKycRequestForReview: KycRequest;
  submitUserFatcaForm: User;
  toggleSamlConfiguration: CrmSamlConfiguration;
  /** Allow recipient (e.g. fund provider) to accept or reject the payment */
  transitionPayment: Payment;
  /** Manually trigger a fee workflow. Scope is resolved automatically from the fee assignment. Throws if the fee has no assignment. Returns the run IDs. */
  triggerFeeWorkflow: Array<Scalars['String']['output']>;
  /** Manually trigger a git-managed (config) fee workflow by its config key. Scope is resolved automatically from the fee assignment. Requires the workflowConfigFeature flag to be enabled for the current tenant. Throws if the fee has no assignment. Returns the run IDs. */
  triggerFeeWorkflowByKey: Array<Scalars['String']['output']>;
  /** Unblock a previously blocked user account */
  unblockUser: User;
  /** Update user citizenships for compliance purposes */
  updateCitizenships: User;
  updateCompany: CrmCompany;
  updateCompanyFatcaDetails: CrmCompany;
  updateEmployee: CrmEmployee;
  updateEmployeeBankDetails: Array<CustomEmployeeValue>;
  updateEmployeesPartially: BulkUpsertEmployees;
  updateEnvironmentDocument: EnvironmentDocument;
  updateExpoPushToken: Scalars['Boolean']['output'];
  /** Update fee name and/or description */
  updateFee: Fee;
  /** Update fee assignments. Supports environment-wide (applyAll), company-scoped, and product-scoped assignments.  */
  updateFeeAssignments: Array<FeeAssignment>;
  updateFormTemplate: FormTemplate;
  updateFormTemplateStatus: FormTemplate;
  updateFundDocument: FundDocument;
  updateIban: UserBankAccount;
  updateMohreCompany: CrmCompany;
  updateNominee: Nominee;
  updatePassword: Scalars['Boolean']['output'];
  updatePasswordPolicy: PasswordPolicy;
  updatePreferredLanguage: Profile;
  updateProfileFinancialGoal: Profile;
  updateRole: Role;
  updateTaskTypeDefinition: TaskTypeDefinition;
  updateTaskTypeDescription: TaskTypeDefinition;
  updateThread: ChatThread;
  /** Update translations */
  updateTranslations: Array<Translation>;
  updateUserBankAccount: UserBankAccount;
  /** Update the email address of a user account */
  updateUserEmail: User;
  updateUserRoles: Scalars['Boolean']['output'];
  updateUserTour: UserTour;
  uploadCompanyVerificationDocument: CrmCompanyDocument;
  uploadEmployeeDocument: KycRequest;
  uploadEnvironmentDocument: EnvironmentDocument;
  uploadEnvironmentLogo: EnvironmentConfg;
  uploadFundDocument: FundDocument;
  uploadFundDocumentV2: Attachment;
  upsertCompanyBillingDetails: CrmCompanyBillingDetails;
  upsertComplianceDocumentTypes: Scalars['Boolean']['output'];
  upsertCustomAttributes: Array<CustomAttribute>;
  upsertDocumentTypes: Scalars['Boolean']['output'];
  upsertEmployees: BulkUpsertEmployees;
  upsertEnvironmentConfig: EnvironmentConfg;
  upsertEnvironmentFeatures: FeaturesConfig;
  upsertFirstLogin: Scalars['Boolean']['output'];
  upsertInvoiceParty: InvoiceParty;
  upsertMarketOrderAdjustment: Adjustment;
  upsertPaymentAdjustment: Adjustment;
  /** Upsert a list of payment categories and remove any that are no longer present (platform-only) */
  upsertPaymentCategories: Array<PaymentCategory>;
  upsertProduct: Product;
  upsertProductCustomAttributes: Array<CustomAttribute>;
  upsertProductInstance: UpsertProductInstanceResult;
  upsertProfile: Profile;
  /** Upsert SAML configuration for a company */
  upsertSamlConfiguration: CrmSamlConfiguration;
  upsertSamlConfigurationMetadataFile: CrmSamlConfiguration;
  upsertTradingBankAccount: CrmTradingBankAccount;
  upsertUserGoal: UserGoal;
  validatePassword: Scalars['Boolean']['output'];
  verifyEmail: User;
  /** Verify SAML domain for a company */
  verifySamlDomain: CrmSamlConfiguration;
  withdraw: ProductAssignment;
};


export type MutationAcceptAttributesCorrectionsArgs = {
  attributes: Array<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  resourceType: AttributesCorrectionsResourceType;
};


export type MutationAcceptEmployeeAttributeCorrectionArgs = {
  attribute: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  newValue: Scalars['String']['input'];
};


export type MutationAcceptEmployeeAttributesCorrectionsArgs = {
  companyId: Scalars['String']['input'];
  corrections: Array<EmployeeAttributeCorrectionInput>;
  employeeId: Scalars['String']['input'];
};


export type MutationAcceptEmployeeInvitationArgs = {
  invitationId: Scalars['String']['input'];
};


export type MutationAcceptUserInvitationArgs = {
  invitationId: Scalars['String']['input'];
};


export type MutationApproveCompanyVerificationArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationApproveKycRequestArgs = {
  extractedFields?: InputMaybe<KycExtractedFieldsInput>;
  kycRequestId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  riskRating: Scalars['String']['input'];
};


export type MutationApproveProductAssignmentSubscriptionRequestsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationArchiveFormTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationAssignEmployeesToProductArgs = {
  companyId: Scalars['String']['input'];
  input: AssignEmployeesToProductInput;
};


export type MutationAssignReviewerArgs = {
  reviewerId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationAssignRoleArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['String']['input'];
  usersIds: Array<Scalars['String']['input']>;
};


export type MutationAssignTaskArgs = {
  assigneeId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationBlockUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationCancelInvitationArgs = {
  isEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationCancelKycRequestArgs = {
  kycRequestId: Scalars['String']['input'];
  note: Scalars['String']['input'];
};


export type MutationCancelMessageArgs = {
  messageId: Scalars['String']['input'];
};


export type MutationChangeTaskPriorityArgs = {
  priority: TaskPriority;
  taskId: Scalars['String']['input'];
};


export type MutationChangeTaskStatusArgs = {
  newStatus: TaskStatus;
  taskId: Scalars['String']['input'];
};


export type MutationChangeWorkflowStatusArgs = {
  status: WorkflowDefinitionStatus;
  workflowDefinitionId: Scalars['String']['input'];
};


export type MutationCheckWithdrawalEligibilityArgs = {
  productAssignmentId: Scalars['String']['input'];
};


export type MutationConfirmMarketOrdersArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationContinueTimerNodeArgs = {
  nodeKey: Scalars['String']['input'];
  runId: Scalars['String']['input'];
};


export type MutationContinueWorkflowRunArgs = {
  runId: Scalars['String']['input'];
};


export type MutationCreateAttributesCorrectionsArgs = {
  reportedAttributes: Array<ReportedFieldsInput>;
  resourceId: Scalars['String']['input'];
  resourceType: AttributesCorrectionsResourceType;
};


export type MutationCreateCompanyArgs = {
  company: CreateCompanyInput;
};


export type MutationCreateCompanyLegacyArgs = {
  company: CreateCompanyInput;
};


export type MutationCreateEmployeeArgs = {
  companyId: Scalars['String']['input'];
  employee: EmployeeInput;
};


export type MutationCreateFeeArgs = {
  input: CreateFeeInput;
};


export type MutationCreateFeeWorkflowArgs = {
  input: CreateFeeWorkflowInput;
};


export type MutationCreateFormTemplateArgs = {
  input: FormTemplateInput;
};


export type MutationCreateHoldingAdjustmentArgs = {
  input: CreateHoldingAdjustmentInput;
};


export type MutationCreateKycRequestArgs = {
  employeeId: Scalars['String']['input'];
  requestedVia?: InputMaybe<KycRequestSource>;
};


export type MutationCreateManualTaskArgs = {
  input: CreateTaskInput;
};


export type MutationCreateMohreOtpForCompanyArgs = {
  input: GetMohreCompanyInput;
};


export type MutationCreateNewTokensArgs = {
  clientType?: InputMaybe<Scalars['String']['input']>;
  refreshToken: Scalars['String']['input'];
};


export type MutationCreateNomineeArgs = {
  input: NomineeInput;
  verificationCode: Scalars['String']['input'];
};


export type MutationCreateProductWorkflowArgs = {
  input: CreateProductWorkflowInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateTaskCommentArgs = {
  input: CreateTaskCommentInput;
};


export type MutationCreateUserBankAccountArgs = {
  iban: Scalars['String']['input'];
  nickName?: InputMaybe<Scalars['String']['input']>;
  signature: Scalars['String']['input'];
};


export type MutationCreateVerificationRequestArgs = {
  actionType: VerificationRequestActionType;
};


export type MutationDeleteAllNotificationsArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteCompanyVerificationDocumentArgs = {
  companyId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
};


export type MutationDeleteComplianceDocumentTypeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteEmployeeDocumentArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<KycDocumentType>;
  kycRequestId: Scalars['String']['input'];
};


export type MutationDeleteEnvironmentDocumentArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationDeleteEnvironmentLogoArgs = {
  variant: LogoVariant;
};


export type MutationDeleteFeeArgs = {
  feeId: Scalars['String']['input'];
};


export type MutationDeleteFeeWorkflowArgs = {
  workflowDefinitionId: Scalars['String']['input'];
};


export type MutationDeleteFormTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFundDocumentArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationDeleteInvoicePartyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNomineeArgs = {
  nominee_id: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};


export type MutationDeletePaymentAdjustmentArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  input: DeletePaymentAdjustmentInput;
};


export type MutationDeleteRoleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSamlConfigurationMetadataFileArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationDeleteThreadArgs = {
  threadId: Scalars['ID']['input'];
};


export type MutationDeleteUserBankAccountArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUserGoalArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyEmployeeInvitationArgs = {
  invitationId: Scalars['String']['input'];
};


export type MutationDisableMfaArgs = {
  code: Scalars['String']['input'];
};


export type MutationDismissVerificationStatusArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationDuplicateFeeArgs = {
  feeId: Scalars['String']['input'];
};


export type MutationDuplicateFeeWorkflowArgs = {
  sourceWorkflowId: Scalars['String']['input'];
};


export type MutationEnableMfaArgs = {
  code: Scalars['String']['input'];
};


export type MutationEscalateTaskArgs = {
  taskId: Scalars['String']['input'];
};


export type MutationExecuteOrderArgs = {
  executedAt: Scalars['String']['input'];
  marketOrderId: Scalars['String']['input'];
  receipt: Scalars['Upload']['input'];
  unitPrice: Scalars['Decimal']['input'];
};


export type MutationExecuteSwitchMarketOrderArgs = {
  executedAt: Scalars['String']['input'];
  fromUnitPrice: Scalars['Decimal']['input'];
  marketOrderId: Scalars['String']['input'];
  receipt: Scalars['Upload']['input'];
  receiptFrom: Scalars['Upload']['input'];
  unitPrice: Scalars['Decimal']['input'];
};


export type MutationExitWorkflowRunArgs = {
  runId: Scalars['String']['input'];
};


export type MutationExportEmployeesArgs = {
  input: EmployeeExportInput;
};


export type MutationExportEmployerHoldingsArgs = {
  input: EmployerHoldingExportInput;
};


export type MutationExportHoldingsArgs = {
  input: HoldingExportInput;
};


export type MutationExportMarketOrdersArgs = {
  input: MarketOrderExportInput;
};


export type MutationExportPaymentLineItemsArgs = {
  input: PaymentLineItemsExportInput;
};


export type MutationExportPaymentsArgs = {
  input: PaymentExportInput;
};


export type MutationExportPaymentsZipArgs = {
  input: PaymentZipExportInput;
};


export type MutationExportProductAssignmentContributionsArgs = {
  input: ExportProductAssignmentContributionsInput;
};


export type MutationGeneratePayrollDeductionPaymentArgs = {
  paymentForMonth: Scalars['String']['input'];
  productInstanceId: Scalars['String']['input'];
};


export type MutationGenerateSumsubAccessTokenArgs = {
  kycRequestId: Scalars['String']['input'];
};


export type MutationImportMohreEmployeesArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationImportPaymentAdjustmentsArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  input: ImportPaymentAdjustmentsInput;
};


export type MutationInviteAllEmployeesArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationInviteEmployeeArgs = {
  companyId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
};


export type MutationInviteEmployeesArgs = {
  companyId: Scalars['String']['input'];
  employeeIds: Array<Scalars['String']['input']>;
};


export type MutationInviteOrResendEmployeesArgs = {
  input: InviteOrResendEmployeesInput;
};


export type MutationInviteUserArgs = {
  payload: InviteUsersInput;
};


export type MutationLoginUserArgs = {
  clientType?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLoginUserWithGoogleAuthTokenArgs = {
  clientType?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationLoginUserWithGoogleAuthTokenWithAccessTokenArgs = {
  accessToken: Scalars['String']['input'];
  clientType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLoginUserWithMfaCodeArgs = {
  clientType?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationMarkAllNotificationsAsReadArgs = {
  input?: InputMaybe<MarkAllNotificationsReadInput>;
};


export type MutationMarkNotificationAsReadArgs = {
  input: MarkNotificationReadInput;
};


export type MutationMarkNotificationsAsSeenArgs = {
  input: MarkNotificationsSeenInput;
};


export type MutationMarkPageAsCompletedArgs = {
  page: ProgressPageName;
  progress: Scalars['Int']['input'];
};


export type MutationProcessPaymentArgs = {
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  paymentId: Scalars['String']['input'];
};


export type MutationPushAllEmployeesToMohreArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationPushEmployerToMohreArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationPushIndividualBasicSubscriptionToMohreArgs = {
  employeeId: Scalars['String']['input'];
};


export type MutationPushIndividualEmployeeToMohreArgs = {
  employeeId: Scalars['String']['input'];
};


export type MutationPushIndividualPaymentToMohreArgs = {
  paymentId: Scalars['String']['input'];
};


export type MutationPushOwnerToMohreArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationPushSubscriptionToMohreArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationRedirectUserToIdentityProviderArgs = {
  email: Scalars['String']['input'];
  routeAfterAuth?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRefreshVerificationRequestArgs = {
  actionType: VerificationRequestActionType;
  verificationRequestId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegenerateSamlDomainDnsTxtRecordArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationRegisterInterestArgs = {
  employeeId: Scalars['String']['input'];
  product: EmployeeProductInterest;
};


export type MutationRegisterUserArgs = {
  clientType?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  invitationId?: InputMaybe<Scalars['String']['input']>;
  isEmployee: Scalars['Boolean']['input'];
  password: Scalars['String']['input'];
};


export type MutationRegisterUserWithGoogleAuthTokenArgs = {
  clientType?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationRejectAttributesCorrectionsArgs = {
  attributes: Array<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  resourceType: AttributesCorrectionsResourceType;
};


export type MutationRejectCompanyVerificationArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationRejectKycRequestArgs = {
  kycRequestId: Scalars['String']['input'];
  note: Scalars['String']['input'];
};


export type MutationRemovePaymentLineItemsArgs = {
  keepOnlySelected?: Scalars['Boolean']['input'];
  lineItemIds: Array<Scalars['String']['input']>;
  paymentId: Scalars['String']['input'];
};


export type MutationRenameWorkflowVersionArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  versionId: Scalars['String']['input'];
};


export type MutationRequestCompanyVerificationDocumentsResubmissionArgs = {
  companyDocumentIds: Array<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestCompanyVerificationMoreDocumentsArgs = {
  companyId: Scalars['String']['input'];
  requestCompanyDocuments: Array<Scalars['String']['input']>;
  requestSignatoryDocuments?: InputMaybe<Array<Scalars['String']['input']>>;
  signatories?: InputMaybe<Array<SignatoryInput>>;
};


export type MutationRequestEmailUpdateArgs = {
  newEmail: Scalars['String']['input'];
};


export type MutationRequestKycMoreDocumentsArgs = {
  kycRequestId: Scalars['String']['input'];
  requestDocuments: Array<Scalars['String']['input']>;
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationRerunEmployeeFundSwitchArgs = {
  input: SetFundInput;
};


export type MutationRerunWorkflowNodeArgs = {
  nodeKey: Scalars['String']['input'];
  runId: Scalars['String']['input'];
};


export type MutationResendEmployeeInvitationArgs = {
  invitationId: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  clientType?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};


export type MutationResolveAttributesCorrectionsArgs = {
  attributes: Array<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  resourceType: AttributesCorrectionsResourceType;
};


export type MutationResubmitKycRequestArgs = {
  documentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  documentTypes: Array<KycDocumentType>;
  kycRequestId: Scalars['String']['input'];
  note: Scalars['String']['input'];
};


export type MutationRevertEmailToDefaultArgs = {
  type: Scalars['String']['input'];
};


export type MutationRevokeRoleArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['String']['input'];
  usersIds: Array<Scalars['String']['input']>;
};


export type MutationRunWorkflowArgs = {
  context?: InputMaybe<Scalars['JSON']['input']>;
  hookInput?: InputMaybe<WorkflowHookInput>;
  workflowVersionId: Scalars['String']['input'];
};


export type MutationRunWorkflowByKeyArgs = {
  context?: InputMaybe<Scalars['JSON']['input']>;
  hookInput?: InputMaybe<WorkflowHookInput>;
  workflowKey: WorkflowKey;
};


export type MutationSaveCompanyVerificationSignatoriesArgs = {
  companyId: Scalars['String']['input'];
  signatories: Array<SignatoryInput>;
};


export type MutationSaveFeeWorkflowArgs = {
  input: SaveWorkflowInput;
};


export type MutationSaveProductWorkflowArgs = {
  input: SaveWorkflowInput;
};


export type MutationSendMessageArgs = {
  input: MessageInput;
};


export type MutationSendOtpViaEmailArgs = {
  actionType: VerificationRequestActionType;
};


export type MutationSendTestEmailArgs = {
  emails: Array<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type MutationSendVerificationCodeArgs = {
  verificationRequestId: Scalars['String']['input'];
};


export type MutationSetCurrentVersionArgs = {
  versionId: Scalars['String']['input'];
  workflowDefinitionId: Scalars['String']['input'];
};


export type MutationSetFundArgs = {
  input: SetFundInput;
  verificationCode: Scalars['String']['input'];
};


export type MutationSetSalaryContributionArgs = {
  input: SetSalaryContributionInput;
  verificationCode: Scalars['String']['input'];
};


export type MutationSkipOnboardingStepArgs = {
  companyId: Scalars['String']['input'];
  onboardingStep: Scalars['String']['input'];
};


export type MutationSubmitCompanyDocumentsForVerificationArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationSubmitIndustryAndVerifyDocumentUploadsArgs = {
  companyId: Scalars['String']['input'];
  industry?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitKycRequestForReviewArgs = {
  kycRequestId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitUserFatcaFormArgs = {
  data: Scalars['JSON']['input'];
};


export type MutationToggleSamlConfigurationArgs = {
  companyId: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
};


export type MutationTransitionPaymentArgs = {
  paymentId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
};


export type MutationTriggerFeeWorkflowArgs = {
  workflowDefinitionId: Scalars['String']['input'];
};


export type MutationTriggerFeeWorkflowByKeyArgs = {
  workflowKey: FeeWorkflowKey;
};


export type MutationUnblockUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationUpdateCitizenshipsArgs = {
  citizenships: Array<Scalars['String']['input']>;
};


export type MutationUpdateCompanyArgs = {
  category: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  update: UpdateCompanyInput;
};


export type MutationUpdateCompanyFatcaDetailsArgs = {
  companyId: Scalars['String']['input'];
  input: CompanyFatcaFormSubmissionInput;
};


export type MutationUpdateEmployeeArgs = {
  category: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  employee: EmployeeInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateEmployeeBankDetailsArgs = {
  input: UpdateEmployeeBankDetailsInput;
};


export type MutationUpdateEmployeesPartiallyArgs = {
  companyId: Scalars['String']['input'];
  employees: Array<EmployeePartialInput>;
};


export type MutationUpdateEnvironmentDocumentArgs = {
  documentId: Scalars['String']['input'];
  fileInputs: Array<FileLanguageInput>;
  languages: Array<Scalars['String']['input']>;
  titles: Scalars['JSONObject']['input'];
  type?: InputMaybe<EnvironmentDocumentType>;
};


export type MutationUpdateExpoPushTokenArgs = {
  expoPushToken: Scalars['String']['input'];
};


export type MutationUpdateFeeArgs = {
  input: UpdateFeeInput;
};


export type MutationUpdateFeeAssignmentsArgs = {
  input: UpdateFeeAssignmentsInput;
};


export type MutationUpdateFormTemplateArgs = {
  id: Scalars['String']['input'];
  input: FormTemplateUpdateInput;
};


export type MutationUpdateFormTemplateStatusArgs = {
  id: Scalars['String']['input'];
  status: FormTemplateStatus;
};


export type MutationUpdateFundDocumentArgs = {
  documentId: Scalars['String']['input'];
  fileInputs: Array<FileLanguageInput>;
  languages: Array<Scalars['String']['input']>;
  titles: Scalars['JSONObject']['input'];
};


export type MutationUpdateIbanArgs = {
  employmentId?: InputMaybe<Scalars['String']['input']>;
  iban: Scalars['String']['input'];
  productAssignmentId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMohreCompanyArgs = {
  category: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  update: UpdateMohreCompanyInput;
};


export type MutationUpdateNomineeArgs = {
  input: NomineeInput;
  nominee_id: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};


export type MutationUpdatePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationUpdatePasswordPolicyArgs = {
  input: PasswordPolicyInput;
};


export type MutationUpdatePreferredLanguageArgs = {
  language: Scalars['String']['input'];
};


export type MutationUpdateProfileFinancialGoalArgs = {
  financialGoal: Scalars['Decimal']['input'];
};


export type MutationUpdateRoleArgs = {
  id: Scalars['String']['input'];
  input: UpdateRoleInput;
};


export type MutationUpdateTaskTypeDefinitionArgs = {
  input: UpdateTaskTypeDefinitionInput;
  resourceType: TaskResourceType;
};


export type MutationUpdateTaskTypeDescriptionArgs = {
  input: UpdateTaskDescriptionInput;
  resourceType: TaskResourceType;
};


export type MutationUpdateThreadArgs = {
  input: UpdateThreadInput;
};


export type MutationUpdateTranslationsArgs = {
  input: UpdateTranslationsInput;
};


export type MutationUpdateUserBankAccountArgs = {
  iban: Scalars['String']['input'];
  id: Scalars['String']['input'];
  nickName?: InputMaybe<Scalars['String']['input']>;
  signature: Scalars['String']['input'];
};


export type MutationUpdateUserEmailArgs = {
  email: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateUserRolesArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  roleIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationUpdateUserTourArgs = {
  input: UpdateUserTourInput;
};


export type MutationUploadCompanyVerificationDocumentArgs = {
  companyId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationUploadEmployeeDocumentArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<KycDocumentType>;
  file: Scalars['Upload']['input'];
  kycRequestId: Scalars['String']['input'];
};


export type MutationUploadEnvironmentDocumentArgs = {
  environmentId: Scalars['String']['input'];
  files: Array<Scalars['Upload']['input']>;
  languages: Array<Scalars['String']['input']>;
  titles: Scalars['JSONObject']['input'];
  type?: InputMaybe<EnvironmentDocumentType>;
};


export type MutationUploadEnvironmentLogoArgs = {
  logo: Scalars['Upload']['input'];
  variant: LogoVariant;
};


export type MutationUploadFundDocumentArgs = {
  files: Array<Scalars['Upload']['input']>;
  fundId: Scalars['String']['input'];
  languages: Array<Scalars['String']['input']>;
  titles: Scalars['JSONObject']['input'];
};


export type MutationUploadFundDocumentV2Args = {
  file: Scalars['Upload']['input'];
};


export type MutationUpsertCompanyBillingDetailsArgs = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  trn?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertComplianceDocumentTypesArgs = {
  complianceType: ComplianceType;
  documentFrom?: InputMaybe<ComplianceDocumentFrom>;
  documentTypesList: Array<SaveComplianceDocumentTypeInput>;
};


export type MutationUpsertCustomAttributesArgs = {
  category: Scalars['String']['input'];
  customAttributes: Array<UpsertCustomAttributeInput>;
};


export type MutationUpsertDocumentTypesArgs = {
  documentTypesList: Array<SaveDocumentTypeInput>;
  type: CompanyDocumentFrom;
};


export type MutationUpsertEmployeesArgs = {
  companyId: Scalars['String']['input'];
  employees: Array<EmployeeInput>;
};


export type MutationUpsertEnvironmentConfigArgs = {
  data: EnvironmentConfigInput;
};


export type MutationUpsertEnvironmentFeaturesArgs = {
  features: FeaturesConfigInput;
};


export type MutationUpsertFirstLoginArgs = {
  value: Scalars['Boolean']['input'];
};


export type MutationUpsertInvoicePartyArgs = {
  input: UpsertInvoicePartyInput;
};


export type MutationUpsertMarketOrderAdjustmentArgs = {
  input: UpsertMarketOrderAdjustmentInput;
};


export type MutationUpsertPaymentAdjustmentArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  input: UpsertPaymentAdjustmentInput;
};


export type MutationUpsertPaymentCategoriesArgs = {
  categories: Array<UpsertPaymentCategoryInput>;
};


export type MutationUpsertProductArgs = {
  input: UpsertProductInput;
};


export type MutationUpsertProductCustomAttributesArgs = {
  category: Scalars['String']['input'];
  customAttributes: Array<UpsertCustomAttributeInput>;
  productId: Scalars['String']['input'];
};


export type MutationUpsertProductInstanceArgs = {
  companyId: Scalars['String']['input'];
  input: UpsertProductInstanceInput;
  productId: Scalars['String']['input'];
};


export type MutationUpsertProfileArgs = {
  input: ProfileInput;
  skipNotification?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpsertSamlConfigurationArgs = {
  companyId: Scalars['String']['input'];
  samlConfiguration: UpsertSamlConfigurationInput;
};


export type MutationUpsertSamlConfigurationMetadataFileArgs = {
  companyId: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationUpsertTradingBankAccountArgs = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  bankLocation: Scalars['String']['input'];
  bankName: Scalars['String']['input'];
  branchAddress?: InputMaybe<Scalars['String']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  iban: Scalars['String']['input'];
  swift?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertUserGoalArgs = {
  goalId?: InputMaybe<Scalars['String']['input']>;
  input: UserGoalInput;
};


export type MutationValidatePasswordArgs = {
  password: Scalars['String']['input'];
};


export type MutationVerifyEmailArgs = {
  verificationId: Scalars['String']['input'];
};


export type MutationVerifySamlDomainArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationWithdrawArgs = {
  input: WithdrawInput;
  verificationCode: Scalars['String']['input'];
};

/** New translation input */
export type NewTranslation = {
  __typename?: 'NewTranslation';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type NewTranslationInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Beneficiary nominee designated by user with relationship, allocation percentage, and personal details */
export type Nominee = {
  __typename?: 'Nominee';
  createdAt: Scalars['DateTime']['output'];
  customNomineeValues: Array<CustomNomineeValue>;
  dateOfBirth: Scalars['Date']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  mobileNumber: Scalars['String']['output'];
  percentAllotted: Scalars['Float']['output'];
  relation: NomineeRelation;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type NomineeInput = {
  /** Custom attributes for the nominee, if any. */
  customAttributes?: InputMaybe<Array<CustomAttributeInput>>;
  /** Nominee's date of birth. */
  dateOfBirth: Scalars['Date']['input'];
  /** Nominee's first name. */
  firstName: Scalars['String']['input'];
  /** Nominee's last name. */
  lastName: Scalars['String']['input'];
  /** Nominee's mobile phone number. */
  mobileNumber: Scalars['String']['input'];
  /** Percentage of benefit allotted to the nominee. */
  percentAllotted: Scalars['Float']['input'];
  /** Relationship of the nominee to the user. */
  relation: NomineeRelation;
};

export enum NomineeRelation {
  Child = 'Child',
  Other = 'Other',
  Parent = 'Parent',
  Sibling = 'Sibling',
  Spouse = 'Spouse'
}

/** Persistent notification stored in the database for user display and tracking */
export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['DateTime']['output'];
  /** Notification payload including title, body, and optional metadata */
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  notifiable?: Maybe<User>;
  notifiableId: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the notification became visible to the user in the notification center */
  seenAt?: Maybe<Scalars['DateTime']['output']>;
  /** Notification class name (e.g., BenefitAssignedNotification) */
  type: Scalars['String']['output'];
};

export type NotificationList = {
  __typename?: 'NotificationList';
  count: Scalars['Int']['output'];
  list: Array<Notification>;
};

export enum OnboardingStepStatus {
  Completed = 'Completed',
  Pending = 'Pending',
  Skipped = 'Skipped'
}

export enum Operation {
  Eq = 'EQ',
  Ge = 'GE',
  Gt = 'GT',
  Ilike = 'ILIKE',
  In = 'IN',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  Le = 'LE',
  Like = 'LIKE',
  Lt = 'LT',
  Neq = 'NEQ'
}

export enum Operator {
  And = 'AND',
  Or = 'OR'
}

export type OrderByInput = {
  /** Column name */
  column?: Scalars['String']['input'];
  /** Direction 'asc' or 'desc' */
  direction?: Scalars['String']['input'];
};

/** Outbound synchronisation record for external systems */
export type Outbound = {
  __typename?: 'Outbound';
  /** External connector (e.g., Mohre) */
  connector: OutboundConnector;
  /** Timestamp when the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the related entity */
  entityId?: Maybe<Scalars['String']['output']>;
  /** Type of the related entity */
  entityType?: Maybe<Scalars['String']['output']>;
  /** External system ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the outbound record */
  id: Scalars['ID']['output'];
  /** Additional metadata */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Current sync status */
  status: OutboundStatus;
  /** Type of the outbound record */
  type: Scalars['String']['output'];
  /** Timestamp when the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** External connector for outbound records */
export enum OutboundConnector {
  Apex = 'Apex',
  Mohre = 'Mohre',
  Scb = 'Scb'
}

/** Log of outbound API requests to external systems */
export type OutboundLog = {
  __typename?: 'OutboundLog';
  /** External connector (e.g., Mohre) */
  connector: Scalars['String']['output'];
  /** Timestamp when the log was created */
  createdAt: Scalars['DateTime']['output'];
  /** Request payload data */
  data?: Maybe<Scalars['String']['output']>;
  /** Destination of the outbound request */
  destination?: Maybe<OutboundLogDestination>;
  /** HTTP method (Put, Post, Delete) */
  endpoint: Scalars['String']['output'];
  /** ID of the related entity */
  entityId?: Maybe<Scalars['String']['output']>;
  /** Type of the related entity */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Error message if failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the outbound log */
  id: Scalars['ID']['output'];
  /** ID of the parent outbound record */
  outboundId?: Maybe<Scalars['String']['output']>;
  /** Response from the external system */
  response?: Maybe<Scalars['String']['output']>;
  /** Number of retry attempts */
  retryCount: Scalars['Int']['output'];
  /** Status of the outbound request */
  status: Scalars['String']['output'];
  /** Temporal workflow ID if triggered by a workflow */
  temporalWorkflowId?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the log was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** URL of the outbound request */
  url?: Maybe<Scalars['String']['output']>;
};

/** Destination of the outbound request */
export enum OutboundLogDestination {
  ApexSftp = 'ApexSFTP',
  MohreAddEmployeeInbound = 'MohreAddEmployeeInbound',
  MohreGenerateOAuthToken = 'MohreGenerateOAuthToken',
  MohreGetAccessToken = 'MohreGetAccessToken',
  MohreGetCompanies = 'MohreGetCompanies',
  MohreGetCompany = 'MohreGetCompany',
  MohreGetEmployees = 'MohreGetEmployees',
  MohreSubmitEmployee = 'MohreSubmitEmployee',
  MohreSubmitEmployer = 'MohreSubmitEmployer',
  MohreSubmitNominee = 'MohreSubmitNominee',
  MohreSubmitOwner = 'MohreSubmitOwner',
  MohreSubmitPayment = 'MohreSubmitPayment',
  MohreSubmitSubscription = 'MohreSubmitSubscription',
  MohreSubmitWithdrawal = 'MohreSubmitWithdrawal',
  MohreUpdateCompanyInbound = 'MohreUpdateCompanyInbound',
  MohreUpdateEmployeeInbound = 'MohreUpdateEmployeeInbound',
  ScbCreateVirtualAccount = 'ScbCreateVirtualAccount',
  ScbPollVirtualAccount = 'ScbPollVirtualAccount',
  ScbSftp = 'ScbSFTP'
}

/** Status of the outbound record */
export enum OutboundStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Synced = 'Synced',
  Updating = 'Updating'
}

export type PaginatedEmployeeStatements = {
  __typename?: 'PaginatedEmployeeStatements';
  count: Scalars['Int']['output'];
  list: Array<EmployeeStatementObject>;
};

export type Pagination = {
  /** Count of entities per one chunk */
  limit?: Scalars['Int']['input'];
  /** Offset */
  offset?: Scalars['Int']['input'];
};

/** Password security rules including complexity, length, and expiration requirements */
export type PasswordPolicy = {
  __typename?: 'PasswordPolicy';
  disallowPreviousPasswords: Scalars['Boolean']['output'];
  forceResetDays?: Maybe<Scalars['Int']['output']>;
  forceResetEnabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  maxLength: Scalars['Int']['output'];
  minLength: Scalars['Int']['output'];
  rejectCommon: Scalars['Boolean']['output'];
  requireLowercase: Scalars['Boolean']['output'];
  requireNumber: Scalars['Boolean']['output'];
  requireSymbol: Scalars['Boolean']['output'];
  requireUppercase: Scalars['Boolean']['output'];
};

export type PasswordPolicyInput = {
  disallowPreviousPasswords?: InputMaybe<Scalars['Boolean']['input']>;
  forceResetDays?: InputMaybe<Scalars['Int']['input']>;
  forceResetEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  minLength?: InputMaybe<Scalars['Int']['input']>;
  rejectCommon?: InputMaybe<Scalars['Boolean']['input']>;
  requireLowercase?: InputMaybe<Scalars['Boolean']['input']>;
  requireNumber?: InputMaybe<Scalars['Boolean']['input']>;
  requireSymbol?: InputMaybe<Scalars['Boolean']['input']>;
  requireUppercase?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Payment transaction between sender and recipient tracking status, line items, and attachments */
export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Decimal']['output'];
  attachments: Array<Attachment>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  /** Resolves the fee name for fee payments by tracing through the workflow chain. */
  feeName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceConfig?: Maybe<InvoiceConfig>;
  invoiceFilename?: Maybe<Scalars['String']['output']>;
  invoiceSize?: Maybe<Scalars['String']['output']>;
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  /** Returns payment line items with pagination support. Defaults to recent first. */
  lineItems: PaymentLineItemList;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  paymentMethod: PaymentMethod;
  /** Resolves the product instance for this payment by tracing through line items to the product assignment. */
  productInstance?: Maybe<ProductInstance>;
  purpose?: Maybe<PaymentPurpose>;
  recipientId: Scalars['String']['output'];
  /** Resolves the display name of the recipient entity for this payment. */
  recipientName: Scalars['String']['output'];
  recipientType: SenderRecipientType;
  runId?: Maybe<Scalars['String']['output']>;
  senderId: Scalars['String']['output'];
  /** Resolves the display name of the sender entity for this payment. */
  senderName: Scalars['String']['output'];
  senderType: SenderRecipientType;
  status: PaymentStatus;
  statusHistory: Array<PaymentStatusHistory>;
  updatedAt: Scalars['DateTime']['output'];
  workflowRun?: Maybe<WorkflowRun>;
};


/** Payment transaction between sender and recipient tracking status, line items, and attachments */
export type PaymentLineItemsArgs = {
  filters?: InputMaybe<FiltersExpression>;
  pagination?: InputMaybe<Pagination>;
};

export type PaymentAdjustmentRow = {
  amount: Scalars['Decimal']['input'];
  categoryName: Scalars['String']['input'];
  employeeNationalId: Scalars['String']['input'];
  reasonText?: InputMaybe<Scalars['String']['input']>;
  reasonType: AdjustmentReasonType;
};

export type PaymentCategory = {
  __typename?: 'PaymentCategory';
  adjustable: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  title: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentCompanyOption = {
  __typename?: 'PaymentCompanyOption';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PaymentDateRange = {
  __typename?: 'PaymentDateRange';
  /** Maximum date in the range */
  max: Scalars['DateTime']['output'];
  /** Minimum date in the range */
  min: Scalars['DateTime']['output'];
};

export type PaymentDecimalRange = {
  __typename?: 'PaymentDecimalRange';
  /** Maximum value in the range */
  max: Scalars['Decimal']['output'];
  /** Minimum value in the range */
  min: Scalars['Decimal']['output'];
};

export type PaymentExportInput = {
  /** Target currency code for amount conversion (e.g. USD, EUR) */
  currency?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FiltersExpression>;
  format: ExportFormat;
  language?: Scalars['String']['input'];
  orderBy?: InputMaybe<PaymentsListOrderByInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** IANA timezone for date formatting (e.g. Asia/Dubai) */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentFilterOptions = {
  __typename?: 'PaymentFilterOptions';
  /** Min/max total amount range across payments */
  amountRange?: Maybe<PaymentDecimalRange>;
  /** Distinct company id+name pairs for filtering */
  companies: Array<PaymentCompanyOption>;
  /** Distinct currency codes for filtering */
  currencies: Array<Scalars['String']['output']>;
  /** Min/max issue date range across payments */
  issueDateRange?: Maybe<PaymentDateRange>;
  /** Distinct product instances linked to payments */
  products: Array<PaymentProductOption>;
};

export type PaymentLedger = {
  __typename?: 'PaymentLedger';
  count: Scalars['Int']['output'];
  list: Array<PaymentLedgerEntry>;
};

export enum PaymentLedgerDirection {
  In = 'In',
  Out = 'Out'
}

export type PaymentLedgerEntry = {
  __typename?: 'PaymentLedgerEntry';
  /** Amount of the payment for this ledger entry */
  amount: Scalars['Decimal']['output'];
  /** Category for the payment (e.g. contributions, withdrawals) */
  category: PaymentCategory;
  /** Timestamp when the ledger entry was created */
  createdAt: Scalars['DateTime']['output'];
  /** Direction of the payment: In (credit) or Out (debit) */
  direction: PaymentLedgerDirection;
  /** Unique identifier for the payment ledger entry */
  id: Scalars['ID']['output'];
  /** Status of the ledger entry: Pending or Completed */
  status?: Maybe<PaymentLedgerStatus>;
};

export enum PaymentLedgerSortKey {
  Amount = 'Amount',
  CreatedAt = 'CreatedAt',
  Status = 'Status',
  Type = 'Type'
}

export enum PaymentLedgerStatus {
  Completed = 'Completed',
  Pending = 'Pending',
  Processing = 'Processing'
}

/** Individual line item within a payment linking to source entity (product assignment or company) with category and amount */
export type PaymentLineItem = {
  __typename?: 'PaymentLineItem';
  adjustment?: Maybe<Adjustment>;
  /** Amount for this payment line item */
  amount: Scalars['Decimal']['output'];
  category?: Maybe<PaymentCategory>;
  categoryId?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the line item was created */
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSONObject']['output']>;
  /** Unique identifier for the payment line item */
  id: Scalars['ID']['output'];
  /** Parent payment entity associated with this line item */
  payment: Payment;
  /** ID of the parent payment for this line item */
  paymentId: Scalars['String']['output'];
  /** ID of the source entity (e.g. product assignment) for this line item */
  sourceId: Scalars['String']['output'];
  /** Resolves the display name of the source entity for this payment line item. */
  sourceName: Scalars['String']['output'];
  /** Type of the source entity for this line item */
  sourceType: PaymentLineItemSourceType;
};

export type PaymentLineItemList = {
  __typename?: 'PaymentLineItemList';
  count: Scalars['Int']['output'];
  list: Array<PaymentLineItem>;
};

export enum PaymentLineItemSourceType {
  ProductAssignmentEntity = 'ProductAssignmentEntity'
}

export type PaymentLineItemsExportInput = {
  companyId: Scalars['String']['input'];
  filters?: InputMaybe<FiltersExpression>;
  format: ExportFormat;
  language?: Scalars['String']['input'];
  lineItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentId: Scalars['String']['input'];
};

export type PaymentList = {
  __typename?: 'PaymentList';
  count: Scalars['Int']['output'];
  list: Array<Payment>;
  totalAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  details: BankTransferDetails;
  type: PaymentMethodType;
};

export enum PaymentMethodType {
  BankTransfer = 'BANK_TRANSFER'
}

export type PaymentProductOption = {
  __typename?: 'PaymentProductOption';
  /** Product instance ID */
  id: Scalars['String']['output'];
  /** Product instance name */
  name: Scalars['String']['output'];
};

export enum PaymentPurpose {
  Adjustment = 'Adjustment',
  Contribution = 'Contribution',
  Fee = 'Fee',
  Withdrawal = 'Withdrawal'
}

export enum PaymentStatus {
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  Pending = 'Pending',
  Processing = 'Processing',
  Settled = 'Settled'
}

/** Audit trail of payment status changes with timestamps and optional reason descriptions */
export type PaymentStatusHistory = {
  __typename?: 'PaymentStatusHistory';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  payment: Payment;
  paymentId: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  status: PaymentStatus;
};

/** Content type for zip export */
export enum PaymentZipContentType {
  Invoices = 'INVOICES',
  Receipts = 'RECEIPTS'
}

export type PaymentZipExportInput = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  contentType: PaymentZipContentType;
  filters?: InputMaybe<FiltersExpression>;
  paymentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentZipExportResult = {
  __typename?: 'PaymentZipExportResult';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  workflowId?: Maybe<Scalars['String']['output']>;
};

/** Columns by which PaymentsList can be ordered */
export enum PaymentsListOrderByColumn {
  Amount = 'Amount',
  CreatedAt = 'CreatedAt',
  Id = 'Id',
  UpdatedAt = 'UpdatedAt'
}

export type PaymentsListOrderByInput = {
  /** Column name */
  column?: PaymentsListOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

/** List of available permissions */
export enum PermissionEnum {
  BlockUser = 'BLOCK_USER',
  CreateBenefit = 'CREATE_BENEFIT',
  CreateCompany = 'CREATE_COMPANY',
  CreateCompanyPayment = 'CREATE_COMPANY_PAYMENT',
  CreateEmployee = 'CREATE_EMPLOYEE',
  CreateEmployeeInvitation = 'CREATE_EMPLOYEE_INVITATION',
  CreateKybTask = 'CREATE_KYB_TASK',
  CreateRole = 'CREATE_ROLE',
  DeleteBenefit = 'DELETE_BENEFIT',
  DeleteRole = 'DELETE_ROLE',
  EditCompanyTradingBankAccount = 'EDIT_COMPANY_TRADING_BANK_ACCOUNT',
  ListCompany = 'LIST_COMPANY',
  ListEmployee = 'LIST_EMPLOYEE',
  ListRole = 'LIST_ROLE',
  MakeFundProviderPayment = 'MAKE_FUND_PROVIDER_PAYMENT',
  ManageAiAssistant = 'MANAGE_AI_ASSISTANT',
  ManageAuthenticationPolicy = 'MANAGE_AUTHENTICATION_POLICY',
  ManageBenefit = 'MANAGE_BENEFIT',
  ManageBranding = 'MANAGE_BRANDING',
  ManageCompanyDocumentType = 'MANAGE_COMPANY_DOCUMENT_TYPE',
  ManageCompanyPayment = 'MANAGE_COMPANY_PAYMENT',
  ManageDocument = 'MANAGE_DOCUMENT',
  ManageEngineRequest = 'MANAGE_ENGINE_REQUEST',
  ManageFees = 'MANAGE_FEES',
  ManageForms = 'MANAGE_FORMS',
  ManageHoldingAdjustment = 'MANAGE_HOLDING_ADJUSTMENT',
  ManageInternal = 'MANAGE_INTERNAL',
  ManageKybTask = 'MANAGE_KYB_TASK',
  ManageKycTask = 'MANAGE_KYC_TASK',
  ManageMarketOrderAdjustment = 'MANAGE_MARKET_ORDER_ADJUSTMENT',
  ManagePasswordPolicy = 'MANAGE_PASSWORD_POLICY',
  ManagePaymentAdjustment = 'MANAGE_PAYMENT_ADJUSTMENT',
  ManagePaymentCategories = 'MANAGE_PAYMENT_CATEGORIES',
  ManageProduct = 'MANAGE_PRODUCT',
  ManageSupportTools = 'MANAGE_SUPPORT_TOOLS',
  ManageTasks = 'MANAGE_TASKS',
  ManageTranslation = 'MANAGE_TRANSLATION',
  ManageUser = 'MANAGE_USER',
  ManageWithdrawal = 'MANAGE_WITHDRAWAL',
  ManageWorkflow = 'MANAGE_WORKFLOW',
  UpdateBenefit = 'UPDATE_BENEFIT',
  UpdateCompany = 'UPDATE_COMPANY',
  UpdateEmployee = 'UPDATE_EMPLOYEE',
  UpdateMarketOrder = 'UPDATE_MARKET_ORDER',
  UpdateRole = 'UPDATE_ROLE',
  UpdateUserEmail = 'UPDATE_USER_EMAIL',
  ViewActivityLog = 'VIEW_ACTIVITY_LOG',
  ViewBenefit = 'VIEW_BENEFIT',
  ViewCompany = 'VIEW_COMPANY',
  ViewCompanyDashboard = 'VIEW_COMPANY_DASHBOARD',
  ViewCompanyDocumentType = 'VIEW_COMPANY_DOCUMENT_TYPE',
  ViewCompanyPayment = 'VIEW_COMPANY_PAYMENT',
  ViewEmployee = 'VIEW_EMPLOYEE',
  ViewEmployeeNominees = 'VIEW_EMPLOYEE_NOMINEES',
  ViewFund = 'VIEW_FUND',
  ViewMarketOrder = 'VIEW_MARKET_ORDER',
  ViewPaymentCategories = 'VIEW_PAYMENT_CATEGORIES',
  ViewRole = 'VIEW_ROLE',
  ViewUser = 'VIEW_USER',
  ViewWithdrawal = 'VIEW_WITHDRAWAL'
}

/** Configurable product template defining custom attributes, workflows, and payment bucket structure */
export type Product = {
  __typename?: 'Product';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByUser: User;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  productCustomAttributes: Array<ProductCustomAttribute>;
  productInstances: Array<ProductInstance>;
  /** product workflows assigned to this product */
  productWorkflows: Array<WorkflowOwner>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Employee assignment to a product instance tracking enrollment period and custom values */
export type ProductAssignment = {
  __typename?: 'ProductAssignment';
  /** Resolves the available actions for a product assignment, including salary contribution, fund setting, and withdrawal. */
  actions: ProductAssignmentActions;
  /** Resolves aggregate balance statistics for a product assignment: invested amount, contribution split, and overall return. */
  balanceStats: BalanceStats;
  /** Resolves settled contributions for a product assignment, bucketed by month and category over the requested range. */
  contributionOverview: ContributionOverview;
  /** Resolves a paginated history of money-in contributions paid into this product assignment, across all payment statuses. */
  contributions: ProductAssignmentContributionList;
  /** Resolves the total settled money-in contributions for this product assignment, excluding fees, withdrawals, and termination payouts. */
  contributionsSummary: ProductAssignmentContributionsSummary;
  createdAt: Scalars['DateTime']['output'];
  customProductAssignmentValues: Array<CustomProductAssignmentValue>;
  employee: CrmEmployee;
  employeeId: Scalars['ID']['output'];
  /** Resolves paginated employee statement PDFs associated with the employee of this product assignment. */
  employeeStatements: PaginatedEmployeeStatements;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Resolves the holding snapshot for a product assignment, providing current holding details. */
  holdingSnapshot: HoldingSnapshot;
  id: Scalars['ID']['output'];
  /** Monthly basic employer contribution based on MOHRE-mandated rates applied to basicSalary */
  monthlyBasicContribution?: Maybe<Scalars['Decimal']['output']>;
  /** Resolves the payment ledger for a product assignment, providing transaction history and balances. */
  paymentLedger: PaymentLedger;
  productAssignmentSubscriptionRequests?: Maybe<Array<CrmProductAssignmentSubscriptionRequestEntity>>;
  productInstance: ProductInstance;
  productInstanceId: Scalars['ID']['output'];
  startDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Employee assignment to a product instance tracking enrollment period and custom values */
export type ProductAssignmentContributionOverviewArgs = {
  range: ContributionOverviewRange;
};


/** Employee assignment to a product instance tracking enrollment period and custom values */
export type ProductAssignmentContributionsArgs = {
  pagination?: InputMaybe<Pagination>;
};


/** Employee assignment to a product instance tracking enrollment period and custom values */
export type ProductAssignmentEmployeeStatementsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Employee assignment to a product instance tracking enrollment period and custom values */
export type ProductAssignmentPaymentLedgerArgs = {
  direction?: InputMaybe<PaymentLedgerDirection>;
  excludeCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortKey?: InputMaybe<PaymentLedgerSortKey>;
  sortOrder?: InputMaybe<SortDirection>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Action to perform on product assignments */
export enum ProductAssignmentAction {
  Add = 'Add',
  Remove = 'Remove'
}

/** All available actions for a product assignment, including salary contribution, fund setting, and withdrawal. */
export type ProductAssignmentActions = {
  __typename?: 'ProductAssignmentActions';
  /** Action for setting fund. */
  setFund: SetFundAction;
  /** Action for setting salary contribution. */
  setSalaryContribution: SetSalaryContributionAction;
  /** Action for withdrawing funds. */
  withdraw: WithdrawAction;
};

export type ProductAssignmentContribution = {
  __typename?: 'ProductAssignmentContribution';
  adjusted: Scalars['Boolean']['output'];
  adjustment?: Maybe<Adjustment>;
  amount: Scalars['Decimal']['output'];
  category?: Maybe<PaymentCategory>;
  id: Scalars['ID']['output'];
  paymentCreatedAt: Scalars['DateTime']['output'];
  paymentForMonth?: Maybe<Scalars['String']['output']>;
  paymentId: Scalars['ID']['output'];
  paymentStatus: PaymentStatus;
};

export type ProductAssignmentContributionList = {
  __typename?: 'ProductAssignmentContributionList';
  count: Scalars['Int']['output'];
  list: Array<ProductAssignmentContribution>;
};

export type ProductAssignmentContributionsSummary = {
  __typename?: 'ProductAssignmentContributionsSummary';
  totalContributed: Scalars['Decimal']['output'];
};

export type ProductAssignmentList = {
  __typename?: 'ProductAssignmentList';
  count: Scalars['Int']['output'];
  list: Array<ProductAssignment>;
};

/** Columns by which ProductAssignmentList can be ordered */
export enum ProductAssignmentListOrderByColumn {
  CreatedAt = 'CreatedAt',
  EmployeeFirstName = 'EmployeeFirstName',
  EmployeeJobTitle = 'EmployeeJobTitle',
  EmployeeLastName = 'EmployeeLastName',
  EmployeeWorkEmail = 'EmployeeWorkEmail',
  EndDate = 'EndDate',
  Id = 'Id',
  ProductInstanceName = 'ProductInstanceName',
  ProductName = 'ProductName',
  StartDate = 'StartDate'
}

export type ProductAssignmentListOrderByInput = {
  /** Column name */
  column?: ProductAssignmentListOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

/** Columns by which ProductAssignmentSubscriptionRequestsList can be ordered */
export enum ProductAssignmentSubscriptionRequestOrderByColumn {
  Amount = 'Amount',
  CompanyName = 'CompanyName',
  CreatedAt = 'CreatedAt',
  EmployeeName = 'EmployeeName',
  Id = 'Id',
  Status = 'Status',
  UpdatedAt = 'UpdatedAt'
}

export enum ProductAssignmentSubscriptionRequestStatus {
  Approved = 'Approved',
  Pending = 'Pending'
}

export enum ProductAssignmentSubscriptionRequestType {
  OneTimePayment = 'OneTimePayment',
  Recurrent = 'Recurrent'
}

export type ProductAssignmentSubscriptionRequestsListOrderByInput = {
  /** Column name */
  column?: ProductAssignmentSubscriptionRequestOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

/** Association linking products to their custom form field definitions */
export type ProductCustomAttribute = {
  __typename?: 'ProductCustomAttribute';
  customAttribute: CustomAttribute;
  customAttributeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  product: Product;
  productId: Scalars['ID']['output'];
};

/** Company-specific product instance with custom configuration values and associated workflow executions */
export type ProductInstance = {
  __typename?: 'ProductInstance';
  company: CrmCompany;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByUser: User;
  customProductInstanceValues: Array<CustomProductInstanceValue>;
  /** Number of active employees assigned to the product */
  employeesCount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  product: Product;
  productAssignments: Array<ProductAssignment>;
  productId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductInstanceList = {
  __typename?: 'ProductInstanceList';
  count: Scalars['Int']['output'];
  list: Array<ProductInstance>;
};

/** Columns by which ProductInstancesByProduct list can be ordered */
export enum ProductInstancesByProductOrderByColumn {
  CreatedAt = 'CreatedAt',
  Id = 'Id',
  Name = 'Name'
}

export type ProductInstancesByProductOrderByInput = {
  /** Column name */
  column?: ProductInstancesByProductOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

/** User profile storing personal details, preferences, and financial goals */
export type Profile = {
  __typename?: 'Profile';
  financialGoal?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  user: User;
  /** Unique identifier of the associated user */
  userId: Scalars['String']['output'];
};

export type ProfileInput = {
  /** Full name of the user. */
  name: Scalars['String']['input'];
  /** Place where the user was born. */
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** User's preferred language for communication. */
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  /** User's preferred name to be displayed. */
  preferredName?: InputMaybe<Scalars['String']['input']>;
  /** User's email address. */
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

/** User onboarding progress tracking completion percentage per page */
export type Progress = {
  __typename?: 'Progress';
  /** Timestamp when progress entry was created */
  createdAt: Scalars['Date']['output'];
  /** Unique identifier of the progress entry */
  id: Scalars['String']['output'];
  /** Onboarding page name being tracked */
  page: ProgressPageName;
  /** Completion percentage of the onboarding page (0-100) */
  progress: Scalars['Float']['output'];
  /** Timestamp when progress entry was last updated */
  updatedAt: Scalars['Date']['output'];
  /** User completing the onboarding */
  user: User;
};

export enum ProgressPageName {
  CitizenshipConfirmation = 'CitizenshipConfirmation',
  ContributionsOnboarding = 'ContributionsOnboarding',
  Disclaimers = 'Disclaimers',
  Onboarding = 'Onboarding',
  Welcome = 'Welcome'
}

export type Query = {
  __typename?: 'Query';
  /** Returns a list of active products available to be assigned to a company. */
  activeProducts: Array<Product>;
  /** Fetches admin event logs for a company, including translated content and metadata, filtered by user permissions and language. */
  adminEventLogs: Array<AdminEventLog>;
  /** Fetches paginated admin event logs for a company with filtering, ordering and search capabilities. */
  adminEventLogsList: AdminEventLogList;
  admins: Array<User>;
  adminsCount: Scalars['Int']['output'];
  /** Returns a combined paginated list of user and employee invitations, with optional company and search filters. */
  allInvitationsList: AllInvitationsList;
  /** Returns the status of an async assign employees workflow (for polling). */
  assignEmployeesToProductStatus: AssignEmployeesToProductStatusResult;
  attributesCorrectionsList: AttributesCorrectionsList;
  attributesCorrectionsRequest: AttributesCorrectionsRequest;
  /** Check if MOHRE employee import workflow is running for a company. */
  checkMohreEmployeesImport: Scalars['Boolean']['output'];
  /** List companies with optional filters, pagination, and ordering. */
  companiesList: CrmCompanyList;
  /** Returns aggregated fee payment summary for a company (total paid, last paid date, upcoming payment) */
  companyFeeSummary: CompanyFeeSummary;
  /** Retrieves a paginated list of compliance document types */
  complianceDocumentTypeList: ComplianceDocumentTypeList;
  /** Returns a single git-managed workflow config (with nodes and layout) by its key, for the current tenant. Returns null when config is disabled or the key is unknown. Backs the read-only builder. */
  configWorkflow?: Maybe<WorkflowConfig>;
  /** Returns all git-managed workflow configs for the current tenant, ordered by name. Empty when config is disabled for the tenant. */
  configWorkflows: Array<WorkflowConfigSummary>;
  country: Scalars['String']['output'];
  currencies: CrmCurrencyList;
  customAttributes: CustomAttributeList;
  dataImportJobByUploadId: DataImportJob;
  /** Retrieves a paginated list of document type templates for company verification */
  documentTypeList: CrmCompanyDocumentTypeList;
  emailTemplate: EmailTemplateDto;
  emailTemplateList: Array<EmailTemplateInListDto>;
  /** Returns available filter options (departments, levels, salary range) for employees in a company. */
  employeeFilterOptions: EmployeeFilterOptionsDto;
  /** Returns a paginated list of employee invitations for a company, with optional filters and ordering. */
  employeeInvitationsList: EmployeeInvitationList;
  employeeProductAssignments: ProductAssignmentList;
  /** Returns a paginated list of employees for a company, with optional filters, purpose, ordering, and pagination. Requires the company identifier. */
  employeesList: CrmEmployeeList;
  employerHoldingPositionHistory: EmployerHoldingHistoryList;
  employerHoldingPositionSummary: EmployerHoldingPositionSummary;
  employerHoldingPositionsList: EmployerHoldingList;
  /** Returns the status of an async export workflow (for polling). */
  exportStatus: ExportStatusResult;
  featuresList: Array<Scalars['String']['output']>;
  /** Returns fee assignments applicable to a company (direct assignments and platform-wide assignments) */
  feeAssignmentsForCompany: Array<FeeAssignment>;
  /** Returns the git-managed workflow configs owned by a fee (matched by the fee's name). Empty when config is disabled for the tenant. */
  feeConfigWorkflows: Array<WorkflowConfigSummary>;
  /** List all fees (platform-only) */
  feesList: Array<Fee>;
  findAllFundDocuments: Array<FundDocument>;
  /** Find a company by its unique identifier. */
  findCompany?: Maybe<CrmCompany>;
  /** Retrieves a company from a verification details ID. */
  findCompanyFromVerificationDetailsId?: Maybe<CrmCompany>;
  /** Finds a single employee by ID for the current user's authorized company scope. Throws 404 if not found. */
  findEmployee: CrmEmployee;
  /** Finds a single employee invitation by its unique ID. Returns null if not found. */
  findEmployeeInvitation?: Maybe<EmployeeInvitation>;
  findEnvironmentConfig: EnvironmentConfg;
  findEnvironmentDocuments: Array<EnvironmentDocument>;
  findEnvironmentFeatures: FeaturesConfig;
  findFundDocuments: Array<FundDocument>;
  /** Find a specific chat message by its unique identifier */
  findMessage: ChatMessage;
  /** Find MOHRE companies using OTP and return those not yet registered. */
  findMohreCompanies: MohreCompaniesResponse;
  /** Find a single MOHRE company by company code. */
  findMohreCompany: MohreCompany;
  /** Find a specific product assignment subscription request by its ID within the user's authorized company scope */
  findProductAssignmentSubscriptionRequest: CrmProductAssignmentSubscriptionRequestEntity;
  /** Find a specific role by its ID, optionally scoped to a company */
  findRole: Role;
  findSamlConfiguration: CrmSamlConfiguration;
  /** Find a specific chat thread by its ID or create a new one if not specified */
  findThread: ChatThread;
  findUser: User;
  /** Finds a single user invitation by its unique ID. Returns null if not found. */
  findUserInvitation: UserInvitation;
  /** Returns a list of user invitations for a company, filtered by user scope and permissions. */
  findUserInvitations: Array<UserInvitation>;
  /** Get a specific draft form template - only accessible by Platform Admins */
  formTemplate: FormTemplate;
  /** Get the latest published version of a specific form template */
  formTemplateLatestPublishedVersion?: Maybe<FormTemplateVersion>;
  /** Get draft form templates - only accessible by Platform Admins */
  formTemplates: Array<FormTemplate>;
  /** @deprecated Funds live in custom attributes */
  funds: Array<Fund>;
  /** Get a specific fee by ID (platform-only) */
  getFee: Fee;
  getPasswordPolicy: PasswordPolicy;
  getPossibleAssignees: Array<User>;
  getPossibleReviewers: Array<User>;
  /** Get the real-time streaming state from a running Temporal workflow processing an AI assistant message */
  getStreamStateQuery?: Maybe<StreamState>;
  getTaskByResourceId?: Maybe<Task>;
  getTaskDetailsById: Task;
  getTaskFilesAndLinks: TaskFilesAndLinks;
  getTaskTypeDefinition: TaskTypeDefinition;
  /** Returns available filter options (companies, products, total units range, market value range) for holding positions. */
  holdingPositionFilterOptions: HoldingPositionFilterOptionsDto;
  holdingPositionHistory: HoldingPositionWithHistory;
  holdingPositionsList: HoldingPositionList;
  internalAuditTrailList: InternalAuditTrailList;
  internalChatThreadList: InternalChatThreadList;
  internalDataImportJobList: InternalDataImportJobList;
  internalEmailLogList: InternalEmailLogList;
  internalEmployeeInvitationList: InternalEmployeeInvitationList;
  internalLLMAuditLogList: InternalLlmAuditLogList;
  internalOutboundList: InternalOutboundList;
  internalOutboundLogList: InternalOutboundLogList;
  internalSupportToolLogList: InternalSupportToolLogList;
  internalWorkflowRunList: InternalWorkflowRunList;
  invoiceParties: Array<InvoiceParty>;
  invoiceParty?: Maybe<InvoiceParty>;
  /** Checks if bulk upsert employees workflow is currently running for a company. */
  isBulkUpsertEmployeesRunning: Scalars['Boolean']['output'];
  /** Retrieves a paginated list of KYB (Know Your Business) verification requests for companies within the user's authorized scope. Supports filtering, ordering, and pagination. */
  kybRequestList: CrmKybRequestList;
  /** Fetch a single KYC request by ID, with authorization checks. */
  kycRequest: KycRequest;
  /** Retrieves a paginated list of KYC (Know Your Customer) verification requests for employees within the user's authorized scope. Supports filtering, ordering, and pagination. */
  kycRequests: KycRequestList;
  kycTaskByRequestId?: Maybe<Task>;
  /** Finds a market order by its ID for the current user's authorized company scope. Throws error if not found. */
  marketOrderById: MarketOrder;
  /** Returns available filter options for market orders. */
  marketOrderFilterOptions: MarketOrderFilterOptionsDto;
  /** Retrieves a paginated list of market orders (buy/sell transactions for investment funds, fund switches) within the user's authorized company scope. Tracks order state (pending, executed, failed), execution timestamps, and associated company information. Supports filtering, ordering by id/timestamps/state, and pagination. */
  marketOrdersList: MarketOrderList;
  /** Get current user's notifications with pagination and filtering */
  notifications: NotificationList;
  /** Returns a single payment entity by its unique ID for the user's company. Throws error if not found. */
  payment: Payment;
  /** List all payment categories */
  paymentCategoriesList: Array<PaymentCategory>;
  /** Returns available filter options (companies, currencies, amount range, issue date range) for payments. */
  paymentFilterOptions: PaymentFilterOptions;
  /** Returns a paginated list of payments for the user's company, with optional filters and ordering. */
  payments: PaymentList;
  /** Returns a platform-level paginated list of employee invitations across all accessible companies, with optional company filter, filters, and ordering. */
  platformEmployeeInvitationsList: EmployeeInvitationList;
  /** Fetches a single product by its unique ID for the authenticated user. Throws NotFoundException if the product does not exist. */
  product: Product;
  /** Returns a single product assignment entity by its unique ID for the authenticated user. */
  productAssignment: ProductAssignment;
  /** Retrieves a paginated list of product assignment subscription requests within the user's authorized company scope. Optionally filter by companyId. Includes employee names and amounts extracted from request data. Supports filtering, ordering, and pagination. */
  productAssignmentSubscriptionRequestsList: CrmProductAssignmentSubscriptionRequestList;
  productAssignments: ProductAssignmentList;
  /** Returns the git-managed workflow configs owned by a product (matched by the product's code). Empty when config is disabled for the tenant. */
  productConfigWorkflows: Array<WorkflowConfigSummary>;
  /** Returns a single product instance by its unique ID for the authenticated user. Throws NotFoundException if not found. */
  productInstance: ProductInstance;
  productInstanceFromAssignment: ProductInstance;
  /** Returns a list of product instances for a given company, ordered by creation date. */
  productInstances: Array<ProductInstance>;
  /** Returns paginated product instances for a given product (across all companies). */
  productInstancesByProduct: ProductInstanceList;
  /** Returns a list of products for the authenticated user, optionally filtered by company. */
  products: Array<Product>;
  /** Returns the schema of queryable entity columns for a given product ID. */
  queryEntitySchema: QueryEntitySchema;
  /** Retrieve a list of all roles, optionally filtered by company */
  rolesList: Array<Role>;
  /** Search companies by name or registered number. Returns top matches. */
  searchCompanies: CrmCompanyList;
  /** Searches employees by name, email, or national ID. Returns paginated results. */
  searchEmployees: CrmEmployeeList;
  tasksList: TaskList;
  tenantsList: Array<TenantEntity>;
  /** Retrieve all exported documents generated by the AI assistant within a specific thread */
  threadDocuments: Array<ThreadDocument>;
  /** Retrieve all exported documents generated by the AI assistant across all threads for the authenticated user */
  threadDocumentsList: ThreadDocumentsList;
  /** Retrieve a paginated list of chat threads for the authenticated user */
  threadsList: ChatThreadsList;
  translations: Scalars['String']['output'];
  translationsDetails: Array<Translation>;
  user: User;
  /** Returns a paginated list of user invitations for a company, with optional filters and ordering. */
  userInvitationsList: UserInvitationList;
  usersList: CrmUserList;
  /** Returns a single workflow definition by its unique ID for the authenticated user. Returns null if not found. */
  workflow?: Maybe<WorkflowDefinition>;
  /** Whether git-managed workflow config is enabled for the current tenant. When true, manual/scheduled runs are sourced from config (by key) instead of the DB. */
  workflowConfigEnabled: Scalars['Boolean']['output'];
  /** Returns a list of workflow events for a given run ID, ordered by sequence. */
  workflowEvents: Array<WorkflowEvent>;
  /** Returns a list of available workflow node types and their configuration schemas. */
  workflowNodeTypes: Array<WorkflowNodeType>;
  /** Returns a list of workflow definitions, ordered by creation date. */
  workflows: Array<WorkflowDefinition>;
};


export type QueryActiveProductsArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminEventLogsArgs = {
  companyId: Scalars['String']['input'];
  language: SupportedLanguages;
  pagination?: InputMaybe<Pagination>;
};


export type QueryAdminEventLogsListArgs = {
  companyId: Scalars['String']['input'];
  filters?: InputMaybe<AdminEventLogFiltersInput>;
  language: SupportedLanguages;
  orderBy?: InputMaybe<AdminEventLogOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryAdminsArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryAdminsCountArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryAllInvitationsListArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAssignEmployeesToProductStatusArgs = {
  workflowId: Scalars['String']['input'];
};


export type QueryAttributesCorrectionsListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<AttributesCorrectionsListOrderByInput>;
  pagination?: InputMaybe<Pagination>;
  resourceId: Scalars['String']['input'];
  resourceType: AttributesCorrectionsResourceType;
};


export type QueryAttributesCorrectionsRequestArgs = {
  companyId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryCheckMohreEmployeesImportArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryCompaniesListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<CompaniesListOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryCompanyFeeSummaryArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryComplianceDocumentTypeListArgs = {
  complianceType: ComplianceType;
  documentFrom?: InputMaybe<ComplianceDocumentFrom>;
  isAdditional?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryConfigWorkflowArgs = {
  key: WorkflowKey;
};


export type QueryDataImportJobByUploadIdArgs = {
  handlerKey: DataImportHandlerKey;
  uploadId: Scalars['String']['input'];
};


export type QueryDocumentTypeListArgs = {
  isAdditional?: InputMaybe<Scalars['Boolean']['input']>;
  type: ComplianceDocumentFrom;
};


export type QueryEmailTemplateArgs = {
  type: Scalars['String']['input'];
};


export type QueryEmployeeFilterOptionsArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryEmployeeInvitationsListArgs = {
  companyId: Scalars['String']['input'];
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<OrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryEmployeeProductAssignmentsArgs = {
  companyId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  filters?: InputMaybe<FiltersExpression>;
  includeEnded?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<ProductAssignmentListOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryEmployeesListArgs = {
  companyId: Scalars['String']['input'];
  excludeForProductId?: InputMaybe<Scalars['String']['input']>;
  excludeProductInstanceId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<EmployeeListOrderByInput>;
  overridePagination?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<Pagination>;
  purpose?: InputMaybe<EmployeesPurpose>;
};


export type QueryEmployerHoldingPositionHistoryArgs = {
  companyId: Scalars['String']['input'];
  isin: Scalars['String']['input'];
  orderBy?: InputMaybe<EmployerHoldingHistoryOrderByInput>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmployerHoldingPositionSummaryArgs = {
  companyId: Scalars['String']['input'];
  isin: Scalars['String']['input'];
};


export type QueryEmployerHoldingPositionsListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<EmployerHoldingPositionsListOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryExportStatusArgs = {
  workflowId: Scalars['String']['input'];
};


export type QueryFeeAssignmentsForCompanyArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryFeeConfigWorkflowsArgs = {
  feeId: Scalars['String']['input'];
};


export type QueryFindCompanyArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindCompanyFromVerificationDetailsIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindEmployeeArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindEmployeeInvitationArgs = {
  invitationId: Scalars['String']['input'];
};


export type QueryFindEnvironmentDocumentsArgs = {
  environmentId: Scalars['String']['input'];
};


export type QueryFindFundDocumentsArgs = {
  fundId: Scalars['String']['input'];
};


export type QueryFindMessageArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindMohreCompaniesArgs = {
  input: GetMohreCompanyInputWithOtp;
};


export type QueryFindMohreCompanyArgs = {
  companyCode: Scalars['String']['input'];
};


export type QueryFindProductAssignmentSubscriptionRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindRoleArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type QueryFindSamlConfigurationArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryFindThreadArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindUserArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryFindUserInvitationArgs = {
  invitationId: Scalars['String']['input'];
};


export type QueryFindUserInvitationsArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFormTemplateArgs = {
  id: Scalars['String']['input'];
};


export type QueryFormTemplateLatestPublishedVersionArgs = {
  formTemplateId?: InputMaybe<Scalars['String']['input']>;
  systemKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFeeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPossibleAssigneesArgs = {
  taskId: Scalars['ID']['input'];
};


export type QueryGetPossibleReviewersArgs = {
  taskId: Scalars['ID']['input'];
};


export type QueryGetStreamStateQueryArgs = {
  workflowId: Scalars['String']['input'];
};


export type QueryGetTaskByResourceIdArgs = {
  resourceId: Scalars['ID']['input'];
  resourceTypes: Array<TaskResourceType>;
};


export type QueryGetTaskDetailsByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTaskFilesAndLinksArgs = {
  taskId: Scalars['ID']['input'];
};


export type QueryGetTaskTypeDefinitionArgs = {
  resourceType: TaskResourceType;
};


export type QueryHoldingPositionHistoryArgs = {
  isin: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
};


export type QueryHoldingPositionsListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<HoldingPositionsListOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryInternalAuditTrailListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<InternalAuditTrailOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryInternalChatThreadListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<InternalChatThreadOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryInternalDataImportJobListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<InternalDataImportJobOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryInternalEmailLogListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<InternalEmailLogOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryInternalEmployeeInvitationListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<InternalEmployeeInvitationOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryInternalLlmAuditLogListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<InternalLlmAuditLogOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryInternalOutboundListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<InternalOutboundOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryInternalOutboundLogListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<InternalOutboundLogOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryInternalSupportToolLogListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<InternalSupportToolLogOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryInternalWorkflowRunListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<InternalWorkflowRunOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryInvoicePartyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIsBulkUpsertEmployeesRunningArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryKybRequestListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<KybRequestListOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryKycRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryKycRequestsArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<KycRequestListOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryKycTaskByRequestIdArgs = {
  kycRequestId: Scalars['ID']['input'];
};


export type QueryMarketOrderByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryMarketOrdersListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<MarketOrdersListOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryNotificationsArgs = {
  filters?: InputMaybe<FiltersExpression>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryPaymentArgs = {
  paymentId: Scalars['String']['input'];
};


export type QueryPaymentCategoriesListArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPaymentFilterOptionsArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaymentsArgs = {
  amountFrom?: InputMaybe<Scalars['Decimal']['input']>;
  amountTo?: InputMaybe<Scalars['Decimal']['input']>;
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<PaymentsListOrderByInput>;
  pagination?: InputMaybe<Pagination>;
  productInstanceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlatformEmployeeInvitationsListArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<OrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryProductArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type QueryProductAssignmentArgs = {
  productAssignmentId: Scalars['String']['input'];
};


export type QueryProductAssignmentSubscriptionRequestsListArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<ProductAssignmentSubscriptionRequestsListOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryProductAssignmentsArgs = {
  companyId: Scalars['String']['input'];
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<ProductAssignmentListOrderByInput>;
  pagination?: InputMaybe<Pagination>;
  productInstanceId: Scalars['String']['input'];
};


export type QueryProductConfigWorkflowsArgs = {
  productId: Scalars['String']['input'];
};


export type QueryProductInstanceArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductInstanceFromAssignmentArgs = {
  assignmentId: Scalars['String']['input'];
};


export type QueryProductInstancesArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryProductInstancesByProductArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<ProductInstancesByProductOrderByInput>;
  pagination?: InputMaybe<Pagination>;
  productId: Scalars['String']['input'];
};


export type QueryProductsArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQueryEntitySchemaArgs = {
  productId: Scalars['String']['input'];
};


export type QueryRolesListArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchCompaniesArgs = {
  query: Scalars['String']['input'];
};


export type QuerySearchEmployeesArgs = {
  pagination?: InputMaybe<Pagination>;
  query: Scalars['String']['input'];
};


export type QueryTasksListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<TaskOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryThreadDocumentsArgs = {
  threadId: Scalars['String']['input'];
};


export type QueryThreadDocumentsListArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryThreadsListArgs = {
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<OrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryTranslationsArgs = {
  application: WebApps;
  language: SupportedLanguages;
};


export type QueryTranslationsDetailsArgs = {
  application: WebApps;
  keys: Array<Scalars['String']['input']>;
  language: SupportedLanguages;
};


export type QueryUserInvitationsListArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<UserInvitationsListOrderByInput>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryUsersListArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FiltersExpression>;
  orderBy?: InputMaybe<UsersListOrderByInput>;
  pagination?: InputMaybe<Pagination>;
  roleScope?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryWorkflowArgs = {
  id: Scalars['String']['input'];
};


export type QueryWorkflowEventsArgs = {
  runId: Scalars['String']['input'];
};


export type QueryWorkflowsArgs = {
  type?: InputMaybe<WorkflowType>;
};

/** Schema describing available queryable columns for each entity type. */
export type QueryEntitySchema = {
  __typename?: 'QueryEntitySchema';
  /** Queryable columns for AUMFeeEntity. */
  AUMFeeEntity?: Maybe<EntityColumns>;
  /** Queryable columns for CompanyEntity. */
  CompanyEntity?: Maybe<EntityColumns>;
  /** Queryable columns for EmployeeEntity. */
  EmployeeEntity?: Maybe<EntityColumns>;
  /** Queryable columns for HistoricalFundPriceEntity. */
  HistoricalFundPriceEntity?: Maybe<EntityColumns>;
  /** Queryable columns for HistoricalFundPriceHistoryEntity (full price history per ISIN, not just the latest price). */
  HistoricalFundPriceHistoryEntity?: Maybe<EntityColumns>;
  /** Queryable columns for HoldingV2Entity. */
  HoldingV2Entity?: Maybe<EntityColumns>;
  /** Queryable columns for MarketOrderTransactionEntity. */
  MarketOrderTransactionEntity?: Maybe<EntityColumns>;
  /** Queryable columns for PaymentLineItemEntity. */
  PaymentLineItemEntity?: Maybe<EntityColumns>;
  /** Queryable columns for ProductAssignmentEntity. */
  ProductAssignmentEntity?: Maybe<EntityColumns>;
  /** Queryable columns for ProductInstanceEntity. */
  ProductInstanceEntity?: Maybe<EntityColumns>;
  /** Queryable columns for UserEntity. */
  UserEntity?: Maybe<EntityColumns>;
};

export type ReportedFieldsInput = {
  /** Name of the reported field. */
  field: Scalars['String']['input'];
  /** Value associated with the reported field, if any. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Role access restriction linking roles to specific companies */
export type RestrictedRoleCompany = {
  __typename?: 'RestrictedRoleCompany';
  company: CrmCompany;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  role: Role;
};

/** Revert translation input */
export type RevertTranslation = {
  __typename?: 'RevertTranslation';
  key: Scalars['String']['output'];
  /** The version to revert to, if 0, the translation will fall back to the original version */
  version: Scalars['Float']['output'];
};

export type RevertTranslationInput = {
  key: Scalars['String']['input'];
  /** The version to revert to, if 0, the translation will fall back to the original version */
  version: Scalars['Float']['input'];
};

/** User role defining a named set of permissions for platform and company-level access control */
export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isMutable: Scalars['Boolean']['output'];
  isPlatform: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  restrictedCompanies?: Maybe<Array<RestrictedRoleCompany>>;
  rolePermissions?: Maybe<Array<RolePermission>>;
  updatedAt: Scalars['Date']['output'];
  userRoles?: Maybe<Array<UserRole>>;
};

/** Association linking roles to individual permissions for granular access control */
export type RolePermission = {
  __typename?: 'RolePermission';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  permission: PermissionEnum;
  role: Role;
  updatedAt: Scalars['Date']['output'];
};

export type SalaryRangeDto = {
  __typename?: 'SalaryRangeDto';
  /** Maximum salary in the range */
  max: Scalars['Decimal']['output'];
  /** Minimum salary in the range */
  min: Scalars['Decimal']['output'];
};

export enum SamlConfigurationVerificationStatus {
  Pending = 'Pending',
  TxtRecordRequested = 'TxtRecordRequested',
  Verified = 'Verified'
}

export type SaveComplianceDocumentTypeInput = {
  data: ComplianceDocumentTypeDataInput;
  id?: InputMaybe<Scalars['String']['input']>;
  optional: Scalars['Boolean']['input'];
  type?: InputMaybe<ComplianceDocumentFrom>;
};

export type SaveDocumentTypeInput = {
  data: Scalars['JSONObject']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  optional: Scalars['Boolean']['input'];
  type: CompanyDocumentFrom;
};

export type SaveWorkflowInput = {
  /** Optional description of the workflow */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the workflow version currently being edited */
  editingVersionId?: InputMaybe<Scalars['String']['input']>;
  /** ReactFlow layout data for UI rendering */
  layout: Scalars['JSONObject']['input'];
  /** Name of the workflow */
  name: Scalars['String']['input'];
  /** List of nodes in the workflow */
  nodes: Array<WorkflowNodeInput>;
  /** Trigger configuration for the workflow */
  trigger: TriggerConfigInput;
  /** ID of the workflow definition to save */
  workflowDefinitionId: Scalars['String']['input'];
};

/** SCB Virtual Account created for a company to make payment for end-of-service benefit payments */
export type ScbVirtualAccount = {
  __typename?: 'ScbVirtualAccount';
  clientReferenceId: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: ScbVirtualAccountStatus;
  statusDescription?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  virtualAccountNumber: Scalars['String']['output'];
};

export enum ScbVirtualAccountStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Success = 'Success'
}

export type SendMessageResponse = {
  __typename?: 'SendMessageResponse';
  /** Indicates whether the message is currently being processed by the AI assistant */
  isProcessing: Scalars['Boolean']['output'];
  /** The unique identifier of the conversation thread */
  threadId: Scalars['ID']['output'];
  /** The chat message entity created from the user's sent message */
  userMessage: ChatMessage;
  /** The Temporal workflow ID for tracking the message processing */
  workflowId: Scalars['String']['output'];
};

export enum SenderRecipientType {
  CompanyEntity = 'CompanyEntity',
  EmployeeEntity = 'EmployeeEntity',
  System = 'System'
}

/** Action to set fund, including enabled state. */
export type SetFundAction = {
  __typename?: 'SetFundAction';
  /** Fund attributes available for switching. */
  fields: Array<SetFundActionField>;
  /** Whether the set fund action is enabled. */
  isEnabled: Scalars['Boolean']['output'];
};

/** Field representing a fund attribute and its current selection. */
export type SetFundActionField = {
  __typename?: 'SetFundActionField';
  /** Custom attribute entity for the fund selection field. */
  attribute: CustomAttribute;
  /** Current fund selection for the field. */
  currentFundName?: Maybe<Scalars['String']['output']>;
  /** To determine if there is an ongoing fund switch workflow. */
  pendingItem?: Maybe<SetFundActionPendingItem>;
};

/** Pending fund switch item for a specific fund custom attribute. Each item corresponds to an ongoing fund switch workflow. */
export type SetFundActionPendingItem = {
  __typename?: 'SetFundActionPendingItem';
  /** Timestamp when the fund switch workflow started. */
  createdAt: Scalars['DateTime']['output'];
  /** Run ID of the fund switch workflow. */
  runId: Scalars['String']['output'];
  /** Source fund name to switch from */
  sourceFundName?: Maybe<Scalars['String']['output']>;
  /** Target fund name to switch into */
  targetFundName: Scalars['String']['output'];
};

export type SetFundInput = {
  /** Name of the custom fund attribute */
  customAttributeName: Scalars['String']['input'];
  /** ID of the product assignment */
  productAssignmentId: Scalars['String']['input'];
  /** Source fund name to switch from */
  sourceFundName?: InputMaybe<Scalars['String']['input']>;
  /** Target fund name to switch into */
  targetFundName: Scalars['String']['input'];
};

/** Action to set salary contribution, including enabled state and related fields. */
export type SetSalaryContributionAction = {
  __typename?: 'SetSalaryContributionAction';
  /** Fields related to the salary contribution action. */
  fields: Array<SetSalaryContributionActionField>;
  /** Whether the salary contribution action is enabled. */
  isEnabled: Scalars['Boolean']['output'];
};

/** Field representing a salary contribution attribute and its current values. */
export type SetSalaryContributionActionField = {
  __typename?: 'SetSalaryContributionActionField';
  /** Annual contribution cap for one-time contributions. */
  annualCap?: Maybe<Scalars['String']['output']>;
  /** Custom attribute entity for the salary contribution field. */
  attribute: CustomAttribute;
  /** Current contribution amount for the salary field. */
  currentValue?: Maybe<Scalars['String']['output']>;
  /** Pending contribution amount awaiting approval. */
  pendingValue?: Maybe<Scalars['String']['output']>;
  /** Remaining annual salary-contribution allowance. */
  remainingAnnualCap?: Maybe<Scalars['String']['output']>;
  /** Maximum one-time contribution allowed in the current cycle. */
  remainingMonthlyCap?: Maybe<Scalars['String']['output']>;
  /** Current salary amount for the field. */
  salaryAmount?: Maybe<Scalars['String']['output']>;
  /** Settled year-to-date one-time salary contributions. */
  ytdOneTimeConsumed?: Maybe<Scalars['String']['output']>;
  /** Settled year-to-date recurring salary contributions. */
  ytdRecurringConsumed?: Maybe<Scalars['String']['output']>;
};

export type SetSalaryContributionInput = {
  /** Contribution amount to set for the salary */
  contributionValue: Scalars['Decimal']['input'];
  /** Name of the custom attribute for salary contribution */
  customAttributeName: Scalars['String']['input'];
  /** ID of the product assignment to update */
  productAssignmentId: Scalars['String']['input'];
};

export type SignatoryInput = {
  signatoryId: Scalars['Int']['input'];
  signatoryName: Scalars['String']['input'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StreamState = {
  __typename?: 'StreamState';
  /** Partial or final data results from query execution */
  dataResult?: Maybe<Array<Scalars['JSONObject']['output']>>;
  /** Whether the AI processing is complete */
  isComplete: Scalars['Boolean']['output'];
  /** Processing status text during tool execution (e.g., what the LLM is thinking) */
  processingStatus: Scalars['String']['output'];
  /** AI reasoning text explaining the current step */
  reasoningText: Scalars['String']['output'];
  /** Current processing stage of the AI assistant */
  stage: Scalars['String']['output'];
};

export type SumsubAmlCaseReview = {
  __typename?: 'SumsubAmlCaseReview';
  /** Overall review answer */
  reviewAnswer: SumsubAmlReviewAnswer;
};

export type SumsubAmlHit = {
  __typename?: 'SumsubAmlHit';
  /** Birth dates associated with this entity */
  birthDates: Array<Scalars['String']['output']>;
  /** Birth years associated with this entity */
  birthYears: Array<Scalars['String']['output']>;
  /** Type of entity (individual, organization, vessel, etc.) */
  entityType: Scalars['String']['output'];
  /** Unique identifier for this hit */
  id: Scalars['String']['output'];
  /** When ongoing monitoring was last updated */
  monitoringUpdatedAt?: Maybe<Scalars['String']['output']>;
  /** Name of the matched entity */
  name: Scalars['String']['output'];
  /** Review information for this hit */
  review?: Maybe<SumsubAmlHitReview>;
  /** Risk labels associated with this hit */
  riskLabels: Array<Scalars['String']['output']>;
  /** Sources where this match was found */
  sources: Array<SumsubAmlSource>;
};

export type SumsubAmlHitReview = {
  __typename?: 'SumsubAmlHitReview';
  /** Match status (e.g., false_positive, true_positive, unresolved) */
  matchStatus?: Maybe<Scalars['String']['output']>;
  /** When this review was last modified */
  modifiedAt?: Maybe<Scalars['String']['output']>;
  /** Whether this hit has been whitelisted */
  whitelisted: Scalars['Boolean']['output'];
};

export type SumsubAmlOngoingMonitoring = {
  __typename?: 'SumsubAmlOngoingMonitoring';
  /** Whether ongoing monitoring is enabled */
  enabled: Scalars['Boolean']['output'];
};

/** AML screening review answer: GREEN (approved), RED (rejected), YELLOW (under review) */
export enum SumsubAmlReviewAnswer {
  Green = 'GREEN',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export type SumsubAmlScreeningData = {
  __typename?: 'SumsubAmlScreeningData';
  /** When this AML case was created */
  createdAt: Scalars['String']['output'];
  /** List of potential matches found */
  hits: Array<SumsubAmlHit>;
  /** Unique identifier for this AML case */
  id: Scalars['String']['output'];
  /** Ongoing monitoring status */
  ongoingMonitoring: SumsubAmlOngoingMonitoring;
  /** Review result */
  review: SumsubAmlCaseReview;
  /** Risk labels identified (e.g., PEP, sanctions, crime) */
  riskLabels: Array<Scalars['String']['output']>;
  /** Name of the screening vendor (e.g., ComplyAdvantage) */
  screeningVendor?: Maybe<Scalars['String']['output']>;
  /** ID of the entity being screened */
  targetEntityId: Scalars['String']['output'];
  /** Type of entity being screened */
  targetEntityType: Scalars['String']['output'];
  /** Vendor attribution text */
  vendorAttribution?: Maybe<Scalars['String']['output']>;
};

/** AML source information (watchlist, media, or related) */
export type SumsubAmlSource = SumsubAmlSourceMedia | SumsubAmlSourceRelated | SumsubAmlSourceWatchlist;

export type SumsubAmlSourceMedia = {
  __typename?: 'SumsubAmlSourceMedia';
  /** Excerpt or annotation from the article */
  annotation?: Maybe<Scalars['String']['output']>;
  /** Published date of the article */
  publishedDate?: Maybe<Scalars['String']['output']>;
  /** Title of the article */
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  /** URL to the media article */
  url: Scalars['String']['output'];
};

export type SumsubAmlSourceRelated = {
  __typename?: 'SumsubAmlSourceRelated';
  type: Scalars['String']['output'];
  /** URL to the related source */
  url: Scalars['String']['output'];
};

export type SumsubAmlSourceWatchlist = {
  __typename?: 'SumsubAmlSourceWatchlist';
  /** End date of active period */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Name of the watchlist */
  name: Scalars['String']['output'];
  /** Start date of active period */
  startDate?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  /** URL to the watchlist source */
  url: Scalars['String']['output'];
};

/** Support tool mutation action types */
export enum SupportToolAction {
  ContinueTimerNode = 'ContinueTimerNode',
  ContinueWorkflowRun = 'ContinueWorkflowRun',
  ExitWorkflowRun = 'ExitWorkflowRun',
  GeneratePayrollDeductionPayment = 'GeneratePayrollDeductionPayment',
  PushAllEmployeesToMohre = 'PushAllEmployeesToMohre',
  PushEmployerToMohre = 'PushEmployerToMohre',
  PushIndividualBasicSubscriptionToMohre = 'PushIndividualBasicSubscriptionToMohre',
  PushIndividualEmployeeToMohre = 'PushIndividualEmployeeToMohre',
  PushIndividualPaymentToMohre = 'PushIndividualPaymentToMohre',
  PushOwnerToMohre = 'PushOwnerToMohre',
  PushSubscriptionToMohre = 'PushSubscriptionToMohre',
  RemovePaymentLineItems = 'RemovePaymentLineItems',
  RerunEmployeeFundSwitch = 'RerunEmployeeFundSwitch',
  RerunEmployeeTerminations = 'RerunEmployeeTerminations',
  RerunWorkflowNode = 'RerunWorkflowNode',
  RunWorkflow = 'RunWorkflow'
}

/** Support tool category */
export enum SupportToolCategory {
  Mohre = 'Mohre',
  Payment = 'Payment',
  Workflow = 'Workflow'
}

/** Audit log for support tool mutation executions */
export type SupportToolLog = {
  __typename?: 'SupportToolLog';
  /** The support tool action that was executed */
  action: SupportToolAction;
  /** Category of the support tool */
  category: SupportToolCategory;
  /** Timestamp when the action was executed */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the target entity */
  entityId?: Maybe<Scalars['String']['output']>;
  /** Type of the target entity */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Error message if the action failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the support tool log */
  id: Scalars['ID']['output'];
  /** Input parameters passed to the mutation */
  inputParams?: Maybe<Scalars['JSON']['output']>;
  /** Whether the action executed successfully */
  success: Scalars['Boolean']['output'];
  /** User who executed the action */
  user: User;
  /** ID of the user who executed the action */
  userId: Scalars['String']['output'];
};

export enum SupportedLanguages {
  Ar = 'ar',
  En = 'en'
}

/** Task entity representing assignable work items with status tracking and resource associations */
export type Task = {
  __typename?: 'Task';
  activities: Array<TaskActivity>;
  assignedTo?: Maybe<User>;
  assignedToId?: Maybe<Scalars['String']['output']>;
  attachments: Array<Attachment>;
  comments: Array<TaskComment>;
  company?: Maybe<CrmCompany>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyVerification?: Maybe<CrmCompanyVerification>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdByType: TaskCreatedByType;
  dataSnapshot: TaskSnapshot;
  description: TaskDescriptionOutput;
  escalatedToId?: Maybe<Scalars['String']['output']>;
  hasOpenAccess: Scalars['Boolean']['output'];
  hasReviewAccess: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Indicates whether the task has been escalated */
  isEscalated: Scalars['Boolean']['output'];
  kycRequest?: Maybe<KycRequest>;
  manualTask?: Maybe<ManualTask>;
  marketOrder?: Maybe<MarketOrder>;
  payment?: Maybe<Payment>;
  priority: TaskPriority;
  productAssignmentSubscriptionRequest?: Maybe<CrmProductAssignmentSubscriptionRequestEntity>;
  resourceId: Scalars['String']['output'];
  resourceType: TaskResourceType;
  reviewedBy?: Maybe<User>;
  reviewedById?: Maybe<Scalars['String']['output']>;
  status: TaskStatus;
  typeDefinition: TaskTypeDefinition;
  typeDefinitionId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Activity log entity for tasks */
export type TaskActivity = {
  __typename?: 'TaskActivity';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  task: Task;
  taskId: Scalars['String']['output'];
  type: TaskActivityType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Type of task activity */
export enum TaskActivityType {
  AssigneeChanged = 'AssigneeChanged',
  CorrectionAccepted = 'CorrectionAccepted',
  CorrectionRejected = 'CorrectionRejected',
  CorrectionResolved = 'CorrectionResolved',
  DocumentsUploaded = 'DocumentsUploaded',
  Escalated = 'Escalated',
  RequestedResubmission = 'RequestedResubmission',
  ReviewerChanged = 'ReviewerChanged',
  StatusChanged = 'StatusChanged',
  SubmittedForReview = 'SubmittedForReview',
  TaskClosed = 'TaskClosed',
  TaskCreated = 'TaskCreated'
}

/** Comment entity for tasks */
export type TaskComment = {
  __typename?: 'TaskComment';
  attachments: Array<Attachment>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  task: Task;
  taskId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

/** Type of entity that created a task */
export enum TaskCreatedByType {
  System = 'System',
  User = 'User'
}

export type TaskDescriptionOutput = {
  __typename?: 'TaskDescriptionOutput';
  ar: Scalars['String']['output'];
  en: Scalars['String']['output'];
};

export type TaskFile = {
  __typename?: 'TaskFile';
  createdAt?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type TaskFilesAndLinks = {
  __typename?: 'TaskFilesAndLinks';
  files: Array<TaskFile>;
  links: Array<TaskLink>;
};

export type TaskLink = {
  __typename?: 'TaskLink';
  displayDomain: Scalars['String']['output'];
  faviconUrl: Scalars['String']['output'];
  hostname: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TaskList = {
  __typename?: 'TaskList';
  count: Scalars['Int']['output'];
  list: Array<Task>;
};

/** Columns by which TasksList can be ordered */
export enum TaskOrderByColumn {
  CreatedAt = 'CreatedAt',
  Id = 'Id',
  Priority = 'Priority',
  UpdatedAt = 'UpdatedAt'
}

export type TaskOrderByInput = {
  /** Column name */
  column?: TaskOrderByColumn;
  /** Sort direction */
  direction?: SortDirection;
};

/** Priority of a task */
export enum TaskPriority {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

/** Type of resource a task is associated with */
export enum TaskResourceType {
  AdjustmentPaymentEntity = 'AdjustmentPaymentEntity',
  AttributesCorrectionsRequestEntity = 'AttributesCorrectionsRequestEntity',
  CompanyVerificationEntity = 'CompanyVerificationEntity',
  ContributionPaymentEntity = 'ContributionPaymentEntity',
  FeeDistributionEntity = 'FeeDistributionEntity',
  FeePayoutEntity = 'FeePayoutEntity',
  KycRequestEntity = 'KycRequestEntity',
  ManualTaskEntity = 'ManualTaskEntity',
  MarketOrderEntity = 'MarketOrderEntity',
  ProductAssignmentSubscriptionRequestEntity = 'ProductAssignmentSubscriptionRequestEntity',
  WithdrawalPaymentEntity = 'WithdrawalPaymentEntity'
}

export type TaskSnapshot = {
  __typename?: 'TaskSnapshot';
  amount?: Maybe<Scalars['Decimal']['output']>;
  companyName?: Maybe<Scalars['JSONObject']['output']>;
  employeeName?: Maybe<Scalars['JSONObject']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Status of a task */
export enum TaskStatus {
  Closed = 'Closed',
  InReview = 'InReview',
  Open = 'Open'
}

/** Task type definition entity defining type transitions for different resource types */
export type TaskTypeDefinition = {
  __typename?: 'TaskTypeDefinition';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['JSONObject']['output']>;
  descriptionVariableKeys: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  type: TaskResourceType;
  typeDefinition: Scalars['JSONObject']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TenantEntity = {
  __typename?: 'TenantEntity';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ThreadDocument = {
  __typename?: 'ThreadDocument';
  /** Timestamp when the document generation was completed */
  completedAt?: Maybe<Scalars['Date']['output']>;
  /** Name of the document file */
  fileName: Scalars['String']['output'];
  /** Unique identifier of the thread document */
  id: Scalars['ID']['output'];
  /** Download URL of the document */
  url: Scalars['String']['output'];
};

export type ThreadDocumentsList = {
  __typename?: 'ThreadDocumentsList';
  count: Scalars['Int']['output'];
  list: Array<ThreadDocument>;
};

export enum TourType {
  CompanyDashboard = 'CompanyDashboard',
  ManageEmployees = 'ManageEmployees'
}

/** Translation key-value pairs with versioning and activation status per language */
export type Translation = {
  __typename?: 'Translation';
  appLanguage: AppLanguage;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
  version: Scalars['Float']['output'];
};

/** Describes when the associated workflow will start running */
export type TriggerConfig = {
  __typename?: 'TriggerConfig';
  spec: Scalars['String']['output'];
  type: TriggerType;
};

export type TriggerConfigInput = {
  /** Specification string for the trigger configuration */
  spec: Scalars['String']['input'];
  /** Type of trigger for the workflow (e.g. event, schedule) */
  type: TriggerType;
};

/** Determines what the 'spec' property of trigger contains */
export enum TriggerType {
  /** A custom attribute containing cron string, i.e. dynamic. Cron is configured druing product instantiation stage */
  DynamicSchedule = 'DynamicSchedule',
  /** Specific and pre-defined events in our system, e.g. employee_terminated */
  Hook = 'Hook',
  /** A cron string defined globally for workflow, i.e. static. Cron is confgiured during workflow building stage */
  StaticSchedule = 'StaticSchedule'
}

export type UaeCompanyDetails = {
  /** The MOHRE company code */
  companyCode?: InputMaybe<Scalars['String']['input']>;
  /** The MOHRE EIDA of the company */
  eida?: InputMaybe<Scalars['String']['input']>;
  /** The MOHRE employer ID */
  employerId?: InputMaybe<Scalars['String']['input']>;
  /** The MOHRE full details */
  fullDetails?: InputMaybe<Scalars['String']['input']>;
  /** The MOHRE ICP company code */
  icpCompanyCode?: InputMaybe<Scalars['String']['input']>;
  /** The MOHRE owner code */
  ownerCode?: InputMaybe<Scalars['String']['input']>;
  /** The MOHRE UID of the company */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** UAE specific company details */
export type UaeCompanyDetailsInput = {
  __typename?: 'UAECompanyDetailsInput';
  /** The MOHRE company code */
  companyCode?: Maybe<Scalars['String']['output']>;
  /** The MOHRE EIDA of the company */
  eida?: Maybe<Scalars['String']['output']>;
  /** The MOHRE employer ID */
  employerId?: Maybe<Scalars['String']['output']>;
  /** The MOHRE full details */
  fullDetails?: Maybe<Scalars['String']['output']>;
  /** The MOHRE ICP company code */
  icpCompanyCode?: Maybe<Scalars['String']['output']>;
  /** The MOHRE owner code */
  ownerCode?: Maybe<Scalars['String']['output']>;
  /** The MOHRE UID of the company */
  uid?: Maybe<Scalars['String']['output']>;
};

export type UaeEmployee = {
  /** Unique MOHRE person code assigned to the employee. */
  mohrePersonCode?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp of last synchronization with MOHRE for this employee. */
  syncWithMohreAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** UAE employee input */
export type UaeEmployeeInput = {
  __typename?: 'UAEEmployeeInput';
  /** Unique MOHRE person code assigned to the employee. */
  mohrePersonCode?: Maybe<Scalars['String']['output']>;
  /** Timestamp of last synchronization with MOHRE for this employee. */
  syncWithMohreAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UpdateCompanyInput = {
  /** Custom attributes for company (key-value pairs) */
  customAttributes?: InputMaybe<Array<CustomAttributeInput>>;
  /** The name of the company */
  name: Scalars['String']['input'];
  /** The official registered office address */
  registeredAddress: Scalars['String']['input'];
  /** The official registration number */
  registeredNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmployeeBankDetailsInput = {
  /** Name on the bank account */
  accountName: Scalars['String']['input'];
  /** Address of the bank branch */
  branchAddress: Scalars['String']['input'];
  /** Name of the bank branch */
  branchName: Scalars['String']['input'];
  /** International Bank Account Number */
  iban: Scalars['String']['input'];
  /** SWIFT/BIC code of the bank */
  swiftCode: Scalars['String']['input'];
};

export type UpdateFeeAssignmentsInput = {
  /** Whether to add or remove assignments */
  action: FeeAssignmentAction;
  /** If true with Add action, assigns fee environment-wide. Not valid with Remove action. */
  applyAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDs of entities to add or remove (required when applyAll is false). */
  assignableIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Type of entity to assign/unassign (required when applyAll is false). */
  assignableType?: InputMaybe<FeeAssignableType>;
  /** ID of the fee to update */
  feeId: Scalars['String']['input'];
};

export type UpdateFeeInput = {
  /** Updated description of the fee */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the fee to update */
  feeId: Scalars['String']['input'];
  /** Updated name of the fee */
  name: Scalars['String']['input'];
};

export type UpdateMohreCompanyInput = {
  customAttributes?: InputMaybe<Array<CustomAttributeInput>>;
};

export type UpdateRoleInput = {
  /** Updated description explaining the purpose and responsibilities of this role */
  description: Scalars['String']['input'];
  /** The updated name of the role */
  name: Scalars['String']['input'];
  /** Updated list of permissions granted to users assigned this role */
  permissions: Array<PermissionEnum>;
  /** Optional updated list of company IDs to which this role is restricted */
  restrictedCompanyIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateTaskDescriptionInput = {
  ar: Scalars['String']['input'];
  en: Scalars['String']['input'];
};

export type UpdateTaskTypeDefinitionInput = {
  escalation: EscalationInput;
  inReviewRoles: Array<Scalars['String']['input']>;
  openRoles: Array<Scalars['String']['input']>;
  readonlyRoles: Array<Scalars['String']['input']>;
};

export type UpdateThreadInput = {
  /** Optional new description for the thread (maximum 500 characters) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier of the thread to update */
  id: Scalars['ID']['input'];
  /** Optional flag to mark the thread as active or inactive */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional flag to mark the thread as starred or unstarred */
  isStarred?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional new title for the thread (maximum 200 characters) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTranslationsInput = {
  app: WebApps;
  language: SupportedLanguages;
  newTranslations: Array<NewTranslationInput>;
  revertedTranslations: Array<RevertTranslationInput>;
};

export type UpdateUserTourInput = {
  /** Timestamp of the user's last interaction with the tour. */
  lastClickedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Current step of the user tour, if set. */
  step?: InputMaybe<UserTourStep>;
  /** Type of user tour being updated. */
  type: TourType;
};

export type UpsertCustomAttributeInput = {
  category: FormCategory;
  data?: InputMaybe<Scalars['JSONObject']['input']>;
  entity: Scalars['String']['input'];
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['JSONObject']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Scalars['JSONObject']['input']>;
  order: Scalars['Float']['input'];
  placeholder?: InputMaybe<Scalars['JSONObject']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['JSONObject']['input']>;
  type: CustomAttributeType;
  validator?: InputMaybe<CustomAttributeValidator>;
};

export type UpsertInvoicePartyInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  trn?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<InvoicePartyKind>;
};

export type UpsertMarketOrderAdjustmentInput = {
  amount: Scalars['Decimal']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  marketOrderId: Scalars['String']['input'];
  productAssignmentId: Scalars['String']['input'];
  reason: AdjustmentReasonInput;
};

export type UpsertPaymentAdjustmentInput = {
  amount: Scalars['Decimal']['input'];
  categoryId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['String']['input'];
  productAssignmentId: Scalars['String']['input'];
  reason: AdjustmentReasonInput;
};

export type UpsertPaymentCategoryInput = {
  /** Whether this category is available as an option when adjusting payment records */
  adjustable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional ID of the payment category (for updates). */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Unique name identifier for the payment category (e.g. SALARY, AUM_FEE) */
  name: Scalars['String']['input'];
  /** Localised title of the payment category keyed by language code */
  title: Scalars['JSON']['input'];
};

export type UpsertProductInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  /** Description of the product */
  description?: Scalars['String']['input'];
  /** Optional ID of the product (for updates) */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the product is active */
  isActive?: Scalars['Boolean']['input'];
  /** Name of the product */
  name: Scalars['String']['input'];
};

export type UpsertProductInstanceInput = {
  /** Custom attribute values for the product instance */
  customAttributeValues?: Array<CustomAttributeInput>;
  /** Optional ID of the product instance (for updates) */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the product instance is active */
  isActive?: Scalars['Boolean']['input'];
  /** Name of the product instance */
  name: Scalars['String']['input'];
};

export type UpsertProductInstanceResult = {
  __typename?: 'UpsertProductInstanceResult';
  productInstance: ProductInstance;
};

export type UpsertSamlConfigurationInput = {
  /** Identity provider URL */
  identityProviderUrl?: InputMaybe<Scalars['String']['input']>;
  /** Metadata source type */
  metadataSourceType?: InputMaybe<Scalars['String']['input']>;
  /** Verification domain */
  verificationDomain?: InputMaybe<Scalars['String']['input']>;
};

/** Platform user managing authentication, profile, role-based permissions, and employment relationships across companies */
export type User = {
  __typename?: 'User';
  adminEventLogs: Array<EventLog>;
  adminInvitations: Array<UserInvitation>;
  /** Resolves aggregate balance statistics across all of the user's product assignments: invested amount, contribution split, and overall return. */
  balanceStats: BalanceStats;
  bankAccounts: Array<UserBankAccount>;
  blockedAt?: Maybe<Scalars['DateTime']['output']>;
  citizenships?: Maybe<Scalars['String']['output']>;
  companyVerifications: Array<CrmCompanyVerification>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  /** Email changes pending address verification */
  emailVerification?: Maybe<EmailVerificationEntity>;
  emailVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  employeeInvitations: Array<EmployeeInvitation>;
  employments: Array<CrmEmployee>;
  fatcaDetails?: Maybe<Scalars['JSON']['output']>;
  /** Returns the most relevant employment for the given company */
  findEmployment?: Maybe<CrmEmployee>;
  goals: Array<UserGoal>;
  holdingSnapshot: HoldingSnapshot;
  id: Scalars['ID']['output'];
  idHash: Scalars['String']['output'];
  isMfaEnabled: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  kycRequest?: Maybe<KycRequest>;
  kycRequests: Array<KycRequest>;
  kycRequestsReviewed: Array<KycRequest>;
  /** Returns the user's most recent session */
  lastSession?: Maybe<UserSession>;
  /** Fetches or lazily resolves the country and city for the user's most recent session. */
  location?: Maybe<LocationType>;
  /** Nominated beneficiaries in the event of user's passing */
  nominees: Array<Nominee>;
  notificationCenterOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  onboardingProgress: Array<Progress>;
  passwordUpdatedAt: Scalars['DateTime']['output'];
  paymentLedger: PaymentLedger;
  profile?: Maybe<Profile>;
  sessions: Array<UserSession>;
  /** Number of unread notifications that have not yet been seen in the notification center */
  unseenNotificationsCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userEventLogs: Array<EventLog>;
  userRoles: Array<UserRole>;
  userTours?: Maybe<Array<UserTour>>;
};


/** Platform user managing authentication, profile, role-based permissions, and employment relationships across companies */
export type UserFindEmploymentArgs = {
  employmentId?: InputMaybe<Scalars['ID']['input']>;
};


/** Platform user managing authentication, profile, role-based permissions, and employment relationships across companies */
export type UserPaymentLedgerArgs = {
  direction?: InputMaybe<PaymentLedgerDirection>;
  excludeCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortKey?: InputMaybe<PaymentLedgerSortKey>;
  sortOrder?: InputMaybe<SortDirection>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type UserAuthResponse = {
  __typename?: 'UserAuthResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
  isMfaRequired: Scalars['Boolean']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

/** User bank account details storing IBAN with optional nickname */
export type UserBankAccount = {
  __typename?: 'UserBankAccount';
  /** International bank account number of the user */
  iban: Scalars['String']['output'];
  /** Unique identifier of the bank account */
  id: Scalars['ID']['output'];
  /** Optional friendly name for the bank account */
  nickName?: Maybe<Scalars['String']['output']>;
  /** Identifier of the user owning the bank account */
  userId: Scalars['String']['output'];
};

export enum UserClientType {
  AdminWebApp = 'AdminWebApp',
  EmployeeMobileApp = 'EmployeeMobileApp'
}

/** Event log for employee app notification view */
export type UserEventLog = {
  __typename?: 'UserEventLog';
  /** Main content or message of the event log */
  content: Scalars['String']['output'];
  /** Timestamp when the event was created */
  createdAt: Scalars['DateTime']['output'];
  /** Type of the event (e.g. creation, update, notification) */
  eventType: EventType;
  /** Unique identifier for the user event log entry */
  id: Scalars['ID']['output'];
  /** Log type for the event (e.g. info, warning, error) */
  logType: EventLogType;
  /** ID of the owner entity related to the event */
  ownerId: Scalars['String']['output'];
  /** Type of the owner entity related to the event (e.g. employee, company) */
  ownerType: Scalars['String']['output'];
  /** Title of the event log entry */
  title: Scalars['String']['output'];
};

/** User financial goal with target amount, timeframe, and tracking for retirement or savings planning */
export type UserGoal = {
  __typename?: 'UserGoal';
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** BlurHash string for thumbnail placeholder */
  imgBlurHash?: Maybe<Scalars['String']['output']>;
  /** Average colour of the image for placeholder use */
  imgColor?: Maybe<Scalars['String']['output']>;
  /** Base image URL from unsplash; dimensions can be specified using the imgix API params */
  imgUrl: Scalars['String']['output'];
  kind: UserGoalKind;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type UserGoalInput = {
  amount: Scalars['Decimal']['input'];
  imgBlurHash?: InputMaybe<Scalars['String']['input']>;
  imgColor?: InputMaybe<Scalars['String']['input']>;
  imgUrl: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum UserGoalKind {
  Future = 'future',
  Today = 'today',
  Tomorrow = 'tomorrow'
}

/** Admin user invitation with email, roles, and company association */
export type UserInvitation = {
  __typename?: 'UserInvitation';
  company?: Maybe<CrmCompany>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inviterUser: User;
  inviterUserId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Resolves the list of roles associated with a user invitation. */
  roles: Array<Role>;
};

export type UserInvitationList = {
  __typename?: 'UserInvitationList';
  count: Scalars['Int']['output'];
  list: Array<UserInvitation>;
};

/** Columns by which UserInvitationsListsList can be ordered */
export enum UserInvitationsListOrderByColumn {
  CreatedAt = 'CreatedAt',
  Email = 'Email',
  Id = 'Id',
  Name = 'Name',
  UpdatedAt = 'UpdatedAt'
}

export type UserInvitationsListOrderByInput = {
  /** Column name */
  column?: UserInvitationsListOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

/** Data for a single user to be invited */
export type UserInviteData = {
  __typename?: 'UserInviteData';
  /** Email address of the user to invite */
  email: Scalars['String']['output'];
};

export type UserInviteDataInput = {
  /** Email address of the user to invite */
  email: Scalars['String']['input'];
};

export type UserMessageMetadata = {
  __typename?: 'UserMessageMetadata';
  /** Assistant mode: GENERAL for chat only, AUREM_AGENT for database operations */
  mode: AssistantModeEnum;
};

/** User role assignment per company with assignment tracking and history */
export type UserRole = {
  __typename?: 'UserRole';
  assignedAt?: Maybe<Scalars['Date']['output']>;
  assignedBy?: Maybe<User>;
  assignedById?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CrmCompany>;
  companyId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  oldRole: Scalars['String']['output'];
  role: Role;
  user: User;
};

export type UserSamlRedirectResponse = {
  __typename?: 'UserSamlRedirectResponse';
  redirectUrl: Scalars['String']['output'];
};

/** User authentication session tracking login time, client type, IP address, and push notification tokens */
export type UserSession = {
  __typename?: 'UserSession';
  city?: Maybe<Scalars['String']['output']>;
  clientType?: Maybe<UserClientType>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deviceInfo?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipAddress: Scalars['String']['output'];
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** User onboarding tour progress tracking completion status per feature */
export type UserTour = {
  __typename?: 'UserTour';
  /** Unique identifier of the user tour */
  id: Scalars['ID']['output'];
  /** Timestamp when user last interacted with the tour */
  lastClickedAt?: Maybe<Scalars['Date']['output']>;
  /** Current completion status of the tour */
  step: UserTourStep;
  /** Type of feature tour being tracked */
  type: TourType;
  /** User taking the feature tour */
  user: User;
  /** Identifier of the user taking the tour */
  userId: Scalars['String']['output'];
};

export enum UserTourStep {
  Finished = 'Finished',
  NotStarted = 'NotStarted',
  Started = 'Started'
}

/** Columns by which UsersListsList can be ordered */
export enum UsersListOrderByColumn {
  CreatedAt = 'CreatedAt',
  Email = 'Email',
  Id = 'Id',
  Name = 'Name',
  UpdatedAt = 'UpdatedAt'
}

export type UsersListOrderByInput = {
  /** Column name */
  column?: UsersListOrderByColumn;
  /** Direction 'ASC' or 'DESC' */
  direction?: SortDirection;
};

/** Time-limited verification code for user actions like email or phone confirmation */
export type VerificationRequest = {
  __typename?: 'VerificationRequest';
  /** Type of action requiring verification */
  actionType: VerificationRequestActionType;
  /** Timestamp when the verification request was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier of the verification request */
  id: Scalars['ID']['output'];
  /** Identifier of the user requesting verification */
  userId: Scalars['String']['output'];
  /** Timestamp when verification code expires */
  validTill: Scalars['DateTime']['output'];
};

export enum VerificationRequestActionType {
  BankAccountAdd = 'BankAccountAdd',
  BankAccountUpdate = 'BankAccountUpdate',
  CreateNominee = 'CreateNominee',
  DeleteNominee = 'DeleteNominee',
  EditNominee = 'EditNominee',
  PensionContributionEdit = 'PensionContributionEdit',
  SetFund = 'SetFund',
  SetSalaryContribution = 'SetSalaryContribution',
  Withdraw = 'Withdraw',
  WithdrawCashAmount = 'WithdrawCashAmount'
}

export enum WebApps {
  Admin = 'admin',
  Email = 'email',
  Employee = 'employee'
}

/** Action to withdraw, including enabled state and pending items. */
export type WithdrawAction = {
  __typename?: 'WithdrawAction';
  /** Whether the withdraw action is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Ongoing fund switch blocking withdrawals, or null when none is in progress. */
  pendingFundSwitch?: Maybe<WithdrawActionPendingFundSwitch>;
  /** List of pending withdraw items for the action. */
  pendingItems: Array<WithdrawActionPendingItem>;
};

/** Ongoing fund switch (manual or termination-driven) that blocks withdrawals until it completes. */
export type WithdrawActionPendingFundSwitch = {
  __typename?: 'WithdrawActionPendingFundSwitch';
  /** Timestamp when the fund switch workflow started. */
  createdAt: Scalars['DateTime']['output'];
  /** Run ID of the fund switch workflow. */
  runId: Scalars['String']['output'];
};

/** Pending item for a withdraw action, including workflow event and cash amount. */
export type WithdrawActionPendingItem = {
  __typename?: 'WithdrawActionPendingItem';
  /** Cash amount for the pending withdraw item. */
  cashAmount: Scalars['Decimal']['output'];
  /** Timestamp when the pending withdraw item was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Run ID of the withdraw workflow. */
  runId: Scalars['String']['output'];
};

export type WithdrawInput = {
  /** Amount of cash to withdraw */
  cashAmount: Scalars['Decimal']['input'];
  /** ID of the product assignment to withdraw from */
  productAssignmentId: Scalars['String']['input'];
};

/** A git-managed workflow config with full node/layout detail for the builder */
export type WorkflowConfig = {
  __typename?: 'WorkflowConfig';
  /** Unique config key for the workflow */
  key: WorkflowKey;
  /** ReactFlow layout data for UI rendering */
  layout?: Maybe<Scalars['JSONObject']['output']>;
  /** Display name of the workflow */
  name: Scalars['String']['output'];
  /** Execution nodes of the workflow */
  nodes: Array<WorkflowNode>;
  /** Whether the config workflow is Draft or Active */
  status: WorkflowDefinitionStatus;
  /** When the workflow runs (hook or schedule) */
  trigger: TriggerConfig;
  /** Whether this is a product or fee workflow */
  workflowType: WorkflowType;
};

/** A git-managed workflow config, summarized for list views */
export type WorkflowConfigSummary = {
  __typename?: 'WorkflowConfigSummary';
  /** Unique config key for the workflow */
  key: WorkflowKey;
  /** Display name of the workflow */
  name: Scalars['String']['output'];
  /** Whether the config workflow is Draft or Active */
  status: WorkflowDefinitionStatus;
  /** When the workflow runs (hook or schedule) */
  trigger: TriggerConfig;
  /** Whether this is a product or fee workflow */
  workflowType: WorkflowType;
};

/** Workflow template defining versioned automation logic with draft or active status */
export type WorkflowDefinition = {
  __typename?: 'WorkflowDefinition';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  createdByUser?: Maybe<User>;
  currentVersion?: Maybe<WorkflowVersion>;
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: WorkflowDefinitionStatus;
  updatedAt: Scalars['DateTime']['output'];
  versions: Array<WorkflowVersion>;
  /** Total number of saved versions for this workflow */
  versionsCount: Scalars['Int']['output'];
  workflowOwner?: Maybe<WorkflowOwner>;
  /** The type of workflow (Product, Fee, etc.) */
  workflowType: WorkflowType;
};

export enum WorkflowDefinitionStatus {
  Active = 'Active',
  Draft = 'Draft'
}

/** Individual event within a workflow run capturing node execution with sequence, type, and patch data */
export type WorkflowEvent = {
  __typename?: 'WorkflowEvent';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  nodeId?: Maybe<Scalars['String']['output']>;
  patch?: Maybe<Scalars['JSONObject']['output']>;
  runId: Scalars['ID']['output'];
  seq: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  workflowRun: WorkflowRun;
};

export type WorkflowHookInput = {
  citizenshipBlocked?: InputMaybe<EmployeeTerminationInput>;
  employeeFundSwitched?: InputMaybe<SetFundInput>;
  employeeTerminated?: InputMaybe<EmployeeTerminationInput>;
  withdrawalRequested?: InputMaybe<WithdrawInput>;
};

export enum WorkflowKey {
  AumFeeCollection = 'AumFeeCollection',
  AumFeeComputation = 'AumFeeComputation',
  EmployeeBasicFundSwitch = 'EmployeeBasicFundSwitch',
  EmployeeCitizenshipBlocked = 'EmployeeCitizenshipBlocked',
  EmployeeFundSwitch = 'EmployeeFundSwitch',
  EmployeeStatement = 'EmployeeStatement',
  EmployeeTerminationTenureGte1Year = 'EmployeeTerminationTenureGte1Year',
  EmployeeTerminationTenureLt1Year = 'EmployeeTerminationTenureLt1Year',
  EmployeeVoluntaryFundSwitch = 'EmployeeVoluntaryFundSwitch',
  ParticipationFee = 'ParticipationFee',
  PayrollDeductionForSavings = 'PayrollDeductionForSavings',
  UpcomingEosbPaymentReport = 'UpcomingEosbPaymentReport',
  Withdrawal = 'Withdrawal'
}

export type WorkflowNode = {
  __typename?: 'WorkflowNode';
  config: Scalars['JSONObject']['output'];
  deps: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type WorkflowNodeInput = {
  /** Node configuration and input parameters */
  config: Scalars['JSONObject']['input'];
  /** Array of node IDs that must complete before this node */
  deps: Array<Scalars['String']['input']>;
  /** Node ID with format <type>:<counter>, e.g., 'query:1' */
  id: Scalars['String']['input'];
};

export type WorkflowNodeType = {
  __typename?: 'WorkflowNodeType';
  /** Whether this node type generates and caches JavaScript code at run time (the frontend exposes an editable cached-code field for these nodes) */
  codegen: Scalars['Boolean']['output'];
  /** JSON schema for node configuration validation */
  configSchema: Scalars['JSONObject']['output'];
  /** The unique type identifier for this node */
  type: Scalars['String']['output'];
};

/** Links a workflow to its owning entity (Fee, Product, etc.) */
export type WorkflowOwner = {
  __typename?: 'WorkflowOwner';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workflow?: Maybe<WorkflowDefinition>;
  /** The DB-stored workflow owned by this entity (null for git-managed config workflows) */
  workflowDefinitionId?: Maybe<Scalars['ID']['output']>;
  /** The git-managed workflow config key owned by this entity (null for DB-stored workflows) */
  workflowKey?: Maybe<WorkflowKey>;
  /** The ID of the entity that owns this workflow */
  workflowableId: Scalars['ID']['output'];
  /** The type of entity that owns this workflow */
  workflowableType: WorkflowableType;
};

/** Execution instance of a workflow version tracking status, temporal workflow ID, and events */
export type WorkflowRun = {
  __typename?: 'WorkflowRun';
  barrierWaiters: Array<InternalWorkflowBarrierWaiter>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  /** Input data provided to the triggered workflow run */
  input: Scalars['JSON']['output'];
  lastEventSeq: Scalars['Int']['output'];
  lastNodeId?: Maybe<Scalars['String']['output']>;
  status: WorkflowRunStatus;
  subject?: Maybe<WorkflowRunSubject>;
  workflowEvents: Array<WorkflowEvent>;
  /** Git-managed workflow config key this run executes (set instead of workflowVersionId when sourced from WorkflowConfigService) */
  workflowKey?: Maybe<WorkflowKey>;
  workflowName?: Maybe<Scalars['String']['output']>;
  workflowVersion?: Maybe<WorkflowVersion>;
  workflowVersionId?: Maybe<Scalars['ID']['output']>;
};

export enum WorkflowRunStatus {
  Completed = 'Completed',
  Created = 'Created',
  Exited = 'Exited',
  Failed = 'Failed',
  Pending = 'Pending',
  Running = 'Running'
}

/** The entity a workflow run acts on, resolved from the run input. Hook-triggered runs are scoped to an employee, fee workflows to a company, and the rest to a product instance. */
export type WorkflowRunSubject = {
  __typename?: 'WorkflowRunSubject';
  /** The company the subject belongs to, used to build a link to the subject. Equals `id` for a company subject. */
  companyId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: WorkflowRunSubjectType;
};

/** The kind of entity a workflow run is scoped to */
export enum WorkflowRunSubjectType {
  Company = 'Company',
  Employee = 'Employee',
  ProductInstance = 'ProductInstance'
}

/** The type of workflow */
export enum WorkflowType {
  Fee = 'Fee',
  Product = 'Product'
}

export type WorkflowVersion = {
  __typename?: 'WorkflowVersion';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  createdByUser?: Maybe<User>;
  diff?: Maybe<Scalars['String']['output']>;
  diffSummary?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** All ReactFlow data packed as JSON object for rendering workflow graph on UI */
  layout: Scalars['JSONObject']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nodes: Array<WorkflowNode>;
  trigger: TriggerConfig;
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
  workflowDefinition: WorkflowDefinition;
  workflowDefinitionId: Scalars['ID']['output'];
  workflowRuns: Array<WorkflowRun>;
};

/** The type of entity that owns a workflow (Fee, Product, etc.) */
export enum WorkflowableType {
  Fee = 'Fee',
  Product = 'Product'
}

export type GetAuthenticationPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthenticationPolicyQuery = { __typename?: 'Query', findEnvironmentFeatures: { __typename?: 'FeaturesConfig', google_sign_in_feature?: boolean | null } };

export type UpdateAuthenticationPolicyMutationVariables = Exact<{
  features: FeaturesConfigInput;
}>;


export type UpdateAuthenticationPolicyMutation = { __typename?: 'Mutation', upsertEnvironmentFeatures: { __typename?: 'FeaturesConfig', google_sign_in_feature?: boolean | null } };

export type EnableMfaMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type EnableMfaMutation = { __typename?: 'Mutation', enableMfa: { __typename?: 'User', id: string } };

export type DisableMfaMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type DisableMfaMutation = { __typename?: 'Mutation', disableMfa: { __typename?: 'User', id: string } };

export type MarkPageAsCompletedMutationVariables = Exact<{
  page: ProgressPageName;
  progress: Scalars['Int']['input'];
}>;


export type MarkPageAsCompletedMutation = { __typename?: 'Mutation', markPageAsCompleted: { __typename?: 'Progress', id: string, progress: number } };

export type OnboardingStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingStatusQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, onboardingProgress: Array<{ __typename?: 'Progress', id: string, page: ProgressPageName, progress: number, updatedAt: any }> } };

export type GetPasswordPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPasswordPolicyQuery = { __typename?: 'Query', getPasswordPolicy: { __typename?: 'PasswordPolicy', requireUppercase: boolean, requireLowercase: boolean, requireNumber: boolean, requireSymbol: boolean, minLength: number, rejectCommon: boolean, forceResetEnabled: boolean, forceResetDays?: number | null, disallowPreviousPasswords: boolean } };

export type UpdatePasswordPolicyMutationVariables = Exact<{
  input: PasswordPolicyInput;
}>;


export type UpdatePasswordPolicyMutation = { __typename?: 'Mutation', updatePasswordPolicy: { __typename?: 'PasswordPolicy', id: string } };

export type EnvironmentQueryVariables = Exact<{ [key: string]: never; }>;


export type EnvironmentQuery = { __typename?: 'Query', findEnvironmentConfig: { __typename?: 'EnvironmentConfg', id?: string | null, name: string, nameAr?: string | null, logoUrlRegular?: string | null, logoUrlInverse?: string | null, logoUrlSymbol?: string | null, themeName?: EnvironmentTheme | null, privacyNoticeEn?: string | null, privacyNoticeAr?: string | null, feelingLostUrlEn?: string | null, feelingLostUrlAr?: string | null, firstLogin: boolean, blockedCitizenships: Array<string> } };


export const GetAuthenticationPolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAuthenticationPolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findEnvironmentFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"google_sign_in_feature"}}]}}]}}]} as unknown as DocumentNode<GetAuthenticationPolicyQuery, GetAuthenticationPolicyQueryVariables>;
export const UpdateAuthenticationPolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAuthenticationPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"features"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeaturesConfigInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertEnvironmentFeatures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"features"},"value":{"kind":"Variable","name":{"kind":"Name","value":"features"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"google_sign_in_feature"}}]}}]}}]} as unknown as DocumentNode<UpdateAuthenticationPolicyMutation, UpdateAuthenticationPolicyMutationVariables>;
export const EnableMfaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnableMfa"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enableMfa"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<EnableMfaMutation, EnableMfaMutationVariables>;
export const DisableMfaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisableMfa"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disableMfa"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DisableMfaMutation, DisableMfaMutationVariables>;
export const MarkPageAsCompletedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkPageAsCompleted"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgressPageName"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"progress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markPageAsCompleted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"progress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"progress"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}}]}}]} as unknown as DocumentNode<MarkPageAsCompletedMutation, MarkPageAsCompletedMutationVariables>;
export const OnboardingStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OnboardingStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"onboardingProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<OnboardingStatusQuery, OnboardingStatusQueryVariables>;
export const GetPasswordPolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPasswordPolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPasswordPolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requireUppercase"}},{"kind":"Field","name":{"kind":"Name","value":"requireLowercase"}},{"kind":"Field","name":{"kind":"Name","value":"requireNumber"}},{"kind":"Field","name":{"kind":"Name","value":"requireSymbol"}},{"kind":"Field","name":{"kind":"Name","value":"minLength"}},{"kind":"Field","name":{"kind":"Name","value":"rejectCommon"}},{"kind":"Field","name":{"kind":"Name","value":"forceResetEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"forceResetDays"}},{"kind":"Field","name":{"kind":"Name","value":"disallowPreviousPasswords"}}]}}]}}]} as unknown as DocumentNode<GetPasswordPolicyQuery, GetPasswordPolicyQueryVariables>;
export const UpdatePasswordPolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePasswordPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PasswordPolicyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePasswordPolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdatePasswordPolicyMutation, UpdatePasswordPolicyMutationVariables>;
export const EnvironmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Environment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findEnvironmentConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrlRegular"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrlInverse"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrlSymbol"}},{"kind":"Field","name":{"kind":"Name","value":"themeName"}},{"kind":"Field","name":{"kind":"Name","value":"privacyNoticeEn"}},{"kind":"Field","name":{"kind":"Name","value":"privacyNoticeAr"}},{"kind":"Field","name":{"kind":"Name","value":"feelingLostUrlEn"}},{"kind":"Field","name":{"kind":"Name","value":"feelingLostUrlAr"}},{"kind":"Field","name":{"kind":"Name","value":"firstLogin"}},{"kind":"Field","name":{"kind":"Name","value":"blockedCitizenships"}}]}}]}}]} as unknown as DocumentNode<EnvironmentQuery, EnvironmentQueryVariables>;